<template>
  <div class="incall-dashboard">
    <div class="search-header" :class="{ 'search-header--collapsed': isSearchCollapsed }">
      <div v-if="!selectedSearchType" class="search-type-selection">
        <h2 style="text-align: center; margin-bottom: 2rem; font-size: 1.8rem; font-weight: 700; color: #333; text-transform: uppercase; letter-spacing: 1px;">
          Seleziona Tipo di Ricerca
        </h2>
        <div class="search-type-buttons">
          <button @click="selectSearchType('cliente')" class="search-type-btn cliente-btn">
            <i class="pi pi-user" style="font-size: 2rem; margin-bottom: 1rem;"></i>
            <span>Cliente</span>
            <small>Ricerca per PDP, Code Cliente, Cod Fiscale, N Fattura</small>
          </button>
          <button @click="selectSearchType('rappresentante')" class="search-type-btn rappresentante-btn">
            <i class="pi pi-users" style="font-size: 2rem; margin-bottom: 1rem;"></i>
            <span>Rappresentante</span>
            <small>Ricerca per Codice Fiscale, Nome/Ragione Sociale</small>
          </button>
        </div>
      </div>

      <div v-if="selectedSearchType" class="search-title-container">
        <div class="search-title-left">
          <button @click="clearAllSearches" class="back-button" type="button" title="Torna alla selezione">
            <i class="pi pi-arrow-left"></i>
          </button>
          <div class="search-title-text">
            <h2>
              {{ selectedSearchType === 'cliente' ? 'Ricerca Cliente' : 'Ricerca Rappresentante' }}
            </h2>
            <p v-if="isSearchCollapsed && activeSearchSummary" class="search-collapsed-summary">
              {{ activeSearchSummary }}
            </p>
          </div>
        </div>

        <button
          v-if="selectedUser.id"
          type="button"
          class="search-collapse-btn"
          :title="searchCollapsed ? 'Espandi ricerca' : 'Comprimi ricerca'"
          @click="toggleSearchCollapsed"
        >
          <i :class="searchCollapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up'"></i>
          <span>{{ searchCollapsed ? 'Espandi ricerca' : 'Comprimi ricerca' }}</span>
        </button>
      </div>

      <div v-if="selectedSearchType && !isSearchCollapsed" class="search-bars-container">
        <div class="search-container search-container--with-suggestions" v-show="selectedSearchType === 'cliente' && showPdpSearch">
          <div class="search-wrapper">
            <i class="pi pi-search search-icon"></i>
            <input type="text" v-model="searchQueries.pdp" placeholder="Cerca per PDP..." class="search-input"
              @input="handleSearch('pdp')" @blur="closeSuggestions('pdp')" />
            <button v-if="searchQueries.pdp" @click="clearSearch('pdp')" class="clear-search">
              <i class="pi pi-times"></i>
            </button>
            <div v-if="loadingSuggestions && activeSuggestionSearchType === 'pdp'" class="loading-suggestions">
              <i class="pi pi-spin pi-spinner"></i>
            </div>
          </div>
          <div class="search-label">PDP</div>
          <div v-if="showSuggestionsFor('pdp')" class="suggestions-dropdown">
            <div
              v-for="suggestion in searchSuggestions"
              :key="`pdp-${suggestion.id}`"
              @mousedown="selectSearchSuggestion(suggestion, 'pdp')"
              class="suggestion-item"
            >
              <div class="suggestion-primary">{{ getSuggestionPrimaryLabel(suggestion.label) }}</div>
              <div v-if="getSuggestionSecondaryLabel(suggestion.label)" class="suggestion-secondary">
                {{ getSuggestionSecondaryLabel(suggestion.label) }}
              </div>
            </div>
            <div v-if="searchSuggestions.length === 0 && searchQueries.pdp.length >= 2 && !loadingSuggestions" class="suggestion-empty">
              Nessun risultato trovato per "{{ searchQueries.pdp }}"
            </div>
          </div>
        </div>

        <div class="search-container search-container--with-suggestions" v-show="selectedSearchType === 'cliente' && showCodiceClienteSearch">
          <div class="search-wrapper">
            <i class="pi pi-search search-icon"></i>
            <input type="text" v-model="searchQueries.codiceCliente" placeholder="Cerca per Codice Cliente..."
              class="search-input" @input="handleSearch('codiceCliente')" @blur="closeSuggestions('codiceCliente')" />
            <button v-if="searchQueries.codiceCliente" @click="clearSearch('codiceCliente')" class="clear-search">
              <i class="pi pi-times"></i>
            </button>
            <div v-if="loadingSuggestions && activeSuggestionSearchType === 'codiceCliente'" class="loading-suggestions">
              <i class="pi pi-spin pi-spinner"></i>
            </div>
          </div>
          <div class="search-label">CODICE CLIENTE</div>
          <div v-if="showSuggestionsFor('codiceCliente')" class="suggestions-dropdown">
            <div
              v-for="suggestion in searchSuggestions"
              :key="`codiceCliente-${suggestion.id}`"
              @mousedown="selectSearchSuggestion(suggestion, 'codiceCliente')"
              class="suggestion-item"
            >
              <div class="suggestion-primary">{{ getSuggestionPrimaryLabel(suggestion.label) }}</div>
              <div v-if="getSuggestionSecondaryLabel(suggestion.label)" class="suggestion-secondary">
                {{ getSuggestionSecondaryLabel(suggestion.label) }}
              </div>
            </div>
            <div v-if="searchSuggestions.length === 0 && searchQueries.codiceCliente.length >= 2 && !loadingSuggestions" class="suggestion-empty">
              Nessun risultato trovato per "{{ searchQueries.codiceCliente }}"
            </div>
          </div>
        </div>

        <div class="search-container search-container--with-suggestions" v-show="selectedSearchType === 'cliente' && showNumeroFatturaSearch">
          <div class="search-wrapper">
            <i class="pi pi-search search-icon"></i>
            <input type="text" v-model="searchQueries.numeroFattura" placeholder="Cerca per Numero Fattura..."
              class="search-input" @input="handleSearch('numeroFattura')" @blur="closeSuggestions('numeroFattura')" />
            <button v-if="searchQueries.numeroFattura" @click="clearSearch('numeroFattura')" class="clear-search">
              <i class="pi pi-times"></i>
            </button>
            <div v-if="loadingSuggestions && activeSuggestionSearchType === 'numeroFattura'" class="loading-suggestions">
              <i class="pi pi-spin pi-spinner"></i>
            </div>
          </div>
          <div class="search-label">NUMERO FATTURA</div>
          <div v-if="showSuggestionsFor('numeroFattura')" class="suggestions-dropdown">
            <div
              v-for="suggestion in searchSuggestions"
              :key="`numeroFattura-${suggestion.id}`"
              @mousedown="selectSearchSuggestion(suggestion, 'numeroFattura')"
              class="suggestion-item"
            >
              <div class="suggestion-primary">{{ getSuggestionPrimaryLabel(suggestion.label) }}</div>
              <div v-if="getSuggestionSecondaryLabel(suggestion.label)" class="suggestion-secondary">
                {{ getSuggestionSecondaryLabel(suggestion.label) }}
              </div>
            </div>
            <div v-if="searchSuggestions.length === 0 && searchQueries.numeroFattura.length >= 2 && !loadingSuggestions" class="suggestion-empty">
              Nessun risultato trovato per "{{ searchQueries.numeroFattura }}"
            </div>
          </div>
        </div>

        <div class="search-container search-container--with-suggestions" v-show="showCodiceFiscaleSearch">
          <div class="search-wrapper">
            <i class="pi pi-search search-icon"></i>
            <input type="text" v-model="searchQueries.codiceFiscale" placeholder="Cerca per Codice Fiscale..."
              class="search-input" @input="handleSearch('codiceFiscale')" @blur="closeSuggestions('codiceFiscale')" />
            <button v-if="searchQueries.codiceFiscale" @click="clearSearch('codiceFiscale')" class="clear-search">
              <i class="pi pi-times"></i>
            </button>
            <div v-if="loadingSuggestions && activeSuggestionSearchType === 'codiceFiscale'" class="loading-suggestions">
              <i class="pi pi-spin pi-spinner"></i>
            </div>
          </div>
          <div class="search-label">CODICE FISCALE</div>
          <div v-if="showSuggestionsFor('codiceFiscale')" class="suggestions-dropdown">
            <div
              v-for="suggestion in searchSuggestions"
              :key="`codiceFiscale-${suggestion.id}`"
              @mousedown="selectSearchSuggestion(suggestion, 'codiceFiscale')"
              class="suggestion-item"
            >
              <div class="suggestion-primary">{{ getSuggestionPrimaryLabel(suggestion.label) }}</div>
              <div v-if="getSuggestionSecondaryLabel(suggestion.label)" class="suggestion-secondary">
                {{ getSuggestionSecondaryLabel(suggestion.label) }}
              </div>
            </div>
            <div v-if="searchSuggestions.length === 0 && searchQueries.codiceFiscale.length >= 2 && !loadingSuggestions" class="suggestion-empty">
              Nessun risultato trovato per "{{ searchQueries.codiceFiscale }}"
            </div>
          </div>
        </div>

        <div class="search-container search-container--with-suggestions" v-show="showNomeSearch">
          <div class="search-wrapper">
            <i class="pi pi-search search-icon"></i>
            <input type="text" v-model="searchQueries.nome" placeholder="Cerca per Nome/Ragione Sociale..."
              class="search-input" @input="handleSearch('nome')" @blur="closeSuggestions('nome')" />
            <button v-if="searchQueries.nome" @click="clearSearch('nome')" class="clear-search">
              <i class="pi pi-times"></i>
            </button>
            <div v-if="loadingSuggestions && activeSuggestionSearchType === 'nome'" class="loading-suggestions">
              <i class="pi pi-spin pi-spinner"></i>
            </div>
          </div>
          <div class="search-label">NOME / RAGIONE SOCIALE</div>
          <div v-if="showSuggestionsFor('nome')" class="suggestions-dropdown">
            <div
              v-for="suggestion in searchSuggestions"
              :key="`nome-${suggestion.id}`"
              @mousedown="selectSearchSuggestion(suggestion, 'nome')"
              class="suggestion-item"
            >
              <div class="suggestion-primary">{{ getSuggestionPrimaryLabel(suggestion.label) }}</div>
              <div v-if="getSuggestionSecondaryLabel(suggestion.label)" class="suggestion-secondary">
                {{ getSuggestionSecondaryLabel(suggestion.label) }}
              </div>
            </div>
            <div v-if="searchSuggestions.length === 0 && searchQueries.nome.length >= 2 && !loadingSuggestions" class="suggestion-empty">
              Nessun risultato trovato per "{{ searchQueries.nome }}"
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="selectedUser.id" class="user-header">
      <div class="header-top-row">
        <div class="user-name-container">
          <h1 class="dashboard-title">
            {{
              (selectedUser.cliente_nome && selectedUser.cliente_cognome && (selectedUser.cliente_nome + ' ' + selectedUser.cliente_cognome)) ||
              selectedUser.cliente_nome ||
              selectedUser.cliente_cognome ||
              selectedUser.ragsoc ||
              (selectedUser.nome && selectedUser.cognome && (selectedUser.nome + ' ' + selectedUser.cognome)) ||
              selectedUser.nome ||
              selectedUser.cognome
            }}
          </h1>
        </div>
        
        <div class="totale-insoluto-container">
          <span v-if="totaleInsoluto > 0" class="totale-insoluto">
            Totale Insoluto: € {{ formatCurrency(totaleInsoluto) }}
          </span>
        </div>
      </div>
    </div>

    <IncallOriginTicket
      v-if="selectedUser.id && contextTicket && showContextTicket"
      :ticket="contextTicket"
      :loading="loadingContextTicket"
      @view="openContextTicket('view')"
      @reply="openContextTicket('reply')"
      @dismiss="dismissContextTicket"
    />

    <div v-if="selectedUser.id" class="main-content">
      <div class="user-details-card">
        <div class="info-card-header">
          <div class="header-content">
            <h3 class="section-title">Dettagli Utente</h3>
            <i class="pi pi-user toggle-icon"></i>
          </div>
        </div>
        <div class="info-card-content">
          <div class="info-row">
            <span class="info-label">Agente:</span>
            <span class="info-value">{{ selectedUser.agente_name || 'Non disponibile' }}</span>
          </div>
          <div class="info-row" v-if="selectedUser.entity_type !== 'rappresentante'">
            <span class="info-label">Codice Cliente:</span>
            <span class="info-value">{{ selectedUser.code_cliente || selectedUser.cod_cliente || 'Non disponibile' }}</span>
          </div>

          <div class="info-row">
            <span class="info-label mt-2">Telefono:</span>
            <span
              class="info-value"
              style="white-space: nowrap; display: inline-flex; align-items: center; gap: 0.5rem;"
            >
              {{ selectedUser.telefono || 'Non disponibile' }}
              <button
                v-if="selectedUser.telefono && selectedUser.telefono !== 'Non disponibile'"
                class="ask-call-btn"
                @click="openCallDialog"
                title="Chiama"
              >
                <i class="pi pi-phone add-icon"></i>
              </button>
            </span>
          </div>

          <div class="info-row">
            <span class="info-label">Email:</span>
            <span class="info-value">{{ selectedUser.email || 'Non disponibile' }}</span>
          </div>
          <div v-if="selectedUser.pec" class="info-row">
            <span class="info-label">PEC:</span>
            <span class="info-value">{{ selectedUser.pec }}</span>
          </div>
          <div v-if="selectedUser.entity_type === 'rappresentante'" class="info-row">
            <span class="info-label">Indirizzo:</span>
            <span class="info-value">{{ selectedUser.indirizzo || 'Non disponibile' }}</span>
          </div>
          <template v-else>
            <div class="info-row">
              <span class="info-label">Via:</span>
              <span class="info-value">{{ selectedUser.via || 'Non disponibile' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Città:</span>
              <span class="info-value">{{ selectedUser.citta || 'Non disponibile' }}</span>
            </div>
          </template>
          <div class="info-row">
            <span class="info-label">Codice Fiscale:</span>
            <span class="info-value">{{ selectedUser.codiceFiscale || 'Non disponibile' }}</span>
          </div>
          <!-- <div v-if="selectedUser.entity_type !== 'rappresentante'" class="info-row">
            <span class="info-label">PDP:</span>
            <span class="info-value">{{ selectedUser.pdp || 'Non disponibile' }}</span>
          </div> -->
          

          <!-- <div v-if="selectedUser.totale_fatturato !== undefined || selectedUser.entity_type" class="info-section-divider">
            <hr style="border: none; border-top: 1px solid #e0e0e0; margin: 1rem 0;">
            <h4 style="font-size: 0.9rem; font-weight: 600; color: #666; margin: 0.5rem 0;">
              {{ selectedUser.entity_type === 'rappresentante' ? 'Dati Rappresentante' : 'Dati PDP' }}
            </h4>
          </div> -->

          <div v-if="selectedUser.totale_fatturato !== undefined" class="info-row">
            <span class="info-label">Totale Fatturato:</span>
            <span class="info-value" style="font-weight: 600; color: #2196F3;">€ {{
              formatCurrency(selectedUser.totale_fatturato) }}</span>
          </div>

          <div v-if="selectedUser.totale_pagato !== undefined" class="info-row">
            <span class="info-label">Totale Pagato:</span>
            <span class="info-value" style="font-weight: 600; color: #4CAF50;">€ {{
              formatCurrency(selectedUser.totale_pagato) }}</span>
          </div>

          <div v-if="selectedUser.consumo_annuo !== undefined" class="info-row">
            <span class="info-label">Consumo Annuo:</span>
            <span class="info-value" style="font-weight: 600; color: #FF9800;">{{ selectedUser.consumo_annuo }}
              kWh</span>
          </div>

          <div v-if="selectedUser.totale_fatturato !== undefined && selectedUser.totale_pagato !== undefined"
            class="info-row">
            <span class="info-label">Saldo Calcolato:</span>
            <span class="info-value" style="font-weight: 700; font-size: 1.1rem;"
              :style="{ color: (selectedUser.totale_fatturato - selectedUser.totale_pagato) > 0 ? '#d32f2f' : '#2e7d32' }">
              € {{ formatCurrency(selectedUser.totale_fatturato - selectedUser.totale_pagato) }}
            </span>
          </div>

          <div v-if="selectedUser.entity_type === 'rappresentante'" class="info-row">
            <span class="info-label">Tipo:</span>
            <span class="info-value" style="font-weight: 600; color: #9C27B0;">Rappresentante</span>
          </div>
        </div>
      </div>

      <div class="incall-right-column">
        <div class="fatture-table-container">
          <div class="fatture-table-header">
            <div>
              <h3 class="section-title">
                FATTURE INSOLUTE
              </h3>
              <div class="ech-legend">
                <span class="ech-legend-square"></span>
                appartenenza lista comuni calamità naturali
              </div>
            </div>
            
            <div class="table-actions">
              <button class="send-email-btn send-totali-btn" @click="openTotaliDialog" :disabled="
                (selectedSearchType === 'rappresentante' && !selectedUser.id) || 
                (selectedSearchType !== 'rappresentante' && !selectedUser.client_id) || 
                loadingTotali
              ">
                <i class="pi pi-chart-bar add-icon"></i>
               Info Estratti Conto
                <span v-if="loadingTotali" class="loader-spinner"></span>
              </button>
              <button class="send-email-btn" @click="openInvioEmailModal" :disabled="!fattureInsolute || fattureInsolute.length === 0">
                <i class="pi pi-envelope add-icon"></i>
               Fatture 
              </button>
              <button class="send-email-btn send-estratto-conto-btn" @click="showEstrattoContoConfirmation" :disabled="
                (selectedSearchType === 'rappresentante' && !selectedUser.id) || 
                (selectedSearchType !== 'rappresentante' && !selectedUser.client_id) || 
                sendingEstrattoConto
              ">
                <i class="pi pi-file-pdf"></i>
                Estratto Conto
                <span v-if="sendingEstrattoConto" class="loader-spinner"></span>
              </button>
              <button class="send-email-btn send-bollettino-btn" @click="showBollettinoDialog = true" :disabled="
                (selectedSearchType === 'rappresentante' && !selectedUser.id) || 
                (selectedSearchType !== 'rappresentante' && !selectedUser.client_id) || 
                sendingBollettino
              ">
                <i class="pi pi-file"></i>
                Bollettini
                <span v-if="sendingBollettino" class="loader-spinner"></span>
              </button>
              <button class="send-email-btn" @click="openQuietanzaDialog" :disabled="
                (selectedSearchType === 'rappresentante' && !selectedUser.id) || 
                (selectedSearchType !== 'rappresentante' && !selectedUser.client_id) || 
                !fattureInsolute || fattureInsolute.length === 0
              ">
                <i class="pi pi-file"></i>
               Quietanza
              </button>

              <button 
                v-if="selectedUser.privilegiato === 0" 
                class="send-email-btn send-bonaria-btn" 
                @click="openEmailBonariaDialog"
              >
                <i class="pi pi-send"></i>
                Invia Email Bonaria
              </button>

              <button 
                class="send-email-btn" 
                @click="openSmsDialog"
              >
                <i class="pi pi-comment"></i>
                Invia SMS
              </button>
            </div>
          </div>
          
          <div v-if="loadingFatture" class="fatture-loader" style="display: flex; justify-content: center; align-items: center; padding: 2rem; background: white;">
            <div style="text-align: center;">
              <i class="pi pi-spin pi-spinner" style="font-size: 2rem; color: #3388b3; margin-bottom: 1rem;"></i>
              <p style="color: #666; margin: 0;">Caricamento fatture...</p>
            </div>
          </div>
          
          <div v-else class="fatture-table-wrapper">
            <table class="fatture-table">
              <thead>
                <tr>
                  <th class="col-pdp">PDP</th>
                  <th class="col-cliente">CLIENTE</th>
                  <th class="col-cliente">CODICE CLIENTE</th>
                  <th class="col-cliente">METODO DI PAGAMENTO</th>
                  <th class="col-indirizzo">INDIRIZZO</th>
                  <th class="col-numero">NUMERO</th>
                  <th class="col-emissione">EMISSIONE</th>
                  <th class="col-scadenza">SCADENZA</th>
                  <th class="col-preavviso">DATA INVIO PREAVVISO</th>
                  <th class="col-preavviso">DATA SCADENZA PREAVVISO</th>
                  <th class="col-importo">TOTALE FATTURA</th>
                  <th class="col-importo">TOTALE PAGATO</th>
                  <th class="col-importo sortable">
                    <button
                      type="button"
                      class="sort-button"
                      @click.stop="sortBy('importo')"
                    >
                      SALDO
                      <span class="sort-icon" v-if="sortField === 'importo'">
                        <i :class="sortOrder === 'asc' ? 'pi pi-sort-up' : 'pi pi-sort-down'"></i>
                      </span>
                      <span class="sort-icon" v-else>
                        <i class="pi pi-sort"></i>
                      </span>
                    </button>
                  </th>
                  <th class="col-stato">STATO</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="fattureInsolute && fattureInsolute.length > 0">
                  <tr
                    v-for="fattura in fattureInsolute"
                    :key="fattura.fattura_id"
                    :class="{ 'row-ech': Number(fattura.ech) === 1 }"
                  >
                    <td class="col-pdp">
                      <a href="javascript:void(0)" @click="navigateToPdpDetail(fattura.cod_pod, fattura.cod_pdr)" class="table-link">
                        {{ fattura.code }}
                      </a>
                    </td>
                    <td class="col-cliente">
                      <a href="javascript:void(0)" @click="navigateToClienteDetail(selectedSearchType === 'rappresentante' ? fattura.cod_cliente : selectedUser.client_id)" class="table-link">
                        {{ selectedSearchType === 'rappresentante' 
                          ? (fattura.cliente_ragsoc || (fattura.cliente_nome && fattura.cliente_cognome ? fattura.cliente_nome + ' ' + fattura.cliente_cognome : fattura.cliente_nome || 'N/A')) 
                          : (selectedUser.ragsoc || (selectedUser.cliente_nome && selectedUser.cliente_cognome && (selectedUser.cliente_nome + ' ' + selectedUser.cliente_cognome))
                          || (selectedUser.nome && selectedUser.cognome && (selectedUser.nome + ' ' + selectedUser.cognome))
                          || selectedUser.cliente_nome 
                          || selectedUser.cliente_cognome 
                          || selectedUser.nome 
                          || selectedUser.cognome 
                          || '-') }}
                      </a>
                    </td>
                    <td class="col-cliente">
                      <a href="javascript:void(0)" @click="navigateToClienteDetail(selectedSearchType === 'rappresentante' ? fattura.cod_cliente : selectedUser.client_id)" class="table-link">
                        {{ selectedSearchType === 'rappresentante' 
                          ? (fattura.code_cliente || fattura.cod_cliente || '-') 
                          : (selectedUser.code_cliente || selectedUser.cod_cliente || '-') }}
                      </a>
                    </td>
                    <td class="col-cliente">
                      {{ fattura.type_pay_name || '-' }}
                    </td>
                    <td class="col-indirizzo">
                      <span class="truncate-text" :title="selectedSearchType === 'rappresentante'
                          ? (fattura.indirizzo_completo || '-')
                          : (selectedUser.indirizzo_completo || selectedUser.via || '-')">
                      {{ selectedSearchType === 'rappresentante'
                          ? (fattura.indirizzo_completo || '-')
                          : (selectedUser.indirizzo_completo || selectedUser.via || '-') }}
                      </span>
                    </td>
                    <td class="col-numero">
                      <a href="javascript:void(0)" @click="navigateToFatturaDetail(fattura.numero)" class="table-link">
                        {{ fattura.numero }}
                      </a>
                    </td>
                    <td class="col-emissione">{{ formatDate(fattura.data_emissione) }}</td>
                    <td class="col-scadenza">{{ formatDate(fattura.data_scadenza_fattura) }}</td>
                    <td class="col-preavviso">{{ formatDate(fattura.data_invio_preavviso) }}</td>
                    <td class="col-preavviso">{{ formatDate(fattura.data_scadenza_preavviso) }}</td>
                    <td class="col-importo">€ {{ formatCurrency(fattura.tot_fattura) }}</td>
                    <td class="col-importo">€ {{ formatCurrency(fattura.totale_pagato) }}</td>
                    <td class="col-importo">€ {{ formatCurrency(fattura.saldo_fattura) }}</td>
                    <td class="col-stato">{{ fattura.type_state_name }}</td>
                  </tr>
                </template>
                <tr v-else>
                  <td colspan="13" class="no-data-message">Non ci sono fatture insolute</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div v-if="puntiDiPrelievo.length > 0" class="pdr-section">
            <div class="pdp-table-header">
              <h3 class="section-title">Punti Di Prelievo</h3>
            </div>
            <div class="fatture-table-wrapper">
              <table class="fatture-table">
                <thead>
                  <tr>
                    <th class="col-pdp">CODICE PDR/POD</th>
                    <th class="col-emissione">DATA INIZIO</th>
                    <th class="col-emissione">DATA FINE</th>
                    <th class="col-stato">STATO</th>
                    <th class="col-cliente">CLIENTE</th>
                    <th class="col-cliente">CODICE CLIENTE</th>
                    <th class="col-indirizzo">INDIRIZZO</th>
                    <th class="col-numero">N. FATTURE</th>
                    <th class="col-importo">TOTALE INSOLUTO</th>
                    <th v-if="hasRiattivablePdr" class="col-azioni">AZIONI</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="pdr in puntiDiPrelievo" :key="pdr.code">
                    <td class="col-pdp">
                      <div class="pdp-code-cell">
                        <a href="javascript:void(0)" @click="navigateToPdpDetail(pdr.cod_pod, pdr.cod_pdr)" class="table-link">
                          {{ pdr.code }}
                        </a>
                        <button
                          v-if="hasAppuntamentoRiattivazione(pdr)"
                          type="button"
                          class="appuntamento-alert"
                          title="Appuntamento riattivazione"
                          @click.stop="openAppuntamentoDialog(pdr)"
                        >
                          <span class="appuntamento-alert__dot"></span>
                          <i class="pi pi-calendar"></i>
                        </button>
                      </div>
                    </td>
                    <td class="col-emissione">{{ formatDate(pdr.data_inizio) || '-' }}</td>
                    <td class="col-emissione">{{ formatDate(pdr.data_fine) || '-' }}</td>
                    <td class="col-stato">{{ pdr.stato }}</td>
                    <td class="col-cliente">
                      <a href="javascript:void(0)" @click="navigateToClienteDetail(selectedSearchType === 'rappresentante' ? pdr.cod_cliente : selectedUser.client_id)" class="table-link">
                        {{ pdr.cliente_ragsoc }}
                      </a>
                    </td>
                    <td class="col-cliente">
                      <a href="javascript:void(0)" @click="navigateToClienteDetail(selectedSearchType === 'rappresentante' ? pdr.cod_cliente_num : selectedUser.client_id)" class="table-link">
                        {{ pdr.cod_cliente }}
                      </a>
                    </td>
                    <td class="col-indirizzo">
                      <span class="truncate-text" :title="pdr.indirizzo_completo">
                        {{ pdr.indirizzo_completo }}
                      </span>
                    </td>
                    <td class="col-numero">{{ pdr.fatture_count }}</td>
                    <td class="col-importo">€ {{ formatCurrency(pdr.totale_insoluto) }}</td>
                    <td v-if="hasRiattivablePdr" class="col-azioni">
                      <button 
                        v-if="shouldShowRiattivaButton(pdr.stato)"
                        @click="riattivaPdr(pdr)"
                        class="btn-riattiva"
                        :disabled="riattivandoPdr || pdr.inPreview"
                      >
                        {{ pdr.inPreview ? 'In Preview' : 'Da Riattivare' }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div> 
    </div> 

    <div v-if="showAppuntamentoDialog" class="modal-overlay" @click="closeAppuntamentoDialog">
      <div class="modal-content modal-medium" @click.stop>
        <div class="modal-header">
          <h3>
            Appuntamenti riattivazione
            <span v-if="selectedAppuntamentoPunto">- {{ selectedAppuntamentoPunto.code }}</span>
          </h3>
          <button class="close-button" @click="closeAppuntamentoDialog">&times;</button>
        </div>
        <div class="modal-body">
          <div v-if="!selectedAppuntamenti.length" class="no-data-message">
            Nessun appuntamento trovato.
          </div>
          <div v-else class="fatture-table-wrapper">
            <table class="fatture-table">
              <thead>
                <tr>
                  <th>Codice</th>
                  <th>Appuntamento</th>
                  <th>Creato il</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="app in selectedAppuntamenti" :key="app.id">
                  <td>{{ app.supply_code || '-' }}</td>
                  <td>{{ formatDateTime(app.appuntamento) || '-' }}</td>
                  <td>{{ formatDateTime(app.creation_time) || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-secondary" @click="closeAppuntamentoDialog">Chiudi</button>
        </div>
      </div>
    </div>

    <div v-if="showRimandaModal" class="modal-overlay" @click="closeRimandaModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Rimanda Recupero</h3>
          <button class="close-button" @click="closeRimandaModal">×</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="rimanda-note">Note:</label>
            <textarea id="rimanda-note" v-model="rimandaData.note" placeholder="Inserisci le note per il rimando..."
              class="form-textarea" rows="4"></textarea>
          </div>
          <div class="form-group">
            <label for="rimanda-data">Data di Rimando:</label>
            <input type="date" id="rimanda-data" v-model="rimandaData.dataRimando" :min="today" :max="maxDate"
              class="form-input" />
            <small class="form-help">Seleziona una data entro 15 giorni da oggi</small>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-secondary" @click="closeRimandaModal">Annulla</button>
          <button class="btn-primary" @click="confermaRimanda"
            :disabled="!rimandaData.note || !rimandaData.dataRimando">
            Conferma Rimando
          </button>
        </div>
      </div>
    </div>

    <div v-if="showDistaccaModal" class="modal-overlay" @click="closeDistaccaModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Distacca Recupero</h3>
          <button class="close-button" @click="closeDistaccaModal">×</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="distacca-note">Note Distacco:</label>
            <textarea id="distacca-note" v-model="distaccaData.note" placeholder="Inserisci le note per il distacco..."
              class="form-textarea" rows="4"></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-secondary" @click="closeDistaccaModal">Annulla</button>
          <button class="btn-primary" @click="confermaDistacca" :disabled="!distaccaData.note">
            Conferma Distacco
          </button>
        </div>
      </div>
    </div>

    <div v-if="showDilazioneModal" class="modal-overlay" @click="closeDilazioneModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Dilaziona Recupero</h3>
          <button class="close-button" @click="closeDilazioneModal">×</button>
        </div>
        <div class="modal-body">
          <div class="dilazione-question">
            <p>Vuoi procedere con la dilazione del recupero?</p>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-secondary" @click="closeDilazioneModal">No</button>
          <button class="btn-primary" @click="confermaDilazione">
            Sì, Dilaziona
          </button>
        </div>
      </div>
    </div>

    <div v-if="loading" class="loading-overlay">
      <div class="loading-spinner">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Caricamento...</span>
      </div>
    </div>

    <div v-if="showInvioEmailModal" class="modal-overlay" @click="closeInvioEmailModal">
      <div class="modal-content modal-extra-large" @click.stop>
        <div class="modal-header modal-header-email">
          <h3>Invio Fatture per Email</h3>
          <button class="close-button" @click="closeInvioEmailModal">&times;</button>
        </div>
        <div class="modal-body">
          <div v-if="loadingEmailModal" class="email-modal-loader">
            <div class="loader-content">
              <i class="pi pi-spin pi-spinner"></i>
              <p>Preparazione invio email...</p>
              <small>Caricamento fatture e configurazione</small>
            </div>
          </div>
          
          <div v-else>
            <div v-if="selectedSearchType === 'rappresentante'" class="info-message info-rappresentante">
              <i class="pi pi-info-circle"></i>
              <strong>Invio al Rappresentante:</strong> Le fatture verranno inviate all'indirizzo email del rappresentante: 
              <strong>{{ selectedUser.email }}</strong>
            </div>
            
            <div v-else class="info-message info-cliente">
              <i class="pi pi-user"></i>
              <strong>Invio al Cliente:</strong> Le fatture verranno inviate all'indirizzo email del cliente: 
              <strong>{{ selectedUser.email }}</strong>
            </div>
            
            <InvioEmail 
              :data="emailFattureData" 
              :hideFooter="true"
              ref="invioEmailComponent"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-secondary" @click="downloadFattureZipModal" :disabled="emailSending || downloadingZip">
            <i class="pi pi-spin pi-spinner" v-if="downloadingZip"></i>
            <i class="pi pi-download" v-else></i>
            Scarica Fattura
          </button>
          <button class="btn-secondary" @click="closeInvioEmailModal">
            <i class="pi pi-times"></i> Chiudi
          </button>
          <button class="btn-primary" @click="executeEmailSend" :disabled="emailSending">
            <i class="pi pi-spin pi-spinner" v-if="emailSending"></i>
            <i class="pi pi-check" v-else></i>
            {{ emailSending ? 'Invio...' : 'Esegui' }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="showEstrattoContoMessageModal" class="modal-overlay" @click="closeEstrattoContoMessageModal">
      <div class="modal-content modal-small" @click.stop>
        <div class="modal-header" :class="estrattoContoMessage.type === 'success' ? 'modal-header-success' : 'modal-header-error'">
          <h3>{{ estrattoContoMessage.title }}</h3>
          <button class="close-button" @click="closeEstrattoContoMessageModal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="message-content">
            <i :class="estrattoContoMessage.type === 'success' ? 'pi pi-check-circle' : 'pi pi-exclamation-triangle'"></i>
            <p>{{ estrattoContoMessage.message }}</p>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-primary" @click="closeEstrattoContoMessageModal">
            OK
          </button>
        </div>
      </div>
    </div>

    <div v-if="showBollettinoMessageModal" class="modal-overlay" @click="closeBollettinoMessageModal">
      <div class="modal-content modal-small" @click.stop>
        <div class="modal-header" :class="bollettinoMessage.type === 'success' ? 'modal-header-success' : 'modal-header-error'">
          <h3>{{ bollettinoMessage.title }}</h3>
          <button class="close-button" @click="closeBollettinoMessageModal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="message-content">
            <i :class="bollettinoMessage.type === 'success' ? 'pi pi-check-circle' : 'pi pi-exclamation-triangle'"></i>
            <p>{{ bollettinoMessage.message }}</p>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-primary" @click="closeBollettinoMessageModal">
            OK
          </button>
        </div>
      </div>
    </div>

    <div v-if="showTotaliDialog" class="modal-overlay" @click="closeTotaliDialog">
      <div class="modal-content modal-large" @click.stop>
        <div class="modal-header">
          <h3>{{ selectedSearchType === 'rappresentante' ? 'Totali Estratti Conto Rappresentante' : 'Totali Estratti Conto Cliente' }}</h3>
          <button class="close-button" @click="closeTotaliDialog">&times;</button>
        </div>
        <div class="modal-body">
                      <div class="anni-selector-section">
              <label class="anni-label">
                <i class="pi pi-calendar"></i>
                Seleziona l'anno di partenza:
              </label>
              <select v-model="selectedAnnoPartenza" class="anno-select" @change="loadTotali">
                <option value="">Seleziona un anno</option>
                <option v-for="anno in anniDisponibiliTotali" :key="anno" :value="anno">
                  {{ anno }}
                </option>
              </select>
            </div>

          <div class="tipo-estratto-section">
            <div class="estratto-filters-row">
              <div class="estratto-filter-col">
                <label class="tipo-estratto-label">
                  <i class="pi pi-file-pdf"></i>
                  Tipo di riepilogo da visualizzare:
                </label>
                <select v-model="selectedTipoEstrattoTotali" class="tipo-estratto-select" @change="loadTotali">
                  <option value="da_saldare">Solo fatture da saldare</option>
                  <option value="completo">Estratto conto completo</option>
                  <option value="escludi_crediti">Escludi Crediti</option>
                </select>
              </div>

              <div class="estratto-filter-col">
                <label for="stato-fornitura-totali-selector" class="tipo-estratto-label">
                  <i class="pi pi-bolt"></i>
                  Punti di fornitura:
                </label>
                <select
                  id="stato-fornitura-totali-selector"
                  v-model="selectedStatoFornituraTotali"
                  class="tipo-estratto-select"
                  @change="loadTotali"
                >
                  <option value="all_state">Tutti i punti</option>
                  <option value="attivi">Solo punti attivi</option>
                  <option value="cessati">Solo punti cessati</option>
                </select>
              </div>
            </div>
          </div>

          <div v-if="loadingTotali" class="totali-loader">
            <i class="pi pi-spin pi-spinner"></i>
            <p>Caricamento totali...</p>
          </div>

          <div v-else-if="totaliData && !totaliData.error" class="totali-results">
            <div class="totali-header">
              <h4 v-if="totaliData.tipo === 'cliente'">
                Totali per cliente: {{ totaliData.cliente?.ragsoc || totaliData.cliente?.nome || 'N/A' }}
              </h4>
              <h4 v-else>
                Totali per rappresentante: {{ selectedUser.nome }} ({{ totaliData.numero_clienti }} clienti)
              </h4>
              <div class="periodo-info">
                <span class="periodo-label">Periodo:</span>
                <span class="periodo-value">
                  {{ selectedAnnoPartenza || 'Nessun anno selezionato' }}
                  {{ selectedTipoEstrattoTotali === 'completo' ? ' (completo)' : ' (solo da saldare)' }}
                </span>
              </div>
            </div>

            <div class="totali-table-container" v-if="totaliData && totaliData.totali_per_mese && totaliData.totali_per_mese.length > 0">
              <table class="totali-table">
                <thead>
                  <tr>
                    <th>Mese/Anno</th>
                    <th style="text-align: center;">N° Fatture</th>
                    <th style="text-align: right; padding-right: 1rem;">Totale Fattura</th>
                    <th style="text-align: right; padding-right: 1rem;">Pagato</th>
                    <th style="text-align: right; padding-right: 1rem;">Saldo</th>
                  </tr>
                </thead>
                <tbody v-if="totaliData && totaliData.totali_per_mese">
                  <tr v-for="mese in totaliData.totali_per_mese" :key="mese.mese_anno">
                    <td>{{ formatMeseAnno(mese.mese_anno) }}</td>
                    <td style="text-align: center;">{{ mese.numero_fatture }}</td>
                    <td class="importo" style="font-size: 1.3rem !important;">€ {{ formatCurrency(mese.totale_fattura) }}</td>
                    <td class="importo" style="font-size: 1.3rem !important;">€ {{ formatCurrency(mese.pagato) }}</td>
                    <td class="importo" :class="mese.saldo >= 0 ? 'saldo-positivo' : 'saldo-negativo'" style="font-size: 1.3rem !important;">
                      € {{ formatCurrency(mese.saldo) }}
                    </td>
                  </tr>
                </tbody>
                <tfoot v-if="totaliData && totaliData.totale_generale">
                  <tr class="totale-generale">
                    <td><strong>TOTALE GENERALE</strong></td>
                    <td style="text-align: center;"><strong>{{ getTotaleFatture() }}</strong></td>
                    <td class="importo" style="font-size: 1.3rem !important;"><strong>€ {{ formatCurrency(totaliData.totale_generale.totale_fattura) }}</strong></td>
                    <td class="importo" style="font-size: 1.3rem !important;"><strong>€ {{ formatCurrency(totaliData.totale_generale.pagato) }}</strong></td>
                    <td class="importo" :class="totaliData.totale_generale.saldo >= 0 ? 'saldo-positivo' : 'saldo-negativo'" style="font-size: 1.3rem !important;">
                      <strong>€ {{ formatCurrency(totaliData.totale_generale.saldo) }}</strong>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <div v-else-if="!loadingTotali && selectedAnnoPartenza" class="no-data-message">
            <i class="pi pi-info-circle"></i>
            <p>Nessun dato trovato per l'anno selezionato</p>
          </div>

          <div v-else-if="!loadingTotali && !selectedAnnoPartenza" class="select-years-message">
            <i class="pi pi-calendar"></i>
            <p>Seleziona un anno per visualizzare i totali</p>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-secondary" @click="closeTotaliDialog">
            <i class="pi pi-times"></i> Chiudi
          </button>
        </div>
      </div>
    </div>

    <div v-if="showCallDialog" class="modal-overlay" @click="closeCallDialog">
      <div class="modal-content modal-small" @click.stop>
        <div class="modal-header">
          <h3>Conferma Chiamata</h3>
          <button class="close-button" @click="closeCallDialog">&times;</button>
        </div>
        <div class="modal-body">
          <p>
            Vuoi chiamare il numero
            <strong>{{ selectedUser.telefono }}</strong>?
          </p>
        </div>
        <div class="modal-footer">
          <button class="btn-secondary" @click="closeCallDialog">
            No
          </button>
          <button class="btn-primary" @click="confirmCall">
            Sì, chiama
          </button>
        </div>
      </div>
    </div>
    <div v-if="showSelezioneFattureDialog" class="modal-overlay" @click="closeSelezioneFattureDialog">
      <div class="modal-content modal-large" @click.stop>
        <div class="modal-header">
          <h3>Seleziona Fatture per Quietanza</h3>
          <button class="close-button" @click="closeSelezioneFattureDialog">&times;</button>
        </div>
        <div class="modal-body">
          <div class="fatture-selection-container">
            <p class="selection-info">
              Seleziona le fatture per cui vuoi creare la quietanza:
            </p>
            
            <div class="fatture-list">
              <div v-for="fattura in fattureInsolute" :key="fattura.numero" class="fattura-item">
                <label class="fattura-checkbox">
                  <input 
                    type="checkbox" 
                    :value="fattura.numero" 
                    v-model="selectedFattureQuietanza"
                  />
                  <span class="checkmark"></span>
                  <div class="fattura-info">
                    <div class="fattura-numero">Fattura {{ fattura.numero }}</div>
                    <div class="fattura-details">
                      <span class="fattura-data">{{ formatDate(fattura.data_emissione) }}</span>
                      <span class="fattura-importo">€ {{ formatCurrency(fattura.saldo_fattura) }}</span>
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-secondary" @click="closeSelezioneFattureDialog">
            <i class="pi pi-times"></i> Annulla
          </button>
          <button class="btn-primary" @click="confermaSelezioneFatture">
            <i class="pi pi-check"></i> Crea Quietanza ({{ selectedFattureQuietanza.length }})
          </button>
        </div>
      </div>
    </div>

    <div v-if="showQuietanzaDialog" class="modal-overlay" @click="closeQuietanzaDialog">
      <div class="modal-content modal-large quietanza-modal" @click.stop>
        <div class="modal-header">
          <h3>Quietanza</h3>
          <button class="close-button" @click="closeQuietanzaDialog">&times;</button>
        </div>
        <div class="modal-body quietanza-container">
          <div class="quietanza-content">
            <!-- Contenuto del componente Quietanza senza wrapper -->
            <div v-if="quietanzaData && processedQuietanzaData && processedQuietanzaData.length > 0" class="quietanza-inline">
              <div v-for="item in processedQuietanzaData" :key="item.rapp" class="mt-2 card">
                <Checkbox v-model="selectedQuietanzeInline" :value="item.rapp" />
                <label class="ml-2">{{ item.rapp }}</label>
                <hr>
                <div v-for="quietanza in item.quietanze" :key="quietanza.cliente" class="formgrid grid mt-2">
                  <div class="field col-12 md:col-3 flex align-items-center">
                    {{ quietanza.cliente }}
                  </div>
                  <div class="field col-12 md:col-3">
                    <label>Data</label>
                    <Calendar v-model="quietanza.date" dateFormat="dd/mm/yy" class="inputfield w-full" />
                  </div>
                  <div class="field col-12 md:col-3">
                    <label>Mezzo Pagamento</label>
                    <InputText v-model="quietanza.type_payment" class="inputfield w-full" />
                  </div>
                  <div class="field col-12 md:col-3">
                    <label>Importo</label>
                    <InputText v-model="quietanza.amount" class="inputfield w-full" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-secondary" @click="closeQuietanzaDialog">
            <i class="pi pi-times"></i> Chiudi
          </button>
          <button class="btn-primary" @click="eseguiQuietanza" :disabled="downloadingQuietanza">
            <i class="pi pi-spin pi-spinner" v-if="downloadingQuietanza"></i>
            <i class="pi pi-check" v-else></i>
            {{ downloadingQuietanza ? 'Generazione...' : 'Esegui' }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="showEmailBonariaDialog" class="modal-overlay" @click="closeEmailBonariaDialog">
      <div class="modal-content modal-large" @click.stop>
        <div class="modal-header">
          <h3>Invia Email Bonaria</h3>
          <button class="close-button" @click="closeEmailBonariaDialog">&times;</button>
        </div>
        <div class="modal-body">
          <div class="fatture-selection-container">
            <p class="selection-info">
              Seleziona le fatture per cui inviare l'email bonaria al cliente:
            </p>
            
            <div class="fatture-list">
              <div v-for="fattura in fattureInsolute" :key="fattura.numero" class="fattura-item">
                <label class="fattura-checkbox">
                  <input 
                    type="checkbox" 
                    :value="fattura.numero" 
                    v-model="selectedFattureEmailBonaria"
                  />
                  <span class="checkmark"></span>
                  <div class="fattura-info">
                    <div class="fattura-numero">Fattura {{ fattura.numero }}</div>
                    <div class="fattura-details">
                      <span class="fattura-data">Emissione: {{ formatDate(fattura.data_emissione) }}</span>
                      <span class="fattura-data">Scadenza: {{ formatDate(fattura.data_scadenza) }}</span>
                      <span class="fattura-importo">€ {{ formatCurrency(fattura.saldo_fattura) }}</span>
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-secondary" @click="closeEmailBonariaDialog">
            <i class="pi pi-times"></i> Annulla
          </button>
          <button class="btn-primary" @click="confermaInvioEmailBonaria" :disabled="sendingEmailBonaria">
            <i class="pi pi-spin pi-spinner" v-if="sendingEmailBonaria"></i>
            <i class="pi pi-send" v-else></i>
            {{ sendingEmailBonaria ? 'Invio in corso...' : `Invia Email (${selectedFattureEmailBonaria.length})` }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="showSmsDialog" class="modal-overlay" @click="closeSmsDialog">
      <div class="modal-content-sms modal-large" @click.stop>
        <div class="modal-header">
          <h3>Invia SMS</h3>
          <button class="close-button" @click="closeSmsDialog">&times;</button>
        </div>
        <div class="modal-body-sms">
          <div class="fatture-selection-container">
            <div>

              <div class="flex gap-3">
                <!-- LEFT -->
                <div class="w-4 border-round p-3 surface-card sms-left" style="width: 35%; max-height: 450px;">
                  <div class="sms-left-scroll">
                    <Accordion :multiple="true" :activeIndex="[0]">
                      <AccordionTab
                        v-for="cat in smsTemplatesCategories"
                        :key="cat === null ? '__NULL__' : cat"
                        :header="cat === null ? '(ALTRO)' : cat"
                      >
                        <div class="flex flex-column gap-2">
                          <button
                            v-for="tpl in templatesByCategory(cat)"
                            :key="tpl.id"
                            type="button"
                            class="text-left p-2 border-round w-full sms-template-button"
                            :class="{ 'is-active': selectedSmsTemplate?.id === tpl.id }"
                            @click="selectTemplate(tpl)"
                          >
                            <div class="font-medium">{{ tpl.name }}</div>
                            <div class="text-sm text-600">{{ snippet(tpl.body) }}</div>
                          </button>
                        </div>
                      </AccordionTab>
                    </Accordion>
                  </div>
                </div>

                <!-- RIGHT -->
                 <div class="border-round p-3 surface-card" style="width: 65%; min-height: 450px;">
                  <div v-if="selectedSmsTemplate">
                    <div class="flex align-items-start justify-content-between mb-2">
                      <div>
                        <div class="text-xl font-semibold">{{ selectedSmsTemplate.name }}</div>

                        <div class="flex gap-2 mt-2">
                          <Tag :value="selectedSmsTemplate.category === null ? 'ALTRO' : selectedSmsTemplate.category" class="p-tag-info mr-2" />
                          <Tag v-if="selectedSmsTemplate.is_system" class="p-tag-danger mr-2" value="SYSTEM" />
                          <Tag v-if="selectedSmsTemplate.language" class="p-tag-info mr-2" :value="selectedSmsTemplate.language" />
                        </div>
                      </div>
                    </div>

                    <div class="mt-3">
                      <label class="text-600 text-sm">Messaggio da inviare</label>
                      <Textarea
                        v-model="selectedSmsTemplate.body"
                        class="w-full mt-2"
                        style="min-height: 260px; max-height: 320px;"
                        rows="4"
                        autoResize
                      />
                    </div>
                  </div>

                  <div v-else class="text-600">
                    Seleziona un template a sinistra per vedere l’anteprima.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-secondary" @click="closeSmsDialog">
            <i class="pi pi-times"></i> Annulla
          </button>
          <button class="btn-primary" @click="confermaInvioSms" :disabled="sendingSms">
            <i class="pi pi-spin pi-spinner" v-if="sendingSms"></i>
            <i class="pi pi-send" v-else></i>
            {{ sendingSms ? 'Invio in corso...' : `Invia SMS` }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="showEstrattoContoDialog" class="modal-overlay" @click="closeEstrattoContoDialog">
      <div class="modal-content modal-medium" @click.stop>
        <div class="modal-header">
          <h3>{{ selectedSearchType === 'rappresentante' ? 'Estratto Conto' : 'Estratto Conto Cliente' }}</h3>
          <button class="close-button" @click="closeEstrattoContoDialog">&times;</button>
        </div>
        <div class="modal-body">
          <div class="anno-selector-section">
            <label for="anno-selector" class="anno-label">
              <i class="pi pi-calendar"></i>
              Anno di partenza per le fatture:
            </label>
            <select id="anno-selector" v-model="selectedAnno" class="anno-select">
              <option value="">Tutti gli anni</option>
              <option v-for="anno in anniDisponibili" :key="anno" :value="anno">
                {{ anno }}
              </option>
            </select>
            <div class="anno-info">
              <small v-if="selectedAnno">
                Verranno incluse solo le fatture dal {{ selectedAnno }} in poi
              </small>
              <small v-else>
                Verranno incluse tutte le fatture disponibili
              </small>
            </div>
          </div>

          <div class="tipo-estratto-selector-section">
            <div class="estratto-filters-row">
              <div class="estratto-filter-col">
                <label for="tipo-estratto-selector" class="tipo-estratto-label">
                  <i class="pi pi-file-pdf"></i>
                  Tipo di estratto conto:
                </label>
                <select id="tipo-estratto-selector" v-model="selectedTipoEstratto" class="tipo-estratto-select">
                  <option value="da_saldare">Solo fatture da saldare</option>
                  <option value="completo">Estratto conto completo</option>
                  <option value="escludi_crediti">Escludi Crediti</option>
                </select>
                <div class="tipo-estratto-info">
                  <small v-if="selectedTipoEstratto === 'da_saldare'">
                    Verranno incluse solo le fatture con saldo da pagare
                  </small>
                  <small v-else-if="selectedTipoEstratto === 'completo'">
                    Verranno incluse tutte le fatture (saldate e da saldare)
                  </small>
                  <small v-else>
                    Verranno incluse tutte le fatture ma saranno esclusi i crediti
                  </small>
                </div>
              </div>

              <div class="estratto-filter-col">
                <label for="stato-fornitura-selector" class="tipo-estratto-label">
                  <i class="pi pi-bolt"></i>
                  Punti di fornitura:
                </label>
                <select
                  id="stato-fornitura-selector"
                  v-model="selectedStatoFornitura"
                  class="tipo-estratto-select"
                >
                  <option value="all_state">Tutti i punti</option>
                  <option value="attivi">Solo punti attivi</option>
                  <option value="cessati">Solo punti cessati</option>
                </select>
                <div class="tipo-estratto-info">
                  <small v-if="selectedStatoFornitura === 'all_state'">
                    Verranno incluse le fatture di tutti i POD/PDR
                  </small>
                  <small v-else-if="selectedStatoFornitura === 'attivi'">
                    Verranno incluse solo le fatture dei punti attivi
                  </small>
                  <small v-else>
                    Verranno incluse solo le fatture dei punti cessati
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div v-if="selectedSearchType === 'rappresentante'" class="estratto-section">
            <h4 class="section-subtitle">
              <i class="pi pi-users"></i>
              Estratto Conto Rappresentante
            </h4>
            <p class="section-description">
              Gestisci l'estratto conto generale del rappresentante <strong>{{ selectedUser.nome }}</strong>
            </p>
            <div class="estratto-actions">
              <button class="btn-secondary" @click="downloadEstrattoContoRappresentante">
                <i class="pi pi-download"></i> Scarica
              </button>
              <button class="btn-primary" @click="sendEstrattoContoEmailRappresentante">
                <i class="pi pi-send"></i> Invia Email
              </button>
            </div>
          </div>

          <div v-else class="estratto-section">
            <h4 class="section-subtitle">
              <i class="pi pi-user"></i>
              Estratto Conto Cliente
            </h4>
            <p class="section-description">
              Gestisci l'estratto conto del cliente <strong>{{ selectedUser.nome }} {{ selectedUser.cognome }} {{ selectedUser.ragsoc }}</strong>
            </p>
            <div v-if="pods && pods.length > 0" class="punto-selector-section">
              <label for="punto-selector" class="punto-selector-label">
                <i class="pi pi-bolt"></i>
                Seleziona POD/PDR (opzionale):
              </label>
              <select id="punto-selector" v-model="selectedPuntoId" class="punto-selector-select">
                <option :value="null">Tutti i punti</option>
                <option v-for="p in pods" :key="p.id" :value="p.id">
                  {{ (p.tipo_punto ? p.tipo_punto.toUpperCase() : 'PUNTO') }} - {{ p.code }}
                </option>
              </select>
              <div class="punto-selector-info">
                <small v-if="selectedPuntoId">
                  L'estratto conto verrà generato per il punto selezionato
                </small>
                <small v-else>
                  L'estratto conto verrà generato per l'intero cliente
                </small>
              </div>
            </div>
            <div class="estratto-actions">
              <button class="btn-secondary" @click="downloadEstrattoConto">
                <i class="pi pi-download"></i> Scarica
              </button>
              <button class="btn-primary" @click="sendEstrattoContoEmail">
                <i class="pi pi-send"></i> Invia Email
              </button>
            </div>
          </div>

          <div v-if="selectedSearchType === 'rappresentante' && getClientiRappresentante.length > 0" class="estratto-section">
            <div class="section-divider"></div>
            <h4 class="section-subtitle">
              <i class="pi pi-user"></i>
              Estratti Conto Clienti
            </h4>
            <p class="section-description">
              Gestisci gli estratti conto dei singoli clienti del rappresentante
            </p>
            
            <div class="clienti-list">
              <div v-for="cliente in getClientiRappresentante" :key="cliente.id" class="cliente-item">
                <div class="cliente-info">
                  <div class="cliente-name">{{ cliente.nome }}</div>
                  <div class="cliente-details">
                    <span class="cliente-id">ID: {{ cliente.id }}</span>
                    <span v-if="cliente.saldo" class="cliente-saldo">Saldo: € {{ formatCurrency(cliente.saldo) }}</span>
                    <span class="cliente-fatture">Fatture: {{ getFattureClienteByAnno(cliente.id).length }}</span>
                  </div>
                </div>
                <div class="cliente-actions">
                  <button class="btn-secondary btn-small" @click="downloadEstrattoContoCliente(cliente.id)">
                    <i class="pi pi-download"></i> Scarica
                  </button>
                  <button class="btn-primary btn-small" @click="sendEstrattoContoEmailCliente(cliente.id)">
                    <i class="pi pi-send"></i> Invia
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="selectedSearchType === 'rappresentante' && getClientiRappresentante.length === 0" class="estratto-section">
            <div class="section-divider"></div>
            <div class="no-clients-message">
              <i class="pi pi-info-circle"></i>
              <p>Nessun cliente trovato per questo rappresentante</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div v-if="showAggiungiDilazioneModal" class="modal-overlay" @click="closeAggiungiDilazioneModal">
      <div class="modal-content modal-extra-large" @click.stop>
        <div class="modal-header">
          <h3>Aggiungi Dilazione</h3>
          <button class="close-button" @click="closeAggiungiDilazioneModal">&times;</button>
        </div>
        <div class="modal-body">
          <AggiungiDilazione :data="fattureNumeri"/>
        </div>
      </div>
    </div> -->


    <div v-if="selectedUser.id" class="tables-container">
      <div v-if="supplyPointsForPratiche.length > 0" class="dilazioni-table-container mt-4">
        <div class="fatture-table-header">
          <h3 class="section-title">Pratiche</h3>
          <div class="table-actions">
            <button
              type="button"
              class="send-email-btn"
              @click="openPratichePdfDialog"
              :disabled="loadingPraticheFiles"
            >
              <i class="pi pi-spin pi-spinner" v-if="loadingPraticheFiles"></i>
              <i class="pi pi-file-pdf" v-else></i>
              PDF Pratiche
            </button>
          </div>
        </div>

        <SupplyPraticheSection
          :supply-points="supplyPointsForPratiche"
          :link-fornitori="true"
          :has-stato-column="true"
          :show-punto-column="supplyPointsForPratiche.length > 1"
          :show-richiesta-appuntamento="true"
          :show-rilascio-tutela="true"
        />
      </div>

      <div v-if="selectedUser.id && clientIdsForDilazioni.length > 0" class="dilazioni-table-container mt-4">
        <div class="fatture-table-header">
          <h3 class="section-title">Dilazioni</h3>
          <div class="table-actions">
            <Button class="add-dilazione-btn" @click="openAggiungiDilazioneModal" :disabled="!fattureInsolute || fattureInsolute.length === 0">
              <i class="pi pi-plus add-icon"></i>
              Aggiungi Dilazione
            </Button>
          </div>
        </div>
        
        <div v-if="loadingDilazioni" class="dilazioni-loader" style="display: flex; justify-content: center; align-items: center; padding: 2rem; background: white;">
          <div style="text-align: center;">
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem; color: #3388b3; margin-bottom: 1rem;"></i>
            <p style="color: #666; margin: 0;">Caricamento dilazioni...</p>
          </div>
        </div>
        
        <DilazioniAll 
          v-else
          :key="`dilazioni-${selectedUser.id}-${clientIdsForDilazioni.join('-')}-${dilazioniRefreshKey}`"
          :client-ids="clientIdsForDilazioni"
          :hide-controls="true"
        />
      </div>

      <IncallTicketsBlock
        v-if="ticketEntityId && selectedUser.entity_type"
        ref="ticketsBlock"
        :entity-id="ticketEntityId"
        :entity-type="selectedUser.entity_type"
        :contact="selectedUser"
        :related-clients="getClientiRappresentante"
      />
    </div>

    <div v-if="showPratichePdfDialog" class="modal-overlay" @click="closePratichePdfDialog">
      <div class="modal-content modal-medium pratiche-pdf-modal" @click.stop>
        <div class="modal-header">
          <h3>PDF Pratiche</h3>
          <button class="close-button" type="button" @click="closePratichePdfDialog">&times;</button>
        </div>
        <div class="modal-body">
          <div v-if="loadingPraticheFiles" class="pratiche-pdf-loading">
            <i class="pi pi-spin pi-spinner"></i>
            Caricamento elenco PDF...
          </div>

          <div v-else-if="pratichePdfGroups.length === 0" class="pratiche-pdf-empty">
            Nessun PDF pratica disponibile
          </div>

          <div v-else class="pratiche-pdf-list">
            <div
              v-for="group in pratichePdfGroups"
              :key="group.id"
              class="pratiche-pdf-group"
            >
              <div class="pratiche-pdf-group-title">
                <span>{{ getIncallPraticaDisplayName(group) }}</span>
                <small v-if="group.code">{{ group.code }}</small>
              </div>
              <div class="pratiche-pdf-files">
                <div
                  v-for="file in group.files"
                  :key="`${group.id}-${file.filename}`"
                  class="pratiche-pdf-file-row"
                  :class="{ 'is-missing': !file.exists }"
                >
                  <div class="pratiche-pdf-file-info">
                    <i :class="file.exists ? 'pi pi-file-pdf' : 'pi pi-ban'"></i>
                    <div class="pratiche-pdf-file-text">
                      <span class="pratiche-pdf-filename" :title="file.filename">{{ file.filename }}</span>
                      <div
                        v-if="file.signature"
                        class="pratiche-pdf-sign-status"
                        :class="`is-${file.signature.status}`"
                      >
                        <span class="pratiche-pdf-status-badge">{{ file.signature.status_label }}</span>
                        <small v-if="file.signature.status === 'signed' && file.signature.data_firma">
                          Firmato il {{ formatPraticaSignDate(file.signature.data_firma) }}
                        </small>
                        <small v-else-if="file.signature.data_invio">
                          Inviata il {{ formatPraticaSignDate(file.signature.data_invio) }}
                        </small>
                      </div>
                    </div>
                    <span v-if="!file.exists" class="pratiche-pdf-missing">Non disponibile</span>
                  </div>
                  <div v-if="file.exists" class="pratiche-pdf-file-actions">
                    <button
                      v-if="file.signature && file.signature.signed_available"
                      type="button"
                      class="pratiche-pdf-action-btn is-signed"
                      :disabled="!!downloadingSignedPraticaFile || sendingPraticaEmail || loadingPraticaPreview"
                      :title="`Scarica ${file.filename} firmato`"
                      @click="downloadSignedPraticaPdf(file.signature.cod_richiesta_firma)"
                    >
                      <i
                        :class="downloadingSignedPraticaFile === file.signature.cod_richiesta_firma
                          ? 'pi pi-spin pi-spinner'
                          : 'pi pi-check-circle'"
                      ></i>
                      Firmato
                    </button>
                    <button
                      v-if="file.form && file.form.fields && file.form.fields.length"
                      type="button"
                      class="pratiche-pdf-action-btn is-preview"
                      :disabled="!!downloadingPraticaFile || sendingPraticaEmail || loadingPraticaPreview"
                      :title="`Compila ${file.filename}`"
                      @click="openPraticaCompileDialog(file, group)"
                    >
                      <i class="pi pi-pencil"></i>
                      Compila
                    </button>
                    <button
                      type="button"
                      class="pratiche-pdf-action-btn"
                      :disabled="!!downloadingPraticaFile || sendingPraticaEmail || loadingPraticaPreview"
                      :title="`Scarica ${file.filename}`"
                      @click="downloadPraticaPdf(file)"
                    >
                      <i
                        :class="downloadingPraticaFile === file.filename
                          ? 'pi pi-spin pi-spinner'
                          : 'pi pi-download'"
                      ></i>
                      Scarica
                    </button>
                    <button
                      type="button"
                      class="pratiche-pdf-action-btn is-email"
                      :disabled="!!downloadingPraticaFile || sendingPraticaEmail || loadingPraticaPreview"
                      :title="`Invia ${file.filename} via email`"
                      @click="openPraticaEmailDialog(file, group)"
                    >
                      <i class="pi pi-envelope"></i>
                      Email
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-secondary" type="button" @click="closePratichePdfDialog">
            Chiudi
          </button>
        </div>
      </div>
    </div>

    <div v-if="showPraticaPdfPreviewDialog" class="modal-overlay" @click="closePraticaPdfPreviewDialog">
      <div class="modal-content modal-large pratiche-pdf-compile-modal" @click.stop>
        <div class="modal-header">
          <h3>Compila PDF — {{ praticaPdfPreviewFilename || 'Pratica' }}</h3>
          <button class="close-button" type="button" @click="closePraticaPdfPreviewDialog">&times;</button>
        </div>
        <div class="modal-body pratiche-pdf-compile-body">
          <div class="pratiche-pdf-compile-layout">
            <div class="pratiche-pdf-compile-form">
              <p class="pratiche-pdf-compile-hint">
                Compila i campi e poi clicca <strong>Aggiorna anteprima</strong> per vedere i dati sul PDF.
              </p>
              <div
                v-for="(block, blockIndex) in praticaCompileLayout"
                :key="block.id || `compile-block-${blockIndex}`"
                class="pratiche-pdf-compile-block"
                :class="`is-${block.type}`"
              >
                <div
                  v-if="block.type === 'radio-row'"
                  class="pratiche-pdf-compile-radio-row"
                >
                  <div
                    v-for="group in block.groups"
                    :key="group.id"
                    class="pratiche-pdf-compile-radio-group"
                  >
                    <span class="pratiche-pdf-compile-radio-title">{{ group.label }}</span>
                    <div
                      class="pratiche-pdf-compile-radio-options"
                      :class="{ 'is-column': group.orientation === 'column' }"
                    >
                      <label
                        v-for="option in group.options"
                        :key="option.key"
                        class="pratiche-pdf-compile-radio-option"
                      >
                        <input
                          type="radio"
                          :name="`pratica-radio-${group.id}`"
                          :value="option.key"
                          :checked="isPraticaRadioSelected(group, option.key)"
                          @change="setPraticaRadioValue(group, option.key)"
                        />
                        <span>{{ option.label }}</span>
                      </label>
                    </div>
                  </div>
                </div>

                <div
                  v-else-if="block.type === 'radio'"
                  class="pratiche-pdf-compile-radio-group"
                >
                  <span class="pratiche-pdf-compile-radio-title">{{ block.group.label }}</span>
                  <div
                    class="pratiche-pdf-compile-radio-options"
                    :class="{ 'is-column': block.group.orientation === 'column' }"
                  >
                    <label
                      v-for="option in block.group.options"
                      :key="option.key"
                      class="pratiche-pdf-compile-radio-option"
                    >
                      <input
                        type="radio"
                        :name="`pratica-radio-${block.group.id}`"
                        :value="option.key"
                        :checked="isPraticaRadioSelected(block.group, option.key)"
                        @change="setPraticaRadioValue(block.group, option.key)"
                      />
                      <span>{{ option.label }}</span>
                    </label>
                  </div>
                </div>

                <div
                  v-else
                  class="pratiche-pdf-compile-fields-row"
                  :class="{ 'is-checkboxes': block.allCheckboxes }"
                  :style="block.allCheckboxes ? {} : { gridTemplateColumns: block.columns }"
                >
                  <div
                    v-for="field in block.fields"
                    :key="field.key"
                    class="form-group"
                    :class="{ 'is-checkbox': field.type === 'checkbox' }"
                  >
                    <template v-if="field.type === 'checkbox'">
                      <input
                        :id="`pratica-field-${field.key}`"
                        v-model="praticaCompileValues[field.key]"
                        type="checkbox"
                        true-value="X"
                        false-value=""
                      />
                      <label :for="`pratica-field-${field.key}`">{{ field.label }}</label>
                    </template>
                    <template v-else>
                      <label :for="`pratica-field-${field.key}`">{{ field.label }}</label>
                      <textarea
                        v-if="field.type === 'textarea'"
                        :id="`pratica-field-${field.key}`"
                        v-model="praticaCompileValues[field.key]"
                        class="form-input"
                        rows="3"
                      ></textarea>
                      <input
                        v-else
                        :id="`pratica-field-${field.key}`"
                        v-model="praticaCompileValues[field.key]"
                        :type="field.type === 'email' ? 'email' : 'text'"
                        class="form-input"
                      />
                    </template>
                  </div>
                </div>
              </div>
              <button
                type="button"
                class="pratiche-pdf-action-btn is-preview pratiche-pdf-update-btn"
                :disabled="loadingPraticaPreview || !praticaCompileFile"
                @click="refreshPraticaCompilePreview"
              >
                <i :class="loadingPraticaPreview ? 'pi pi-spin pi-spinner' : 'pi pi-refresh'"></i>
                {{ loadingPraticaPreview ? 'Aggiornamento...' : 'Aggiorna anteprima' }}
              </button>
            </div>

            <div class="pratiche-pdf-compile-preview">
              <div class="pdf-preview-actions">
                <button
                  type="button"
                  class="pratiche-pdf-action-btn is-preview"
                  :disabled="loadingPraticaPreview || !praticaCompileFile"
                  @click="refreshPraticaCompilePreview"
                >
                  <i :class="loadingPraticaPreview ? 'pi pi-spin pi-spinner' : 'pi pi-refresh'"></i>
                  Aggiorna
                </button>
                <button
                  type="button"
                  class="pratiche-pdf-action-btn is-preview"
                  :disabled="!praticaPdfPreviewUrl || loadingPraticaPreview"
                  @click="openPraticaPdfPreviewInNewTab"
                >
                  <i class="pi pi-external-link"></i>
                  Apri
                </button>
                <button
                  type="button"
                  class="pratiche-pdf-action-btn"
                  :disabled="loadingPraticaPreview || !praticaCompileFile"
                  @click="downloadCompiledPraticaPdf"
                >
                  <i class="pi pi-download"></i>
                  Scarica
                </button>
                <button
                  type="button"
                  class="pratiche-pdf-action-btn is-email"
                  :disabled="loadingPraticaPreview || !praticaCompileFile"
                  @click="openEmailFromCompiledPratica"
                >
                  <i class="pi pi-envelope"></i>
                  Email
                </button>
              </div>

              <div v-if="loadingPraticaPreview" class="pratiche-pdf-loading">
                <i class="pi pi-spin pi-spinner"></i>
                Aggiornamento anteprima...
              </div>
              <div v-else-if="praticaPdfPreviewUrl" class="pdf-preview-frame">
                <iframe
                  :key="praticaPdfPreviewUrl"
                  :src="praticaPdfPreviewUrl"
                  title="Anteprima PDF compilato"
                ></iframe>
              </div>
              <div v-else class="pratiche-pdf-empty">
                Clicca <strong>Aggiorna anteprima</strong> per visualizzare il PDF compilato
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-secondary" type="button" @click="closePraticaPdfPreviewDialog">
            Chiudi
          </button>
        </div>
      </div>
    </div>

    <div v-if="showPraticaEmailDialog" class="modal-overlay" @click="closePraticaEmailDialog">
      <div class="modal-content modal-medium pratiche-pdf-email-modal" @click.stop>
        <div class="modal-header">
          <h3>Invia PDF pratica</h3>
          <button class="close-button" type="button" @click="closePraticaEmailDialog">&times;</button>
        </div>
        <div class="modal-body">
          <div class="info-message info-cliente" style="margin-bottom: 1rem;">
            <i class="pi pi-file-pdf"></i>
            Allegato: <strong>{{ praticaEmailForm.filename }}</strong>
          </div>

          <div class="form-group">
            <label>Tipo invio</label>
            <div class="pratiche-email-mode-options">
              <label class="pratiche-email-mode-option">
                <input
                  v-model="praticaEmailSendMode"
                  type="radio"
                  value="email"
                />
                Invia email
              </label>
              <label class="pratiche-email-mode-option">
                <input
                  v-model="praticaEmailSendMode"
                  type="radio"
                  value="otp"
                />
                Invia Email OTP
              </label>
            </div>
          </div>

          <div class="form-group">
            <label for="pratica-email-to">Destinatario</label>
            <input
              id="pratica-email-to"
              v-model="praticaEmailForm.email"
              type="email"
              class="form-input"
              placeholder="email@cliente.it"
            />
          </div>

          <template v-if="praticaEmailSendMode === 'otp'">
            <div class="form-group">
              <label for="pratica-email-nominativo">Nominativo firmatario</label>
              <input
                id="pratica-email-nominativo"
                v-model="praticaEmailForm.nominativo"
                type="text"
                class="form-input"
                placeholder="Nome e cognome"
              />
            </div>
            <div class="form-group">
              <label for="pratica-email-contatto">Cellulare OTP</label>
              <input
                id="pratica-email-contatto"
                v-model="praticaEmailForm.contatto"
                type="text"
                class="form-input"
                placeholder="3331234567"
              />
            </div>
          </template>

          <template v-if="praticaEmailSendMode === 'email'">
          <div class="form-group">
            <label for="pratica-email-subject">Oggetto</label>
            <input
              id="pratica-email-subject"
              v-model="praticaEmailForm.subject"
              type="text"
              class="form-input"
              placeholder="Oggetto email"
            />
          </div>

          <div class="form-group">
            <label for="pratica-email-body">Messaggio</label>
            <textarea
              id="pratica-email-body"
              v-model="praticaEmailForm.body"
              class="form-textarea"
              rows="8"
              placeholder="Contenuto email..."
            ></textarea>
          </div>
          </template>
        </div>
        <div class="modal-footer">
          <button class="btn-secondary" type="button" @click="closePraticaEmailDialog" :disabled="sendingPraticaEmail">
            Annulla
          </button>
          <button
            class="btn-primary"
            type="button"
            @click="submitPraticaEmailDialog"
            :disabled="sendingPraticaEmail || !canSendPraticaEmail"
          >
            <i class="pi pi-spin pi-spinner" v-if="sendingPraticaEmail"></i>
            <i :class="praticaEmailSendMode === 'otp' ? 'pi pi-shield' : 'pi pi-send'" v-else></i>
            {{
              sendingPraticaEmail
                ? 'Invio...'
                : (praticaEmailSendMode === 'otp' ? 'Invia Email OTP' : 'Invia email')
            }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="showBollettinoDialog" class="modal-overlay" @click="closeBollettinoDialog">
      <div class="modal-content modal-medium bollettino-modal" @click.stop>
        <div class="modal-header">
          <h3>Seleziona Fatture per Bollettini a Saldo</h3>
          <button class="close-button" @click="closeBollettinoDialog">&times;</button>
        </div>
        <div class="modal-body">
          <div class="bollettino-info">
            <p class="section-description">
              Seleziona le fatture per cui inviare o scaricare il bollettino postale a 
              <strong>{{ getContactDisplayName() }}</strong>
            </p>
            <div class="bollettino-saldo-notice">
              <i class="pi pi-info-circle"></i>
              <strong>Tutti i bollettini generati saranno a saldo.</strong>
            </div>
            <div class="bollettino-tipo-selector">
              <span class="bollettino-tipo-label">Composizione:</span>
              <label class="bollettino-tipo-option" for="bollettino-composizione-unico">
                <RadioButton
                  inputId="bollettino-composizione-unico"
                  name="composizione-bollettino"
                  v-model="bollettinoComposizione"
                  value="unico"
                />
                <span>Unico</span>
              </label>
              <label class="bollettino-tipo-option" for="bollettino-composizione-singoli">
                <RadioButton
                  inputId="bollettino-composizione-singoli"
                  name="composizione-bollettino"
                  v-model="bollettinoComposizione"
                  value="singoli"
                />
                <span>Singoli</span>
              </label>
            </div>
          </div>

          <div class="search-fatture-section">
            <div class="search-wrapper">
              <i class="pi pi-search search-icon"></i>
              <input 
                type="text" 
                v-model="searchFattureQuery" 
                placeholder="Cerca per numero fattura..." 
                class="search-input"
              />
              <button 
                v-if="searchFattureQuery" 
                @click="clearSearchFatture" 
                class="clear-search"
                title="Cancella ricerca"
              >
                <i class="pi pi-times"></i>
              </button>
            </div>
            <div v-if="searchFattureQuery" class="search-info">
              Trovate {{ filteredFatture.length }} fatture su {{ fattureInsolute.length }}
            </div>
          </div>

          <div class="fatture-selection">
            <div class="selection-header">
              <label class="select-all-label">
                <input 
                  type="checkbox" 
                  v-model="selectAllFatture"
                  @change="toggleSelectAllFatture"
                  :disabled="fattureSelezionabili.length === 0"
                  class="select-all-checkbox"
                />
                <span>
                  <template v-if="selectAllFatture">Deseleziona tutto</template>
                  <template v-else>
                    Seleziona tutte le fatture selezionabili
                    ({{ fattureSelezionabili.length }} su {{ filteredFatture.length }})
                  </template>
                </span>
              </label>
              <button
                v-if="fattureNonSelezionabili.length > 0"
                type="button"
                class="toggle-fatture-non-selezionabili"
                @click="showFattureNonSelezionabili = !showFattureNonSelezionabili"
              >
                <i :class="showFattureNonSelezionabili ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
                {{ showFattureNonSelezionabili ? 'Nascondi' : 'Mostra' }} non selezionabili
                ({{ fattureNonSelezionabili.length }})
              </button>
            </div>

            <div v-if="fattureVisibili.length > 0" class="fatture-list">
              <div 
                v-for="fattura in fattureVisibili"
                :key="fattura.fattura_id"
                class="fattura-item"
                :class="{
                  'selected': selectedFatture.includes(fattura.numero),
                  'disabled': !isFatturaSelezionabile(fattura)
                }"
              >
                <label class="fattura-checkbox">
                  <input 
                    type="checkbox" 
                    :value="fattura.numero"
                    v-model="selectedFatture"
                    class="fattura-checkbox-input"
                    :disabled="!isFatturaSelezionabile(fattura)"
                  />
                  <div class="fattura-info">
                    <div class="fattura-numero">
                      <strong>Fattura {{ fattura.numero }}</strong>
                    </div>
                    <div class="fattura-details">
                      <span class="fattura-data">Totale: € {{ formatCurrency(fattura.tot_fattura) }}</span>
                      <span class="fattura-data">Emissione: {{ formatDate(fattura.data_emissione) }}</span>
                      <span class="fattura-scadenza">Scadenza: {{ formatDate(fattura.data_scadenza_fattura) }}</span>
                      <span class="fattura-importo">Saldo: € {{ formatCurrency(fattura.saldo_fattura) }}</span>
                    </div>
                  </div>
                </label>
              </div>
            </div>

            <div v-else class="no-fatture-message">
              <i class="pi pi-info-circle"></i>
              <p v-if="searchFattureQuery && filteredFatture.length === 0">
                Nessuna fattura trovata per "{{ searchFattureQuery }}"
              </p>
              <p v-else-if="fattureNonSelezionabili.length > 0">
                Nessuna fattura selezionabile disponibile
              </p>
              <p v-else>Nessuna fattura insoluta disponibile</p>
            </div>
          </div>

          <div class="bollettino-actions">
            <button 
              class="btn-secondary" 
              @click="closeBollettinoDialog"
              :disabled="sendingBollettino"
            >
              Annulla
            </button>
            <button 
              class="btn-primary" 
              @click="sendBollettinoWithSelection"
              :disabled="selectedFatture.length === 0 || sendingBollettino"
            >
              <i class="pi pi-send"></i>
              Invia {{ bollettinoComposizione === 'unico' ? 'Bollettino unico' : 'Bollettini singoli' }} ({{ selectedFatture.length }})
              <span v-if="sendingBollettino" class="loader-spinner"></span>
            </button>
            <button 
              class="btn-secondary" 
              @click="downloadBollettinoZip"
              :disabled="selectedFatture.length === 0 || downloadingBollettino"
            >

            <i class="pi pi-download" v-if="!downloadingBollettino"></i>
              <i class="pi pi-spin pi-spinner" v-else></i>
              Scarica {{ bollettinoComposizione === 'unico' ? 'Bollettino unico' : 'Bollettini singoli' }} (ZIP)
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showBloccoCalamitaDialog" class="modal-overlay" @click="closeBloccoCalamitaDialog">
      <div class="modal-content modal-medium" @click.stop>
        <div class="modal-header">
          <h3>BLOCCO SOSPENSIONE CALAMITA'</h3>
          <button class="close-button" @click="closeBloccoCalamitaDialog">&times;</button>
        </div>
        <div class="modal-body">
          <div v-if="!puntiCalamita || puntiCalamita.length === 0" class="no-data-message">
            <i class="pi pi-info-circle"></i>
            <p>Nessun POD/PDR con ech = 1</p>
          </div>
          <div v-else class="fatture-table-wrapper">
            <table class="fatture-table">
              <thead>
                <tr>
                  <th class="col-pdp">CODICE PDR/POD</th>
                  <th class="col-stato">STATO</th>
                  <th class="col-cliente">CLIENTE</th>
                  <th class="col-cliente">CODICE CLIENTE</th>
                  <th class="col-indirizzo">INDIRIZZO</th>
                  <th class="col-importo">TOTALE INSOLUTO</th>
                  <th class="col-dataInserimento">DATA INSERIMENTO</th>
                  <th class="col-azioni">AZIONI</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="pdr in puntiCalamita" :key="pdr.code">
                  <td class="col-pdp">
                    <a
                      href="javascript:void(0)"
                      @click="navigateToPdpDetail(pdr.cod_pod, pdr.cod_pdr)"
                      class="table-link"
                    >
                      {{ pdr.code }}
                    </a>
                  </td>
                  <td class="col-stato">{{ pdr.stato }}</td>
                  <td class="col-cliente">
                    <a
                      href="javascript:void(0)"
                      @click="navigateToClienteDetail(selectedSearchType === 'rappresentante' ? pdr.cod_cliente_num : selectedUser.client_id)"
                      class="table-link"
                    >
                      {{ pdr.cliente_ragsoc }}
                    </a>
                  </td>
                  <td class="col-cliente">
                    <a
                      href="javascript:void(0)"
                      @click="navigateToClienteDetail(selectedSearchType === 'rappresentante' ? pdr.cod_cliente_num : selectedUser.client_id)"
                      class="table-link"
                    >
                      {{ pdr.cod_cliente }}
                    </a>
                  </td>
                  <td class="col-indirizzo">
                    <span class="truncate-text" :title="pdr.indirizzo_completo">
                      {{ pdr.indirizzo_completo }}
                    </span>
                  </td>
                  <td class="col-importo">€ {{ formatCurrency(pdr.totale_insoluto) }}</td>
                  <td class="col-dataInserimento">
                    <span v-if="calamitaDettagli[pdr.code] && calamitaDettagli[pdr.code].data_inserimento">
                      {{ formatDate(calamitaDettagli[pdr.code].data_inserimento) }}
                    </span>
                    <span v-else>-</span>
                  </td>
                  <td class="col-azioni">
                    <span v-if="calamitaCheckLoading[pdr.code]" class="upload-info text-muted">
                      Verifica...
                    </span>
                    <span v-else-if="calamitaDocumentoCaricato[pdr.code]" class="documento-gia-caricato">
                      DOCUMENTO GIA' CARICATO
                    </span>
                    <template v-else>
                      <input
                        type="file"
                        :id="`file-blocco-${pdr.code}`"
                        class="hidden-file-input"
                        accept="application/pdf,image/jpeg,image/jpg,image/png"
                        @change="onSelectBloccoFile(pdr, $event)"
                      />
                      <button
                        class="btn-secondary btn-small mb-1"
                        type="button"
                        @click="triggerBloccoFileInput(pdr.code)"
                      >
                        Carica documento
                      </button>
                      <div
                        v-if="calamitaUploads[pdr.code] && calamitaUploads[pdr.code].fileName"
                        class="upload-info"
                      >
                        <span class="file-name">
                          {{ calamitaUploads[pdr.code].fileName }}
                        </span>
                        <span
                          v-if="calamitaUploads[pdr.code].success"
                          class="upload-success"
                        >
                          Caricato
                        </span>
                        <span
                          v-if="calamitaUploads[pdr.code].error"
                          class="upload-error"
                        >
                          {{ calamitaUploads[pdr.code].error }}
                        </span>
                      </div>
                      <button
                        class="btn-primary btn-small"
                        type="button"
                        @click="confirmBloccoUpload(pdr)"
                        :disabled="
                          !calamitaUploads[pdr.code] ||
                          !calamitaUploads[pdr.code].file ||
                          calamitaUploads[pdr.code].uploading
                        "
                      >
                        <i
                          class="pi pi-spin pi-spinner"
                          v-if="calamitaUploads[pdr.code] && calamitaUploads[pdr.code].uploading"
                        ></i>
                        <span v-else>Conferma</span>
                      </button>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-secondary" @click="closeBloccoCalamitaDialog">
            <i class="pi pi-times"></i> Chiudi
          </button>
        </div>
      </div>
    </div>
    <div v-if="showCallNotesDialog" class="modal-overlay" @click="closeCallNotesDialog">
      <div class="modal-content modal-medium" @click.stop>
        <div class="modal-header">
          <h3>Prendi appunti</h3>
          <button class="close-button" @click="closeCallNotesDialog">&times;</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="call-notes">Appunti della chiamata</label>
            <textarea
              id="call-notes"
              v-model="callNotes"
              class="form-textarea"
              rows="8"
              placeholder="Scrivi qui gli appunti della chiamata..."
            ></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-secondary" @click="closeCallNotesDialog">
            Chiudi
          </button>
          <button class="btn-primary" @click="saveCallNotes" :disabled="savingCallNotes">
            <i class="pi pi-spin pi-spinner" v-if="savingCallNotes"></i>
            <i class="pi pi-save" v-else></i>
            {{ savingCallNotes ? 'Salvataggio...' : 'Salva' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import services from "@/config/services";
import IncallService from "@/services/ask-management/Incall-service";
import InvioEmail from "@/pages/ask/dialogs/operations/fatture-vendita/InvioEmail.vue";
import DilazioniAll from '@/components/ask/pages/dilazioni/All.vue';
import SupplyPraticheSection from '@/components/ask/details/SupplyPraticheSection.vue';
import IncallTicketsBlock from '@/components/incall/IncallTicketsBlock.vue'
import IncallOriginTicket from '@/components/incall/IncallOriginTicket.vue'
// import AggiungiDilazione from '@/pages/ask/dialogs/operations/fatture-vendita/AggiungiDilazione.vue';
import objMethodAggiungiDilazione from '@/config/mind-tab/tab-buttons/fatture-vendita/aggiungi-dilazione.js'

export default {
  name: 'Incall',
  components: {
    InvioEmail,
    DilazioniAll,
    SupplyPraticheSection,
    IncallTicketsBlock,
    IncallOriginTicket,
    // AggiungiDilazione,
  },

  data() {
    return {
      searchQueries: {
        pdp: '',  
        codiceCliente: '',
        numeroFattura: '',
        codiceFiscale: '',
        nome: ''
      },
      
      searchTimeouts: {
        pdp: null,
        codiceCliente: null,
        numeroFattura: null,
        codiceFiscale: null,
        nome: null
      },

      ticketSearchQuery: '',
      ticketSearchTimeout: null,

      searchSuggestions: [],
      showSearchSuggestions: false,
      activeSuggestionSearchType: null,
      searchSuggestionsTimeout: null,
      loadingSuggestions: false,

      showCallNotesDialog: false,
      callNotes: '',
      savingCallNotes: false,

      currentCallId: null,

      currentPage: 1,
      currentPageSystemTickets: 1,
      itemsPerPage: 10,
      loading: false,
      contratti: [],
      fatture: [],
      entityTypes: [],
      linkEntityType: '',
      entityOptions: [],
      selectedEntity: null,
      entitySearch: '',
      showEntityList: false,
      entitySearchTimeout: null,
      showTicketModal: false,
      showAddTicketModal: false,
      showActionModal: false,

      showRimandaModal: false,
      showDistaccaModal: false,
      showDilazioneModal: false,
      showInvioEmailModal: false,
      emailSending: false,
      loadingFatture: false,
      loadingEmailModal: false,
      sendingEstrattoConto: false,
      showEstrattoContoMessageModal: false,
      estrattoContoMessage: { type: 'success', title: '', message: '' },
      sendingBollettino: false,
      downloadingZip: false,
      downloadingBollettino: false,
      showBollettinoMessageModal: false,
      bollettinoMessage: { type: 'success', title: '', message: '' },
      showReclamoDialog: false,
      showReclamoLink: false,
      showEstrattoContoDialog: false,
      showBollettinoDialog: false,
      bollettinoIsSaldo: 1,
      bollettinoComposizione: 'singoli',
      showFattureNonSelezionabili: false,
      showBloccoCalamitaDialog: false,
      loadingTotali: false,
      showTotaliDialog: false,
      totaliData: null,
      selectedAnnoPartenza: '',
      selectedTipoEstrattoTotali: 'da_saldare',
      showQuietanzaDialog: false,
      showSelezioneFattureDialog: false,
      quietanzaData: null,
      selectedFattureQuietanza: [],
      processedQuietanzaData: [],
      selectedQuietanzeInline: [],
      downloadingQuietanza: false,
      showEmailBonariaDialog: false,
      selectedFattureEmailBonaria: [],
      sendingEmailBonaria: false,
      showCallDialog: false,
      showSmsDialog: false,
      showPratichePdfDialog: false,
      loadingPraticheFiles: false,
      pratichePdfGroups: [],
      downloadingPraticaFile: null,
      showPraticaEmailDialog: false,
      sendingPraticaEmail: false,
      showPraticaPdfPreviewDialog: false,
      loadingPraticaPreview: false,
      previewingPraticaFile: null,
      praticaPdfPreviewUrl: null,
      praticaPdfPreviewFilename: '',
      praticaCompileFile: null,
      praticaCompileGroup: null,
      praticaCompileFields: [],
      praticaCompileValues: {},
      praticaCompilePreviewTimeout: null,
      praticaEmailForm: {
        filename: '',
        praticaName: '',
        praticaCode: '',
        email: '',
        subject: '',
        body: '',
        nominativo: '',
        contatto: '',
        fields: null,
      },
      praticaEmailSendMode: 'email',
      downloadingSignedPraticaFile: null,
      sendingSms: false,
      smsTemplates: [],
      smsTemplatesCategories: [],
      categorySelected: '',
      selectedSmsTemplate: null,

      sortField: null,
      sortOrder: 'asc',

      clientIdsForDilazioni: [],

      selectedUser: {
        id: null,
        client_id: null,
        nome: '',
        cognome: '',
        importo: '',
        telefono: '',
        email: '',
        via: '',
        citta: '',
        codiceFiscale: '',
        pdp: '',
        pec: '',
        cap: '',
        agente_name: '',
        code_cliente: ''
      },

      selectedContatto: null,
      pods: [],
      clienti: [],
      selectedPuntoId: null,

      tickets: [],
      totalTickets: 0,
      selectedTicket: {},
      showTicketActionModal: false,
      ticketForAction: null,
      ticketModalMode: 'view',
      loadingTicketDetails: false,
      sendingTicketReply: false,
      ticketReplyMessage: '',
      ticketReplyCallTransferSuccess: null,
      ticketReplyCallTransferAreaId: null,
      ticketReplyStatusId: null,
      newTicket: {
        tipo: 'Ticket',
        tipoDestinatario: '',
        titolo: '',
        descrizione: '',
        priorita: 'media',
        stato: 'In Attesa',
        statusCode: 'opened',
        recipient: null,
        recipient_id: null,
        area_id: 1,
        is_related: false,
        motivazioneId: null,
        callTransferSuccess: null,
        callTransferAreaId: null,
      },

      searchClients: [],

      actionData: {
        action: '',
        note: '',
        continua: false
      },

      rimandaData: {
        note: '',
        dataRimando: ''
      },
      distaccaData: {
        note: ''
      },

      incallService: null,
      contextTicketId: null,
      contextTicket: null,
      loadingContextTicket: false,
      showContextTicket: true,
      pendingContextTicketMode: null,

      typesRecipients: [
        { name: 'agente', code: 'Agente' },
        { name: 'client', code: 'Cliente' },
        { name: 'rappresentante', code: 'Rappresentante' },
        { name: 'assicuratori', code: 'Assicuratore' },
        { name: 'user', code: 'User' },
        { name: 'area', code: 'Area User' },
      ],
      recipients: [], 
      ticketAreas: [], 
      ticketStatuses: [],
      motivazioniTicket: [], 

      recipientSearchQuery: '',
      showRecipientsList: false,
      recipientSearchTimeout: null,
      selectedSearchType: null,
      searchCollapsed: false,
      loadingDilazioni: false,
      showAggiungiDilazioneModal: false,
      selectedAnno: '',
      selectedTipoEstratto: 'da_saldare',
      selectedStatoFornitura: 'all_state',
      selectedStatoFornituraTotali: 'all_state', 
      dilazioniRefreshKey: 0,
      selectedFatture: [],
      searchFattureQuery: '',
      riattivandoPdr: false,
      pdrInPreview: new Set(),
      appuntamentiRiattivazioni: [],
      showAppuntamentoDialog: false,
      selectedAppuntamenti: [],
      selectedAppuntamentoPunto: null,
      loadingAppuntamentiRiattivazioni: false,
      lastAppuntamentiRequestKey: '',
      methodAggiungiDilazione: objMethodAggiungiDilazione,
      calamitaUploads: {},
      calamitaDocumentoCaricato: {},
      calamitaCheckLoading: {},
      calamitaDettagli: {},
      ticketModalDrag: { active: false, startX: 0, startY: 0, deltaX: 0, deltaY: 0 },
      unsubs: []
    }
  },

  computed: {
    praticaCompileLayout() {
      return this.buildPraticaCompileLayout(this.praticaCompileFields || [])
    },

    canSendPraticaEmail() {
      const email = (this.praticaEmailForm?.email || '').trim()
      const subject = (this.praticaEmailForm?.subject || '').trim()
      const body = (this.praticaEmailForm?.body || '').trim()
      const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
      const hasBase = !!(this.praticaEmailForm?.filename && emailValid)

      if (this.praticaEmailSendMode === 'otp') {
        const nominativo = (this.praticaEmailForm?.nominativo || '').trim()
        const contatto = (this.praticaEmailForm?.contatto || '').replace(/\D/g, '')
        return hasBase && !!nominativo && contatto.length >= 9 && contatto.length <= 10
      }

      return hasBase && !!subject && !!body
    },

    ticketEntityId() {
      if (!this.selectedUser?.id) return null
      if (this.selectedUser.entity_type === 'client' && this.selectedUser.client_id) {
        return this.selectedUser.client_id
      }
      return this.selectedUser.id
    },
    ticketModalPositionStyle() {
      const d = this.ticketModalDrag
      if (!d || (d.deltaX === 0 && d.deltaY === 0)) return {}
      return {
        transform: `translate(${d.deltaX}px, ${d.deltaY}px)`
      }
    },
    filteredTickets() {
      if (!this.ticketSearchQuery.trim()) {
        return this.tickets
      }

      const query = this.ticketSearchQuery.toLowerCase().trim()
      
      return this.tickets.filter(ticket => {
        const title = (ticket.title || ticket.titolo || '').toLowerCase()
        const status = (ticket.status || ticket.stato || '').toLowerCase()
        const recipient = (ticket.recipient_name || ticket.destinatario || '').toLowerCase()
        const tipo = (ticket.tipo || '').toLowerCase()
        
        return title.includes(query) || 
               status.includes(query) || 
               recipient.includes(query) ||
               tipo.includes(query)
      })
    },

    userTicketsCount() {
      return this.tickets.filter(ticket => !this.isSystemTicket(ticket)).length
    },

    systemTicketsCount() {
      return this.tickets.filter(ticket => this.isSystemTicket(ticket)).length
    },

    filteredUserTickets() {
      return this.filteredTickets.filter(ticket => !this.isSystemTicket(ticket))
    },

    filteredSystemTickets() {
      return this.filteredTickets.filter(ticket => this.isSystemTicket(ticket))
    },

    totalPagesUserTickets() {
      return Math.ceil(this.filteredUserTickets.length / this.itemsPerPage)
    },

    totalPagesSystemTickets() {
      return Math.ceil(this.filteredSystemTickets.length / this.itemsPerPage)
    },

    userTicketStartIndex() {
      if (this.filteredUserTickets.length === 0) return 0
      return (this.currentPage - 1) * this.itemsPerPage + 1
    },

    userTicketEndIndex() {
      return Math.min(this.currentPage * this.itemsPerPage, this.filteredUserTickets.length)
    },

    systemTicketStartIndex() {
      if (this.filteredSystemTickets.length === 0) return 0
      return (this.currentPageSystemTickets - 1) * this.itemsPerPage + 1
    },

    systemTicketEndIndex() {
      return Math.min(this.currentPageSystemTickets * this.itemsPerPage, this.filteredSystemTickets.length)
    },

    paginatedUserTickets() {
      if (this.filteredUserTickets.length === 0) return []
      const start = (this.currentPage - 1) * this.itemsPerPage
      const end = start + this.itemsPerPage
      return this.filteredUserTickets.slice(start, end)
    },

    paginatedSystemTickets() {
      if (this.filteredSystemTickets.length === 0) return []
      const start = (this.currentPageSystemTickets - 1) * this.itemsPerPage
      const end = start + this.itemsPerPage
      return this.filteredSystemTickets.slice(start, end)
    },

    selectedTicketMessages() {
      const messages = this.selectedTicket?.messages
      if (!messages || typeof messages !== 'object') return []

      const grouped = []
      Object.keys(messages).sort().forEach((date) => {
        const dayMessages = Array.isArray(messages[date]) ? messages[date] : []
        dayMessages.forEach((message) => {
          grouped.push({ ...message, date })
        })
      })
      return grouped
    },

    selectedTicketHistoryStatus() {
      return Array.isArray(this.selectedTicket?.history_status) ? this.selectedTicket.history_status : []
    },

    selectedTicketHistoryAssignment() {
      return Array.isArray(this.selectedTicket?.history_assignment) ? this.selectedTicket.history_assignment : []
    },

    currentUserId() {
      try {
        if (!this.$store?.state?.auth?.user) return null
        const user = JSON.parse(atob(this.$store.state.auth.user))
        return user?.user?.[0]?.id ?? null
      } catch {
        return null
      }
    },

    showTicketReplyForm() {
      return this.ticketModalMode === 'reply' && !this.isSystemTicket(this.selectedTicket)
    },

    canCreateTicket() {
      const hasMotivazione = !!this.newTicket.motivazioneId
      const hasTitolo = !!this.newTicket.titolo?.trim()
      const hasDescrizione = !!this.newTicket.descrizione?.trim()
      const contentOk = hasMotivazione || (hasTitolo && hasDescrizione)
      return this.newTicket.tipoDestinatario &&
        contentOk &&
        this.selectedUser.id &&
        this.newTicket.recipient
    },

    motivazioneTicketTesto() {
      if (!this.newTicket.motivazioneId) return ''
      const m = this.motivazioniTicket.find(x => String(x.id) === String(this.newTicket.motivazioneId))
      return m?.motivation || ''
    },

    today() {
      return new Date().toISOString().split('T')[0];
    },
    maxDate() {
      const date = new Date();
      date.setDate(date.getDate() + 15);
      return date.toISOString().split('T')[0];
    },

    hasActiveSearch() {
      return this.searchQueries.pdp
        || this.searchQueries.codiceCliente
        || this.searchQueries.numeroFattura
        || this.searchQueries.codiceFiscale
        || this.searchQueries.nome;
    },

    hasActiveTicketSearch() {
      return this.ticketSearchQuery.trim().length > 0;
    },

    activeSearchType() {
      if (this.searchQueries.pdp) return 'pdp'
      if (this.searchQueries.codiceCliente) return 'codiceCliente'
      if (this.searchQueries.numeroFattura) return 'numeroFattura'
      if (this.searchQueries.codiceFiscale) return 'codiceFiscale'  
      if (this.searchQueries.nome) return 'nome'
      return null
    },

    showPdpSearch() {
      return this.selectedSearchType === 'cliente' && (!this.activeSearchType || this.activeSearchType === 'pdp')
    },

    showCodiceClienteSearch() {
      return this.selectedSearchType === 'cliente' && (!this.activeSearchType || this.activeSearchType === 'codiceCliente')
    },

    showNumeroFatturaSearch() {
      return this.selectedSearchType === 'cliente' && (!this.activeSearchType || this.activeSearchType === 'numeroFattura')
    },

    showCodiceFiscaleSearch() {
      return !this.activeSearchType || this.activeSearchType === 'codiceFiscale'
    },

    showNomeSearch() {
      return !this.activeSearchType || this.activeSearchType === 'nome'
    },

    isSearchCollapsed() {
      return !!(this.searchCollapsed && this.selectedUser?.id && this.selectedSearchType)
    },

    activeSearchSummary() {
      const typeLabels = {
        pdp: 'PDP',
        codiceCliente: 'Codice Cliente',
        numeroFattura: 'Numero Fattura',
        codiceFiscale: 'Codice Fiscale',
        nome: 'Nome / Ragione Sociale',
      }
      const type = this.activeSearchType
      const value = type ? this.searchQueries[type] : ''
      if (!type || !value) {
        const name =
          this.selectedUser?.ragsoc ||
          [this.selectedUser?.cliente_nome, this.selectedUser?.cliente_cognome].filter(Boolean).join(' ') ||
          [this.selectedUser?.nome, this.selectedUser?.cognome].filter(Boolean).join(' ') ||
          this.selectedUser?.nome ||
          ''
        return name ? `Risultato: ${name}` : ''
      }
      return `${typeLabels[type] || type}: ${value}`
    },

    fattureInsolute() {
      const fatture = this.selectedUser.fatture_insolute || [];
      
      if (this.sortField === 'importo') {
        const sorted = [...fatture].sort((a, b) => {
          const importoA = parseFloat(a.saldo_fattura) || 0;
          const importoB = parseFloat(b.saldo_fattura) || 0;
          
          if (this.sortOrder === 'asc') {
            return importoA - importoB;
          } else {
            return importoB - importoA;
          }
        });
        return sorted;
      }
      
      return fatture;
    },

    puntiDiPrelievo() {
      if (!this.fattureInsolute || this.fattureInsolute.length === 0) {
        return [];
      }
      
      const pdrMap = new Map();
      
      this.fattureInsolute.forEach(fattura => {
        if (fattura.code && (fattura.cod_pod > 0 || fattura.cod_pdr > 0)) {
          const key = fattura.code;
          
          if (!pdrMap.has(key)) {
            pdrMap.set(key, {
              code: fattura.code,
              cod_pod: fattura.cod_pod || 0,
              cod_pdr: fattura.cod_pdr || 0,
              data_inizio: fattura.data_inizio || null,
              data_fine: fattura.data_fine || null,
              cliente_ragsoc: this.selectedSearchType === 'rappresentante' 
                ? (fattura.cliente_ragsoc || (fattura.cliente_nome && fattura.cliente_cognome ? fattura.cliente_nome + ' ' + fattura.cliente_cognome : fattura.cliente_nome || 'N/A'))
                : (this.selectedUser.ragsoc || (this.selectedUser.cliente_nome && this.selectedUser.cliente_cognome && (this.selectedUser.cliente_nome + ' ' + this.selectedUser.cliente_cognome))
                  || (this.selectedUser.nome && this.selectedUser.cognome && (this.selectedUser.nome + ' ' + this.selectedUser.cognome))
                  || this.selectedUser.cliente_nome 
                  || this.selectedUser.cliente_cognome 
                  || this.selectedUser.nome 
                  || this.selectedUser.cognome 
                  || '-'),
              cod_cliente: this.selectedSearchType === 'rappresentante' 
                ? (fattura.code_cliente || fattura.cod_cliente || '-')
                : (this.selectedUser.code_cliente || this.selectedUser.cod_cliente || '-'),
              cod_cliente_num: this.selectedSearchType === 'rappresentante' 
                ? fattura.cod_cliente
                : this.selectedUser.client_id,
              indirizzo_completo: this.selectedSearchType === 'rappresentante'
                ? (fattura.indirizzo_completo || '-')
                : (this.selectedUser.indirizzo_completo || this.selectedUser.via || '-'),
              fatture_count: 0,
              totale_insoluto: 0,
              stati: []
            });
          }
          
          const pdr = pdrMap.get(key);
          pdr.fatture_count++;
          pdr.totale_insoluto += parseFloat(fattura.saldo_fattura) || 0;
          if (!pdr.data_inizio && fattura.data_inizio) {
            pdr.data_inizio = fattura.data_inizio;
          }
          if (!pdr.data_fine && fattura.data_fine) {
            pdr.data_fine = fattura.data_fine;
          }
          if (fattura.type_state_name) {
            pdr.stati.push(fattura.type_state_name);
          }
        }
      });
      
      return Array.from(pdrMap.values()).map(pdr => {
        const statiCount = {};
        pdr.stati.forEach(stato => {
          statiCount[stato] = (statiCount[stato] || 0) + 1;
        });
        
        const statoMostFrequent = Object.keys(statiCount).reduce((a, b) => 
          statiCount[a] > statiCount[b] ? a : b, 
          pdr.stati[0] || 'N/A'
        );
        
        return {
          ...pdr,
          stato: statoMostFrequent,
          inPreview: this.pdrInPreview.has(pdr.code)
        };
      }).sort((a, b) => a.code.localeCompare(b.code));
    },

    puntiCalamita() {
      if (!this.fattureInsolute || this.fattureInsolute.length === 0) {
        return [];
      }

      const pdrMap = new Map();

      this.fattureInsolute.forEach(fattura => {
        if (
          Number(fattura.ech) === 1 &&
          fattura.code &&
          (fattura.cod_pod > 0 || fattura.cod_pdr > 0)
        ) {
          const key = fattura.code;

          if (!pdrMap.has(key)) {
            pdrMap.set(key, {
              code: fattura.code,
              cod_pod: fattura.cod_pod || 0,
              cod_pdr: fattura.cod_pdr || 0,
              cliente_ragsoc: this.selectedSearchType === 'rappresentante' 
                ? (fattura.cliente_ragsoc || (fattura.cliente_nome && fattura.cliente_cognome ? fattura.cliente_nome + ' ' + fattura.cliente_cognome : fattura.cliente_nome || 'N/A'))
                : (this.selectedUser.ragsoc || (this.selectedUser.cliente_nome && this.selectedUser.cliente_cognome && (this.selectedUser.cliente_nome + ' ' + this.selectedUser.cliente_cognome))
                  || (this.selectedUser.nome && this.selectedUser.cognome && (this.selectedUser.nome + ' ' + this.selectedUser.cognome))
                  || this.selectedUser.cliente_nome 
                  || this.selectedUser.cliente_cognome 
                  || this.selectedUser.nome 
                  || this.selectedUser.cognome 
                  || '-'),
              cod_cliente: this.selectedSearchType === 'rappresentante' 
                ? (fattura.code_cliente || fattura.cod_cliente || '-')
                : (this.selectedUser.code_cliente || this.selectedUser.cod_cliente || '-'),
              cod_cliente_num: this.selectedSearchType === 'rappresentante' 
                ? fattura.cod_cliente
                : this.selectedUser.client_id,
              indirizzo_completo: this.selectedSearchType === 'rappresentante'
                ? (fattura.indirizzo_completo || '-')
                : (this.selectedUser.indirizzo_completo || this.selectedUser.via || '-'),
              fatture_count: 0,
              totale_insoluto: 0,
              stati: []
            });
          }

          const pdr = pdrMap.get(key);
          pdr.fatture_count++;
          pdr.totale_insoluto += parseFloat(fattura.saldo_fattura) || 0;
          if (fattura.type_state_name) {
            pdr.stati.push(fattura.type_state_name);
          }
        }
      });

      return Array.from(pdrMap.values()).map(pdr => {
        const statiCount = {};
        pdr.stati.forEach(stato => {
          statiCount[stato] = (statiCount[stato] || 0) + 1;
        });

        const statoMostFrequent = Object.keys(statiCount).reduce((a, b) =>
          statiCount[a] > statiCount[b] ? a : b,
          pdr.stati[0] || 'N/A'
        );

        return {
          ...pdr,
          stato: statoMostFrequent,
          inPreview: this.pdrInPreview.has(pdr.code)
        };
      }).sort((a, b) => a.code.localeCompare(b.code));
    },

    hasRiattivablePdr() {
      return this.puntiDiPrelievo.some(pdr => this.shouldShowRiattivaButton(pdr.stato));
    },

    emailFattureData() {
      if (!this.fattureInsolute || this.fattureInsolute.length === 0) {
        return [];
      }

      const data = this.fattureInsolute.map(fattura => {
        const isRappresentante = this.selectedUser.entity_type === 'rappresentante' || this.selectedSearchType === 'rappresentante';

        const ragsoc = isRappresentante 
          ? this.selectedUser.nome || this.selectedUser.ragsoc || 'Rappresentante'
          : (this.selectedUser.ragsoc || `${this.selectedUser.nome} ${this.selectedUser.cognome}`.trim());
        
        const email = this.selectedUser.email || '';

        return {
          ragsoc: ragsoc,
          email: email,
          numero: fattura.numero,
          data_emissione: fattura.data_emissione || null,
          data_invio_cliente: fattura.data_invio_cliente || null,
          fattura_id: fattura.fattura_id,
          mese_fatturazione: fattura.mese_fatturazione || this.getMeseFatturazione(fattura.data_emissione),
          data_scadenza: fattura.data_scadenza_fattura,
          data_invio_preavviso: fattura.data_invio_preavviso || null,
          importo: fattura.saldo_fattura,
          token: fattura.token,
          is_rappresentante: isRappresentante
        };
      });

      return data;
    },

    totaleInsoluto() {
      if (!this.fattureInsolute || this.fattureInsolute.length === 0) {
        return 0
      }
      
      return this.fattureInsolute.reduce((totale, fattura) => {
        return totale + (parseFloat(fattura.saldo_fattura) || 0)
      }, 0)
    },

    supplyPointsForPratiche() {
      const points = [];
      const seen = new Set();

      const pushPoint = (id, type, code) => {
        const normalizedType = this.detectPraticaSupplyType(type, code)
        const normalizedCode = this.normalizePraticaSupplyCode(code)
        const key = `${normalizedType}-${id || normalizedCode}`
        if (!normalizedCode || seen.has(key)) {
          return
        }
        seen.add(key)
        points.push({
          id: id || null,
          type: normalizedType,
          code: normalizedCode,
        })
      }

      ;(this.pods || []).forEach((pod) => {
        pushPoint(pod.id, pod.tipo_punto, pod.code)
      })

      ;(this.puntiDiPrelievo || []).forEach((punto) => {
        if (Number(punto.cod_pod) > 0) {
          pushPoint(punto.cod_pod, 'pod', punto.code)
        }
        if (Number(punto.cod_pdr) > 0) {
          pushPoint(punto.cod_pdr, 'pdr', punto.code)
        }
      })

      const userPdp = this.normalizePraticaSupplyCode(
        this.selectedUser?.pdp || this.selectedUser?.pod || this.selectedUser?.pdr || ''
      )
      if (userPdp) {
        pushPoint(null, null, userPdp)
      }

      return points
    },

    getClientIdsForDilazioni() {
      if (!this.selectedUser) {
        return [];
      }
      
      if (this.selectedSearchType === 'rappresentante' && this.selectedUser.id) {
        if (this.fattureInsolute && this.fattureInsolute.length > 0) {
          const rawIds = this.fattureInsolute
            .map(fattura => fattura.cod_cliente)
            .filter(id => id && !isNaN(id));

          const clientIds = Array.from(new Set(
            rawIds.map(id => Number(id)).filter(id => id > 0)
          )).sort((a, b) => a - b);
          
          if (clientIds.length > 0) {
            return clientIds;
          }
        }
    
        return [];
      }
      
      if (this.selectedUser.client_id && this.selectedUser.client_id > 0) {
        return [this.selectedUser.client_id];
      } else if (this.selectedUser.id && this.selectedUser.id > 0) {
        return [this.selectedUser.id];
      } else if (this.selectedUser.rappresentante_id && this.selectedUser.rappresentante_id > 0) {
        return [this.selectedUser.rappresentante_id];
      } else {
        return [];
      }
    },

    fattureNumeri() {
      if (!this.fattureInsolute || this.fattureInsolute.length === 0) {
        return [];
      }
      return this.fattureInsolute.map(fattura => fattura.numero).filter(numero => numero);
    },

    getClientiRappresentante() {
      if (this.selectedSearchType !== 'rappresentante' || !this.selectedUser.id) {
        return [];
      }
      
      if (this.fattureInsolute && this.fattureInsolute.length > 0) {
        const clientiMap = new Map();
        
        this.fattureInsolute.forEach(fattura => {
          if (fattura.cod_cliente && fattura.cod_cliente > 0) {
            const clienteId = fattura.cod_cliente;
            
            if (!clientiMap.has(clienteId)) {
              clientiMap.set(clienteId, {
                id: clienteId,
                nome: fattura.cliente_ragsoc || 
                      (fattura.cliente_nome && fattura.cliente_cognome ? 
                       `${fattura.cliente_nome} ${fattura.cliente_cognome}` : 
                       fattura.cliente_nome || 'Cliente ' + clienteId),
                saldo: 0
              });
            }
            
            const cliente = clientiMap.get(clienteId);
            cliente.saldo += parseFloat(fattura.saldo_fattura) || 0;
          }
        });
        
        return Array.from(clientiMap.values()).sort((a, b) => a.nome.localeCompare(b.nome));
      }
      
      return [];
    },

    anniDisponibili() {
      if (!this.fattureInsolute || this.fattureInsolute.length === 0) {
        return [];
      }
      
      const anni = new Set();
      this.fattureInsolute.forEach(fattura => {
        if (fattura.data_emissione) {
          const dataEmissione = new Date(fattura.data_emissione);
          if (!isNaN(dataEmissione.getTime())) {
            anni.add(dataEmissione.getFullYear());
          }
        }
      });
      
      return Array.from(anni).sort((a, b) => b - a); 
    },

    anniDisponibiliTotali() {
      const currentYear = new Date().getFullYear();
      const anni = [];
      for (let year = currentYear; year >= currentYear - 10; year--) {
        anni.push(year);
      }
      return anni;
    },

    fattureFiltratePerAnno() {
      if (!this.fattureInsolute || this.fattureInsolute.length === 0) {
        return [];
      }
      
      if (!this.selectedAnno) {
        return this.fattureInsolute;
      }
      
      const annoSelezionato = parseInt(this.selectedAnno);
      
      return this.fattureInsolute.filter(fattura => {
        if (!fattura.data_emissione) {
          return false;
        }
        
        const dataEmissione = new Date(fattura.data_emissione);
        if (isNaN(dataEmissione.getTime())) {
          return false;
        }
        
        const annoFattura = dataEmissione.getFullYear();
        const include = annoFattura >= annoSelezionato;
        
        return include;
      });
    },

    fattureSelezionabili() {
      return this.filteredFatture.filter(fattura => this.isFatturaSelezionabile(fattura));
    },

    fattureNonSelezionabili() {
      return this.filteredFatture.filter(fattura => !this.isFatturaSelezionabile(fattura));
    },

    fattureVisibili() {
      return this.showFattureNonSelezionabili
        ? this.filteredFatture
        : this.fattureSelezionabili;
    },

    selectAllFatture: {
      get() {
        return this.fattureSelezionabili.length > 0
          && this.fattureSelezionabili.every(fattura => this.selectedFatture.includes(fattura.numero));
      },
      set(value) {
        if (value) {
          this.selectedFatture = this.fattureSelezionabili.map(fattura => fattura.numero);
        } else {
          this.selectedFatture = [];
        }
      }
    },

    filteredFatture() {
      const query = this.searchFattureQuery.toLowerCase().trim();
      const fatture = query
        ? this.fattureInsolute.filter(fattura => {
          const numero = fattura.numero.toLowerCase();
          return numero.includes(query);
        })
        : [...this.fattureInsolute];

      return fatture.sort((fatturaA, fatturaB) => {
        return Number(this.isFatturaSelezionabile(fatturaB))
          - Number(this.isFatturaSelezionabile(fatturaA));
      });
    }
  },

  watch: {
    'selectedUser.id': {
      handler(newId, oldId) {
        if (newId && newId !== oldId) {
          this.startDilazioniLoading();
          this.searchCollapsed = true
        }
        if (!newId) {
          this.clearAppuntamentiRiattivazioni()
          this.searchCollapsed = false
        }
      },
      immediate: false
    },

    puntiDiPrelievo: {
      handler(punti) {
        this.loadAppuntamentiRiattivazioni(punti)
      },
      immediate: true
    },
    
    getClientIdsForDilazioni: {
      handler(newClientIds) {
        const normalizedNew = Array.isArray(newClientIds) ? newClientIds : [];
        const normalizedCurrent = Array.isArray(this.clientIdsForDilazioni) ? this.clientIdsForDilazioni : [];

        if (JSON.stringify(normalizedNew) !== JSON.stringify(normalizedCurrent)) {
          this.clientIdsForDilazioni = normalizedNew;
          this.startDilazioniLoading();
        }
      },
      immediate: false
    }
  },

  async mounted() {
    this.incallService = new IncallService(this.$http, this.$eventBus)
    await this.loadTicketOptions()
    this.initFromQuery()
    this.loadAppuntamentiRiattivazioni(this.puntiDiPrelievo)

    const handler = () => {
      this.dilazioniRefreshKey += 1
    }

    this.$eventBus.on('incall:refresh-dilazioni', handler)
    this.unsubs.push(() => this.$eventBus.off('incall:refresh-dilazioni', handler))
  },

  beforeUnmount() {
    this.$eventBus.off('email-sent', this.handleEmailSent)
    this.unsubs.forEach((fn) => fn())
  },

  methods: {
    sortBy(field) {
      if (this.sortField === field) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortField = field;
        this.sortOrder = 'asc';
      }
    },

    shouldShowRiattivaButton(stato) {
      const statiAttivi = ['Attiva', 'Riattivazione richiesta','Riattivazione in lavorazione'];
      return !statiAttivi.includes(stato);
    },

    async riattivaPdr(pdr) {
      try {
        this.riattivandoPdr = true;
        
        const items = [{
          type_fornitura: pdr.cod_pod > 0 ? 'pod' : 'pdr',
          id_pod: pdr.cod_pod > 0 ? pdr.cod_pod : 0,
          id_pdr: pdr.cod_pdr > 0 ? pdr.cod_pdr : 0
        }];

        const result = await this.incallService.createRiattivazione(items);
        
        if (result.success) {
          
          this.pdrInPreview.add(pdr.code);
          
          if (this.$toast) {
            this.$toast.add({ 
              severity: 'success', 
              summary: 'Successo', 
              detail: result.msg || 'Riattivazione creata con successo', 
              life: 3000 
            });
          }
        }
      } catch (error) {
        if (this.$toast) {
          this.$toast.add({ 
            severity: 'error', 
            summary: 'Errore', 
            detail: 'Errore nella creazione della riattivazione', 
            life: 3000 
          });
        }
      } finally {
        this.riattivandoPdr = false;
      }
    },

    initFromQuery() {
      try {
        const q = this.$route && this.$route.query ? this.$route.query : {}
        if (!q) {
          return
        }

        if (q.ticket_id) {
          this.contextTicketId = String(q.ticket_id)
          this.showContextTicket = true
          this.loadContextTicket(this.contextTicketId)
        }

        if (!q.search_type || !q.q) {
          return
        }

        const queryValue = String(q.q).trim()
        if (!queryValue) {
          return
        }

        if (q.search_type === 'rappresentante') {
          this.selectedSearchType = 'rappresentante'
          if (q.search_by === 'id') {
            this.loadRappresentanteById(queryValue)
          } else {
            this.searchQueries.nome = queryValue
            this.performSearch('nome', queryValue)
          }
          return
        }

        if (q.search_type === 'cliente') {
          this.selectedSearchType = 'cliente'
          if (q.search_by === 'id') {
            this.loadClienteById(queryValue)
            return
          }
          const searchBy = q.search_by === 'codiceCliente' ? 'codiceCliente' : 'nome'
          this.searchQueries[searchBy] = queryValue
          this.performSearch(searchBy, queryValue)
        }
      } catch (e) {
        // noop
      }
    },

    async loadClienteById(clienteId) {
      if (!clienteId) return

      this.selectedSearchType = 'cliente'
      this.loading = true

      try {
        if (!this.incallService) {
          this.incallService = new IncallService(this.$http, this.$eventBus)
        }

        const response = await this.searchByCodiceCliente(String(clienteId))
        const results = this.getSearchResultsFromResponse(response)
        const match = results.find((item) =>
          String(item.client_id) === String(clienteId)
        )

        if (match) {
          this.searchQueries.codiceCliente = match.code_cliente || String(clienteId)
          await this.applySearchSelection(match, 'codiceCliente')
          return
        }

        this.searchClients = []
        this.resetData()

        if (this.$notify) {
          this.$notify.info({
            title: 'Info',
            message: `Nessun cliente trovato con id ${clienteId}`
          })
        }
      } catch (e) {
        this.handleApiError(e, 'Errore nel caricamento del cliente')
      } finally {
        this.loading = false
      }
    },

    async loadRappresentanteById(rappresentanteId) {
      if (!rappresentanteId) return

      this.selectedSearchType = 'rappresentante'
      this.loading = true

      try {
        if (!this.incallService) {
          this.incallService = new IncallService(this.$http, this.$eventBus)
        }

        const response = await this.searchByNomeRagioneSociale(String(rappresentanteId))
        const responseData = response?.items

        if (responseData?.success && Array.isArray(responseData.data) && responseData.data.length > 0) {
          const match = responseData.data.find((item) =>
            String(item.id) === String(rappresentanteId)
            || String(item.rappresentante_id) === String(rappresentanteId)
          ) || responseData.data[0]

          this.searchClients = responseData.data
          this.searchQueries.nome = match.nome || match.display_name || match.ragsoc || String(rappresentanteId)
          this.populateSelectedUserFromRappresentanteData(match)

          const dettaglioId = match.rappresentante_id || match.id || rappresentanteId
          await this.loadDettaglioContatto(dettaglioId, match.fatture_insolute, match)

          this.selectedUser = {
            ...this.selectedUser,
            id: match.id || match.rappresentante_id || this.selectedUser.id,
            nome: match.nome || match.display_name || match.ragsoc || this.selectedUser.nome,
            entity_type: 'rappresentante',
            fatture_insolute: match.fatture_insolute || this.selectedUser.fatture_insolute || [],
          }
          return
        }

        await this.loadDettaglioContatto(rappresentanteId)
      } catch (e) {
        this.handleApiError(e, 'Errore nel caricamento del rappresentante')
      } finally {
        this.loading = false
      }
    },

    readOriginTicketFromStorage(ticketId) {
      try {
        const raw = sessionStorage.getItem('incall_origin_ticket')
        if (!raw) return null
        const parsed = JSON.parse(raw)
        sessionStorage.removeItem('incall_origin_ticket')
        if (!parsed) return null
        const parsedId = parsed.id_ticket ?? parsed.id
        if (ticketId && parsedId != null && String(parsedId) !== String(ticketId)) {
          return null
        }
        return parsed
      } catch (e) {
        return null
      }
    },

    hasTicketMessages(ticket) {
      if (!ticket || !ticket.messages) return false
      if (Array.isArray(ticket.messages)) return ticket.messages.length > 0
      if (typeof ticket.messages === 'object') {
        return Object.keys(ticket.messages).some((key) => {
          const day = ticket.messages[key]
          return Array.isArray(day) && day.length > 0
        })
      }
      return false
    },

    async loadContextTicket(ticketId) {
      if (!ticketId) return

      this.loadingContextTicket = true
      try {
        const fromStorage = this.readOriginTicketFromStorage(ticketId)
        let ticket = fromStorage
          ? { ...fromStorage, id_ticket: fromStorage.id_ticket ?? fromStorage.id ?? ticketId }
          : { id_ticket: ticketId }

        this.contextTicket = ticket

        if (!this.incallService) {
          this.incallService = new IncallService(this.$http, this.$eventBus)
        }

        if (!this.hasTicketMessages(ticket)) {
          const { item } = await this.incallService.getTicketDetails(ticket)
          if (item) {
            this.contextTicket = { ...ticket, ...item }
          }
        }
      } catch (e) {
        if (!this.contextTicket) {
          this.contextTicket = { id_ticket: ticketId, title: `Ticket #${ticketId}` }
        }
      } finally {
        this.loadingContextTicket = false
      }
    },

    dismissContextTicket() {
      this.showContextTicket = false
    },

    async openContextTicket(mode = 'view') {
      if (!this.contextTicket) return

      this.pendingContextTicketMode = mode
      await this.$nextTick()

      const block = this.$refs.ticketsBlock
      if (block && typeof block.openTicket === 'function') {
        block.openTicket(this.contextTicket, mode)
        this.pendingContextTicketMode = null
        return
      }

      // Il blocco ticket potrebbe non essere ancora montato: riprova a breve
      setTimeout(() => {
        const retryBlock = this.$refs.ticketsBlock
        if (retryBlock && typeof retryBlock.openTicket === 'function' && this.pendingContextTicketMode) {
          retryBlock.openTicket(this.contextTicket, this.pendingContextTicketMode)
          this.pendingContextTicketMode = null
        }
      }, 600)
    },
    async onToggleIsRelated() {
      if (this.newTicket.is_related) {
        try {
          const res = await this.incallService.getTypesEntity()
          this.entityTypes = res.items || []
        } catch (e) {
          this.entityTypes = []
        }
      } else {
        this.linkEntityType = ''
        this.entityOptions = []
        this.selectedEntity = null
        this.entitySearch = ''
        this.showEntityList = false
      }
    },

    async onChangeEntityType() {
      this.selectedEntity = null
      this.entitySearch = ''
      this.entityOptions = []
      if (!this.linkEntityType) return
      await this.loadEntityOptions()
    },

    async loadEntityOptions() {
      if (!this.linkEntityType) return
      try {
        const { items } = await this.incallService.getTicketEntity(
          this.entitySearch || '',
          this.linkEntityType,
          { limit: 10, offset: 0 }
        )
        this.entityOptions = Array.isArray(items) ? items : []
        this.showEntityList = true
      } catch (e) {
        this.entityOptions = []
        this.showEntityList = false
      }
    },

    onSearchEntity() {
      if (this.entitySearchTimeout) clearTimeout(this.entitySearchTimeout)
      this.entitySearchTimeout = setTimeout(() => {
        this.loadEntityOptions()
      }, 300)
    },

    selectEntity(opt) {
      this.selectedEntity = { id: (opt.value || opt.id), label: (opt.label || opt.name || opt.code || opt.numero), type: opt.type }
      this.entitySearch = this.selectedEntity.label
      this.showEntityList = false
    },
    async searchContatti(params = {}) {
      return await this.incallService.searchContatti(params.search, params.limit)
    },

    async searchByCodiceFiscale(codiceFiscale) {
      return await this.incallService.searchByCodiceFiscale(codiceFiscale, this.selectedSearchType)
    },

    async searchByCodiceCliente(codiceCliente) {
      return await this.incallService.searchByCodiceCliente(codiceCliente)
    },

    async searchByNumeroFattura(numeroFattura) {
      return await this.incallService.searchByNumeroFattura(numeroFattura)
    },

    populateSelectedUserFromCodiceFiscaleData(cfData) {
      this.loadingFatture = true
      
      
      const isRappresentante = cfData.entity_type === 'rappresentante'
      const rappresentanteId = cfData.rappresentante_id || (isRappresentante ? cfData.id : null)
      
      this.selectedUser = {
        id: isRappresentante ? (rappresentanteId || cfData.id) : cfData.id,
        rappresentante_id: rappresentanteId || null,
        client_id: cfData.client_id || this.selectedUser.client_id || null,
        nome: cfData.nome || cfData.cliente_nome || '',
        cognome: cfData.cognome || '',
        ragsoc: cfData.ragsoc || '',
        telefono: cfData.telefono || 'Non disponibile',
        email: cfData.email || 'Non disponibile', 
        pec: cfData.pec || 'Non disponibile',
        via: cfData.indirizzo_completo || cfData.via || 'Non disponibile',
        cap: cfData.cap || 'Non disponibile',
        citta: 'N/D', 
        codiceFiscale: cfData.codfis || cfData.codiceFiscale || 'Non disponibile',
        pdp: cfData.pod_code || cfData.pdp || 'Non disponibile',
        
        importo: cfData.totale_saldo_fatture || 0,
        
        totale_fatturato: cfData.totale_fatturato || cfData.totale_fatturato_pod || 0,
        totale_pagato: cfData.totale_pagato || cfData.totale_pagato_pod || 0,
        consumo_annuo: cfData.consumo_annuo || 0,
        
        entity_type: cfData.entity_type || 'client',
        is_rappresentante: isRappresentante,
        code_cliente: cfData.code_cliente || cfData.cod_cliente || this.selectedUser.code_cliente || '',
        agente_name: cfData.agente_name || this.selectedUser.agente_name || '',

        fatture_insolute: cfData.fatture_insolute || []
      }


      if (cfData.pod_code && cfData.pod_id) {
        this.pods = [{
          id: cfData.pod_id,
          code: cfData.pod_code,
          saldoUltimoMese: cfData.saldoUltimoMese || 0,
          totale_fatturato_pod: cfData.totale_fatturato_pod || 0,
          totale_pagato_pod: cfData.totale_pagato_pod || 0,
          consumo_annuo: cfData.consumo_annuo || 0
        }]
      } else {
        this.pods = []
      }

      if (cfData.client_id || cfData.rappresentante_id) {
        this.clienti = [{
          id: cfData.client_id || cfData.rappresentante_id,
          nome: cfData.nome || '',
          cognome: cfData.cognome || '',
          ragsoc: cfData.ragsoc || '',
          email: cfData.email || '',
          pec: cfData.pec || '',
          entity_type: cfData.entity_type
        }]
      } else {
        this.clienti = []
      }

      setTimeout(() => {
        this.loadingFatture = false
      }, 500)
    },

    async getDettaglioContatto(contattoId) {
      if (this.selectedSearchType === 'rappresentante') {
        return await this.incallService.getContattoRappresentante(contattoId)
      } else {
        return await this.incallService.getDettaglioContatto(contattoId)
      }
    },

    async callBackendDirect(url, params = null) {
      let fullUrl = url
      if (params) {
        const queryString = new URLSearchParams(params).toString()
        fullUrl = `${url}?${queryString}`
      }

      const response = await fetch(fullUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',

          ...(this.$http?.defaults?.headers?.common?.Authorization && {
            'Authorization': this.$http.defaults.headers.common.Authorization
          })
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`)
      }

      const data = await response.json()
      return { data } 
    },

    handleSearch(searchType) {
      if (this.searchTimeouts[searchType]) {
        clearTimeout(this.searchTimeouts[searchType])
      }
      this.clearOtherSearches(searchType)
      this.handleSearchAutocomplete(searchType)
    },

    clearOtherSearches(activeSearchType) {
      Object.keys(this.searchQueries).forEach(type => {
        if (type !== activeSearchType) {
          this.searchQueries[type] = ''
          if (this.searchTimeouts[type]) {
            clearTimeout(this.searchTimeouts[type])
          }
        }
      })

      if (this.activeSuggestionSearchType !== activeSearchType) {
        this.showSearchSuggestions = false
        this.searchSuggestions = []
        this.activeSuggestionSearchType = activeSearchType
      }
    },

    showSuggestionsFor(searchType) {
      return this.showSearchSuggestions
        && this.activeSuggestionSearchType === searchType
        && this.searchQueries[searchType].trim().length >= 2
    },

    getSuggestionPrimaryLabel(label) {
      return String(label || '').split(' - ')[0]
    },

    getSuggestionSecondaryLabel(label) {
      const parts = String(label || '').split(' - ')
      return parts.length > 1 ? parts.slice(1).join(' - ') : ''
    },

    async fetchSearchResults(searchType, query) {
      switch (searchType) {
        case 'pdp':
          return await this.searchByPDP(query)
        case 'codiceCliente':
          return await this.searchByCodiceCliente(query)
        case 'numeroFattura':
          return await this.searchByNumeroFattura(query)
        case 'codiceFiscale':
          return await this.searchByCodiceFiscale(query)
        case 'nome':
          return await this.searchByNomeRagioneSociale(query)
        default:
          return null
      }
    },

    getSearchResultsFromResponse(response) {
      const responseData = response?.items || response?.item || response?.data
      if (responseData?.success && Array.isArray(responseData.data)) {
        return responseData.data
      }
      return []
    },

    buildSearchSuggestion(item, searchType) {
      return {
        id: (searchType === 'numeroFattura' && item.numero_fattura)
          ? item.numero_fattura
          : (item.id || item.contatto_id || item.client_id || item.pdp_id || item.rappresentante_id || item.code || item.code_cliente),
        label: this.formatSuggestionLabel(item, searchType),
        data: item,
      }
    },

    async handleSearchAutocomplete(searchType) {
      const query = this.searchQueries[searchType].trim()
      this.activeSuggestionSearchType = searchType

      if (this.searchSuggestionsTimeout) {
        clearTimeout(this.searchSuggestionsTimeout)
      }

      if (query.length < 2) {
        this.showSearchSuggestions = false
        this.searchSuggestions = []
        if (query.length === 0) {
          this.resetData()
        }
        return
      }

      this.loadingSuggestions = true

      this.searchSuggestionsTimeout = setTimeout(async () => {
        try {
          const response = await this.fetchSearchResults(searchType, query)
          const results = this.getSearchResultsFromResponse(response)

          if (results.length > 0) {
            this.searchClients = results
            this.searchSuggestions = results.map((item) => this.buildSearchSuggestion(item, searchType))
            this.showSearchSuggestions = true
          } else {
            this.searchClients = []
            this.searchSuggestions = []
            this.showSearchSuggestions = true
          }
        } catch (error) {
          this.searchSuggestions = []
          this.showSearchSuggestions = false
        } finally {
          this.loadingSuggestions = false
        }
      }, 300)
    },

    getDettaglioIdFromSearchItem(item, searchType) {
      if (this.selectedSearchType === 'rappresentante') {
        return item.rappresentante_id || item.id || null
      }

      if (searchType === 'codiceCliente') {
        return item.id || item.contatto_id || null
      }

      return item.contatto_id || item.id || null
    },

    async applySearchSelection(item, searchType) {
      this.searchClients = [item]

      if (searchType === 'pdp') {
        this.populateSelectedUserFromPDPData(item)
        await this.loadDettaglioContatto(item.contatto_id, this.selectedUser.fatture_insolute, item)
        return
      }

      if (searchType === 'codiceCliente') {
        this.populateSelectedUserFromCodiceFiscaleData(item)
        await this.loadDettaglioContatto(
          this.getDettaglioIdFromSearchItem(item, searchType),
          this.selectedUser.fatture_insolute,
          item
        )
        return
      }

      if (searchType === 'numeroFattura') {
        this.populateSelectedUserFromCodiceFiscaleData(item)
        await this.loadDettaglioContatto(
          this.getDettaglioIdFromSearchItem(item, searchType),
          this.selectedUser.fatture_insolute,
          item
        )
        return
      }

      if (searchType === 'codiceFiscale') {
        this.populateSelectedUserFromCodiceFiscaleData(item)
        await this.loadDettaglioContatto(
          this.getDettaglioIdFromSearchItem(item, searchType),
          this.selectedUser.fatture_insolute,
          item
        )
        return
      }

      if (searchType === 'nome') {
        if (this.selectedSearchType === 'rappresentante') {
          this.selectedUser = {
            id: item.rappresentante_id || item.id,
            rappresentante_id: item.rappresentante_id || item.id,
            nome: item.nome || item.ragsoc || item.display_name || '',
            email: item.email || '',
            pec: item.pec || '',
            telefono: item.telefono || 'Non disponibile',
            codiceFiscale: item.codiceFiscale || item.codfis || '',
            entity_type: 'rappresentante',
            fatture_insolute: item.fatture_insolute || [],
          }
        } else {
          this.selectedUser = {
            id: item.id,
            client_id: item.client_id,
            nome: item.nome || item.ragsoc || item.display_name || '',
            email: item.email || '',
            pec: item.pec || '',
            telefono: item.telefono || 'Non disponibile',
            codiceFiscale: item.codiceFiscale || item.codfis || '',
            entity_type: 'client',
            fatture_insolute: item.fatture_insolute || [],
          }
        }

        await this.loadDettaglioContatto(
          this.getDettaglioIdFromSearchItem(item, searchType),
          item.fatture_insolute,
          item
        )
      }
    },

    async performSearch(searchType, query) {
      this.loading = true
      try {
        const response = await this.fetchSearchResults(searchType, query)
        const results = this.getSearchResultsFromResponse(response)

        if (results.length > 0) {
          await this.applySearchSelection(results[0], searchType)
        } else {
          this.searchClients = []
          this.resetData()

          if (this.$notify) {
            this.$notify.info({
              title: 'Info',
              message: `Nessun contatto trovato per la ricerca ${searchType.toUpperCase()}`
            })
          }
        }
      } catch (error) {
        this.handleApiError(error, `Errore nella ricerca per ${searchType}`)
      } finally {
        this.loading = false
      }
    },

    async searchByPDP(pdpCode) {
      return await this.incallService.searchByPDP(pdpCode)
    },

    populateSelectedUserFromPDPData(pdpData) {
      
      this.loadingFatture = true
      
      this.selectedUser = {
        id: pdpData.client_id || pdpData.pdp_id || pdpData.id, 
        client_id: pdpData.client_id,
        cliente_nome: pdpData.cliente_nome || '',
        cliente_cognome: pdpData.cliente_cognome || '',
        nome: pdpData.cliente_nome || '',
        cognome: pdpData.cliente_cognome || '',
       // ragsoc: pdpData.cliente_nome || '', 
        telefono: pdpData.telefono || 'Non disponibile',
        email: pdpData.email || 'Non disponibile', 
        pec: pdpData.pec || 'Non disponibile',
        via: pdpData.indirizzo_completo || 'Non disponibile',
        indirizzo_completo: pdpData.indirizzo_completo || 'Non disponibile',
        cap: pdpData.cap || 'Non disponibile',
        citta: 'N/D',
        codiceFiscale: 'N/D',
        pdp: pdpData.code || 'Non disponibile',
        agente_name: pdpData.agente_name || 'Non disponibile',
        code_cliente: pdpData.code_cliente || 'Non disponibile',
        importo: pdpData.saldoUltimoMese || 0,
        
        totale_fatturato: pdpData.totale_fatturato || 0,
        totale_pagato: pdpData.totale_pagato || 0,
        consumo_annuo: pdpData.consumo_annuo || 0,
        
        entity_type: 'client', 
        fatture_insolute: pdpData.fatture_insolute || []
      }

      this.pods = [{
        id: pdpData.pdp_id || pdpData.id,
        code: pdpData.code,
        saldoUltimoMese: pdpData.saldoUltimoMese || 0,
        totale_fatturato: pdpData.totale_fatturato || 0,
        totale_pagato: pdpData.totale_pagato || 0,
        consumo_annuo: pdpData.consumo_annuo || 0
      }]

      setTimeout(() => {
        this.loadingFatture = false
      }, 500)
    },
    formatCurrency(amount) {
      return new Intl.NumberFormat('it-IT', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount || 0)
    },

    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      return date.toLocaleDateString('it-IT')
    },

    formatDateTime(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      if (Number.isNaN(date.getTime())) return String(dateStr)
      return date.toLocaleString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },

    clearAppuntamentiRiattivazioni() {
      this.appuntamentiRiattivazioni = []
      this.lastAppuntamentiRequestKey = ''
      this.showAppuntamentoDialog = false
      this.selectedAppuntamenti = []
      this.selectedAppuntamentoPunto = null
    },

    buildAppuntamentiPayload(punti = []) {
      return {
        punti: (punti || []).map((pdr) => {
          const isPod = Number(pdr.cod_pod) > 0
          return {
            supply_type: isPod ? 'pod' : 'pdr',
            supply_id: isPod ? Number(pdr.cod_pod) : Number(pdr.cod_pdr),
            supply_code: pdr.code,
          }
        }).filter((p) => p.supply_code || p.supply_id > 0),
      }
    },

    async loadAppuntamentiRiattivazioni(punti = []) {
      if (!this.incallService) return

      const list = Array.isArray(punti) ? punti : []
      if (!list.length) {
        this.clearAppuntamentiRiattivazioni()
        return
      }

      const payload = this.buildAppuntamentiPayload(list)
      const requestKey = JSON.stringify(payload)
      if (requestKey === this.lastAppuntamentiRequestKey) return

      this.lastAppuntamentiRequestKey = requestKey
      this.loadingAppuntamentiRiattivazioni = true

      try {
        const res = await this.incallService.getAppuntamentiRiattivazioni(payload)
        const data = Array.isArray(res?.data) ? res.data : []
        this.appuntamentiRiattivazioni = data
      } catch (error) {
        this.appuntamentiRiattivazioni = []
        console.error('Errore nel recupero appuntamenti riattivazioni:', error)
      } finally {
        this.loadingAppuntamentiRiattivazioni = false
      }
    },

    getAppuntamentiForPunto(pdr) {
      if (!pdr || !this.appuntamentiRiattivazioni?.length) return []

      const code = String(pdr.code || '')
      const isPod = Number(pdr.cod_pod) > 0
      const supplyId = isPod ? Number(pdr.cod_pod) : Number(pdr.cod_pdr)
      const supplyType = isPod ? 'pod' : 'pdr'

      return this.appuntamentiRiattivazioni.filter((app) => {
        const appCode = String(app.supply_code || '')
        if (code && appCode && appCode === code) return true

        return (
          String(app.supply_type || '').toLowerCase() === supplyType &&
          Number(app.supply_id) === supplyId &&
          supplyId > 0
        )
      })
    },

    hasAppuntamentoRiattivazione(pdr) {
      return this.getAppuntamentiForPunto(pdr).length > 0
    },

    openAppuntamentoDialog(pdr) {
      this.selectedAppuntamentoPunto = pdr
      this.selectedAppuntamenti = this.getAppuntamentiForPunto(pdr)
      this.showAppuntamentoDialog = true
    },

    closeAppuntamentoDialog() {
      this.showAppuntamentoDialog = false
      this.selectedAppuntamenti = []
      this.selectedAppuntamentoPunto = null
    },

    handleApiError(error, defaultMessage = 'Errore imprevisto') {
      const message = error.message || defaultMessage

      if (this.$notify) {
        this.$notify.error({
          title: 'Errore',
          message: message
        })
      } else if (this.$message) {
        this.$message.error(message)
      } else {
        alert(message)
      }
    },

    async loadDettaglioContatto(contattoId, fattureInsoluteFromSearch = null, mainData = null) {
      const resolvedId = Number(contattoId)
      if (!Number.isFinite(resolvedId) || resolvedId <= 0) {
        this.handleApiError(
          new Error('ID dettaglio contatto non valido'),
          'ID dettaglio contatto non valido'
        )
        return
      }

      this.loadingFatture = true
      

      try {
        const response = await this.getDettaglioContatto(resolvedId)
        
        const responseData = response.item || response.data;
        
        if (responseData && responseData.success && responseData.data) {
          const data = responseData.data

          if (this.selectedSearchType === 'rappresentante') {
            const rapp = (data.rappresentanti && data.rappresentanti.length > 0) ? data.rappresentanti[0] : null;
            this.selectedUser = {
              id: rapp ? rapp.id : data.contatto.id,
              nome: rapp ? rapp.name : '',
              email: rapp ? rapp.email : data.contatto.email || '',
              pec: rapp ? rapp.pec : data.contatto.pec || '',
              codiceFiscale: rapp ? rapp.codfis : '',
              telefono: data.contatto.telefono || data.contatto.tel || data.contatto.cell || 'Non disponibile',
              entity_type: 'rappresentante',
              fatture_insolute: this.selectedUser.fatture_insolute || [],
              indirizzo: data.contatto.indirizzo_completo || '',
              agente_name: data.contatto.agente_name || 'Non disponibile',
              code_cliente: data.contatto.code_cliente || 'Non disponibile',
              privilegiato: (data.clienti && data.clienti.length > 0) ? data.clienti[0].privilegiato : null,
            }
          } else {
            const base = mainData || {}
            
            const existingClientId = this.selectedUser.client_id

            this.selectedUser = {
              id: base.id || data.contatto.id,
              client_id: existingClientId || (data.clienti.length > 0 ? data.clienti[0].id : null),
              cliente_nome: base.cliente_nome || (data.clienti.length > 0 ? (data.clienti[0].cliente_nome || data.clienti[0].nome) : ''),
              cliente_cognome: base.cliente_cognome || (data.clienti.length > 0 ? (data.clienti[0].cliente_cognome || data.clienti[0].cognome) : ''),
              nome: base.cliente_nome || base.nome || (data.clienti.length > 0 ? data.clienti[0].nome : ''),
              cognome: base.cliente_cognome || base.cognome || (data.clienti.length > 0 ? data.clienti[0].cognome : ''),
              telefono: base.telefono || base.cell || data.contatto.telefono || data.contatto.cell || 'Non disponibile',
              email: base.email || data.contatto.email || 'Non disponibile',
              pec: base.pec || data.contatto.pec || 'Non disponibile',
              via: base.indirizzo_completo || base.via || data.contatto.indirizzo_completo || 'Non disponibile',
              cap: base.cap || data.contatto.cap || 'Non disponibile',
              citta: base.citta || (data.clienti.length > 0 ? data.clienti[0].citta : 'Non disponibile'),
              codiceFiscale: (base.codfis && base.codfis.trim()) 
                || (base.codiceFiscale && base.codiceFiscale.trim()) 
                || (data.clienti.length > 0 ? data.clienti[0].codiceFiscale || data.contatto.codiceFiscale : 'Non disponibile'),
              pdp: base.pod_code || base.pdp || (data.pods.length > 0 ? data.pods[0].code : 'Non disponibile'),
              importo: base.importo || data.saldo_totale || 0,
              entity_type: base.entity_type || 'client',
              agente_name: base.agente_name || data.contatto.agente_name || 'Non disponibile',
              code_cliente: base.code_cliente || data.contatto.code_cliente || 'Non disponibile',
              fatture_insolute: base.fatture_insolute || data.fatture_insolute || fattureInsoluteFromSearch || [],
              privilegiato: (data.clienti && data.clienti.length > 0) ? data.clienti[0].privilegiato : null,
            }
            this.pods = Array.isArray(data.pods) ? data.pods : []
            
          }
        } else {
          // Risposta non valida dal server
        }
      } catch (error) {
        this.handleApiError(error, 'Errore nel caricamento dei dettagli contatto')
      } finally {
        setTimeout(() => {
          this.loadingFatture = false
        }, 500)
      }
    },

    

    resetData() {
      this.selectedContatto = null
      this.pods = []
      this.clienti = []
      this.searchClients = []
      this.tickets = []
      this.totalTickets = 0
      this.loadingFatture = false
      this.clearAppuntamentiRiattivazioni()
      this.selectedUser = {
        id: null,
        client_id: null,
        nome: '',
        cognome: '',
        importo: '',
        telefono: '',
        email: '',
        via: '',
        citta: '',
        codiceFiscale: '',
        pdp: '',
        pec: '',
        cap: '',
        agente_name: '',
        code_cliente: ''
      }
    },

    async loadTicketOptions() {
      try {
        const areasResponse = await this.incallService.getTypesAreaTicket()
        if (areasResponse.items) {
          this.ticketAreas = areasResponse.items
        }

        const statusResponse = await this.incallService.getStatus()
        if (statusResponse.items) {
          this.ticketStatuses = statusResponse.items
        }

        const motivazioniResponse = await this.incallService.getMotivationTicket()
        if (motivazioniResponse.items && Array.isArray(motivazioniResponse.items)) {
          this.motivazioniTicket = motivazioniResponse.items
        }

      } catch (error) {
        // Errore caricamento opzioni ticket
      }
    },

    async loadAllTickets() {
      try {
        
        let response;
        
        if (this.selectedUser.id && this.selectedUser.entity_type) {
          let userId = this.selectedUser.id;
          if (this.selectedUser.entity_type === 'client' && this.selectedUser.client_id) {
            userId = this.selectedUser.client_id;
          }
          
          response = await this.getUserTickets(userId, this.selectedUser.entity_type)
        } else {
          response = await this.incallService.getTickets()
        }

        let tickets = []
        if (response.success && response.data && Array.isArray(response.data)) {
          tickets = response.data
        } else if (response.items && response.items.success && response.items.data && Array.isArray(response.items.data)) {
          tickets = response.items.data
        } else if (response.items && Array.isArray(response.items)) {
          tickets = response.items
        } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
          tickets = response.data.data
        } else if (response.data && Array.isArray(response.data)) {
          tickets = response.data
        }

        this.tickets = tickets
        this.totalTickets = tickets.length
        this.currentPage = 1
        this.currentPageSystemTickets = 1
        this.ticketSearchQuery = ''
        
      } catch (error) {
        this.tickets = []
        this.totalTickets = 0
      }
    },

    async getUserTickets(userId, userType) {
      let targetUserType = userType
      if (userId.toString().startsWith('rappresentante_')) {
        targetUserType = 'rappresentante'
        userId = userId.replace('rappresentante_', '')
      } else if (userType === 'client' || !userType) {
        targetUserType = 'client'
      }

      return await this.incallService.getUserTickets(userId, targetUserType)
    },

    async createTicketDirect(ticketData) {
      if (this.backendConfig) {
        const endpoint = this.backendConfig.endpoint.replace('/search/contatti', '/ticket/create')
        const url = `${this.backendConfig.baseUrl}${endpoint}`
        
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...(this.$http?.defaults?.headers?.common?.Authorization && {
              'Authorization': this.$http.defaults.headers.common.Authorization
            })
          },
          body: JSON.stringify({ ticket: ticketData })
        })

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`)
        }

        const data = await response.json()
        return data
      }

      const response = await this.$http.post(`${services.ask_pratiche.url}/incall/ticket/create`, {
        ticket: ticketData
      })
      
      return response.data
    },

    async onChangeTypeRecipient() {
      this.newTicket.recipient = null
      this.recipients = []
      this.recipientSearchQuery = ''
      this.showRecipientsList = false

      if (this.recipientSearchTimeout) {
        clearTimeout(this.recipientSearchTimeout)
      }

      if (this.newTicket.tipoDestinatario && this.newTicket.tipoDestinatario !== 'area') {
        try {
          const response = await this.incallService.getTicketRecipients('', this.newTicket.tipoDestinatario)
          this.recipients = response.items || []
        } catch (error) {
          this.recipients = []
          // Errore nel caricamento dei destinatari
        }
      }
    },

    getEntityOptions(entityType) {
      switch (entityType) {
        case 'pod':
          return this.pods || []
        case 'contratto':
          return this.contratti || []
        case 'fattura':
          return this.fatture || []
        default:
          return []
      }
    },

    getEntityLabel(item, entityType) {
      switch (entityType) {
        case 'pod':
          return item.code || item.id
        case 'contratto':
          return item.numero || item.id
        case 'fattura':
          return item.numero || item.id
        default:
          return item.id
      }
    },


    async handleDilaziona() {
      if (!this.selectedUser.id) {
        this.handleApiError({ message: 'Seleziona prima un contatto' })
        return
      }
      this.showDilazioneModal = true
    },

    closeDilazioneModal() {
      this.showDilazioneModal = false
    },

    async confermaDilazione() {
      try {

        if (this.$notify) {
          this.$notify.success({
            title: 'Successo',
            message: `Dilazione creata per ${this.selectedUser.nome} ${this.selectedUser.cognome}`
          })
        } else {
          alert(`Dilazione creata per ${this.selectedUser.nome} ${this.selectedUser.cognome}`)
        }

        this.closeDilazioneModal()
      } catch (error) {
        this.handleApiError(error, 'Errore nella creazione della dilazione')
      }
    },

    async handleRimanda() {
      if (!this.selectedUser.id) {
        this.handleApiError({ message: 'Seleziona prima un contatto' })
        return
      }
      this.showRimandaModal = true
    },

    closeRimandaModal() {
      this.showRimandaModal = false
      this.rimandaData = { note: '', dataRimando: '' }
    },

    async confermaRimanda() {
      try {

        if (this.$notify) {
          this.$notify.success({
            title: 'Successo',
            message: `Rimando impostato per ${this.selectedUser.nome} ${this.selectedUser.cognome}`
          })
        } else {
          alert(`Rimando impostato per ${this.selectedUser.nome} ${this.selectedUser.cognome}`)
        }

        this.closeRimandaModal()
      } catch (error) {
        // Errore rimando
        this.handleApiError(error, 'Errore nell\'impostazione del rimando')
      }
    },

    async handleDistacca() {
      if (!this.selectedUser.id) {
        this.handleApiError({ message: 'Seleziona prima un contatto' })
        return
      }
      this.showDistaccaModal = true
    },

    closeDistaccaModal() {
      this.showDistaccaModal = false
      this.distaccaData = { note: '' }
    },

    async confermaDistacca() {
      try {

        if (this.$notify) {
          this.$notify.success({
            title: 'Successo',
            message: `Distacco registrato per ${this.selectedUser.nome} ${this.selectedUser.cognome}`
          })
        } else {
          alert(`Distacco registrato per ${this.selectedUser.nome} ${this.selectedUser.cognome}`)
        }

        this.closeDistaccaModal()
      } catch (error) {
        // Errore distacco
        this.handleApiError(error, 'Errore nella registrazione del distacco')
      }
    },


    openTicketActions(ticket) {
      this.ticketForAction = ticket
      this.showTicketActionModal = true
    },

    closeTicketActionModal() {
      this.showTicketActionModal = false
      this.ticketForAction = null
    },

    selectTicketAction(mode) {
      const ticket = this.ticketForAction
      this.closeTicketActionModal()
      if (ticket) {
        this.openTicket(ticket, mode)
      }
    },

    async openTicket(ticket, mode = 'view') {
      this.selectedTicket = { ...ticket }
      this.ticketModalMode = mode
      this.resetTicketReplyForm()
      this.showTicketModal = true

      if (!this.ticketHasEmbeddedDetails(ticket)) {
        await this.loadSelectedTicketDetails(ticket)
      } else {
        this.$nextTick(() => this.scrollTicketMessagesToBottom())
      }

      if (mode === 'reply') {
        this.initTicketReplyStatus(this.selectedTicket)
      }
    },

    ticketHasEmbeddedDetails(ticket) {
      if (!ticket) return false
      const hasMessages = ticket.messages && typeof ticket.messages === 'object' && Object.keys(ticket.messages).length > 0
      const hasHistory = Array.isArray(ticket.history_status) && ticket.history_status.length > 0
      return hasMessages || hasHistory
    },

    syncSelectedTicketFromList() {
      const ticketId = this.getTicketId(this.selectedTicket)
      if (!ticketId) return

      const updatedTicket = this.tickets.find((ticket) => this.getTicketId(ticket) === ticketId)
      if (updatedTicket) {
        this.selectedTicket = { ...updatedTicket }
      }
    },

    async loadSelectedTicketDetails(ticket) {
      this.loadingTicketDetails = true
      try {
        const { item } = await this.incallService.getTicketDetails(ticket)
        if (item) {
          this.selectedTicket = { ...ticket, ...item }
          if (this.ticketModalMode === 'reply') {
            this.initTicketReplyStatus(this.selectedTicket)
          }
        }
      } catch (error) {
        this.handleApiError(error, 'Errore nel caricamento della conversazione')
      } finally {
        this.loadingTicketDetails = false
        this.$nextTick(() => this.scrollTicketMessagesToBottom())
      }
    },

    getTicketId(ticket) {
      return ticket?.id_ticket ?? ticket?.id ?? null
    },

    isOwnTicketMessage(message) {
      return this.currentUserId != null && message?.id_user == this.currentUserId
    },

    parseTicketDate(value) {
      if (!value) return null
      const normalized = String(value).includes('T') ? value : String(value).replace(' ', 'T')
      const date = new Date(normalized)
      return Number.isNaN(date.getTime()) ? null : date
    },

    formatTicketMessageTime(message) {
      const value = message?.datetime || message?.date
      const date = this.parseTicketDate(value)
      if (!date) return value || ''
      return date.toLocaleString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },

    formatTicketHistoryDate(value) {
      const date = this.parseTicketDate(value)
      if (!date) return value || 'N/A'
      return date.toLocaleString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },

    getTicketMessageSender(message) {
      return message?.sender || message?.name || this.selectedTicket?.creator_name || this.selectedTicket?.creator || 'Sistema'
    },

    getCallTransferSuccess(item) {
      if (!item) return null

      if (item.call_transfer_success !== undefined && item.call_transfer_success !== null && item.call_transfer_success !== '') {
        return item.call_transfer_success === true
          || item.call_transfer_success === 1
          || item.call_transfer_success === '1'
      }

      if (item.call_transfer?.success !== undefined && item.call_transfer?.success !== null && item.call_transfer?.success !== '') {
        return !!item.call_transfer.success
      }

      return null
    },

    getCallTransferAreaLabel(item) {
      if (!item) return ''

      return item.call_transfer_area_name
        || item.call_transfer_area
        || item.area_call_transfer
        || this.getTicketAreaNameById(item.id_call_transfer_area)
        || this.getTicketAreaNameById(item.call_transfer?.id_ticket_area)
        || ''
    },

    getTicketAreaNameById(areaId) {
      if (!areaId) return ''
      const area = this.ticketAreas.find((entry) => entry.id_ticket_area === areaId)
      if (!area) return ''
      return area.area || area.code || ''
    },

    hasCallTransferInfo(item) {
      return this.getCallTransferSuccess(item) !== null
    },

    getTicketCallTransferLabel(item) {
      const success = this.getCallTransferSuccess(item)
      if (success === null) return ''

      const area = this.getCallTransferAreaLabel(item)
      if (success) {
        return area ? `Trasferimento riuscito verso ${area}` : 'Trasferimento riuscito'
      }

      return area ? `Trasferimento non riuscito verso ${area}` : 'Trasferimento non riuscito'
    },

    getCallTransferBadgeClass(item) {
      const success = this.getCallTransferSuccess(item)
      if (success === true) return 'call-transfer-badge call-transfer-badge--success'
      if (success === false) return 'call-transfer-badge call-transfer-badge--failed'
      return 'call-transfer-badge'
    },

    resetTicketReplyCallTransfer() {
      this.ticketReplyCallTransferSuccess = null
      this.ticketReplyCallTransferAreaId = null
    },

    resetTicketReplyForm() {
      this.ticketReplyMessage = ''
      this.resetTicketReplyCallTransfer()
      this.ticketReplyStatusId = null
    },

    findTicketStatusByLabel(label) {
      if (!label || !Array.isArray(this.ticketStatuses)) {
        return null
      }

      const normalized = String(label).toLowerCase().trim()
      return this.ticketStatuses.find((entry) => (
        String(entry.status || '').toLowerCase().trim() === normalized
      )) || null
    },

    getTicketCurrentStatusId(ticket) {
      if (!ticket) {
        return null
      }

      if (ticket.id_ticket_status != null && ticket.id_ticket_status !== '') {
        return ticket.id_ticket_status
      }

      const history = ticket.history_status
      if (Array.isArray(history) && history.length > 0) {
        const last = history[history.length - 1]
        if (last?.id_ticket_status != null && last.id_ticket_status !== '') {
          return last.id_ticket_status
        }

        const historyMatch = this.findTicketStatusByLabel(last?.status)
        if (historyMatch) {
          return historyMatch.id_ticket_status
        }
      }

      const currentMatch = this.findTicketStatusByLabel(ticket.status || ticket.stato)
      return currentMatch?.id_ticket_status ?? null
    },

    initTicketReplyStatus(ticket) {
      const currentStatusId = this.getTicketCurrentStatusId(ticket)
      this.ticketReplyStatusId = currentStatusId
    },

    shouldUpdateTicketReplyStatus(previousStatusId) {
      if (this.ticketReplyStatusId == null || this.ticketReplyStatusId === '') {
        return false
      }

      if (previousStatusId == null || previousStatusId === '') {
        return true
      }

      return Number(this.ticketReplyStatusId) !== Number(previousStatusId)
    },

    onTicketReplyCallTransferSuccessChange() {
      if (!this.requiresCallTransferArea(this.ticketReplyCallTransferSuccess)) {
        this.ticketReplyCallTransferAreaId = null
      }
    },

    buildReplyCallTransferPayload() {
      if (!this.requiresCallTransferArea(this.ticketReplyCallTransferSuccess)) {
        return null
      }

      return {
        success: this.ticketReplyCallTransferSuccess === true,
        id_ticket_area: this.ticketReplyCallTransferAreaId,
      }
    },

    formatTicketMessageContent(content) {
      if (!content) return ''
      return String(content).replace(/\n/g, '<br>')
    },

    scrollTicketMessagesToBottom() {
      const container = this.$refs.ticketMessagesContainer
      if (container) {
        container.scrollTop = container.scrollHeight
      }
    },

    async sendTicketReply() {
      const message = this.ticketReplyMessage?.trim()
      if (!message) return

      const ticketId = this.getTicketId(this.selectedTicket)
      if (!ticketId) {
        this.handleApiError({ message: 'ID ticket non valido' })
        return
      }

      if (
        this.requiresCallTransferArea(this.ticketReplyCallTransferSuccess)
        && !this.ticketReplyCallTransferAreaId
      ) {
        this.handleApiError({ message: 'Seleziona l\'area verso cui hai provato a trasferire la chiamata' })
        return
      }

      const callTransfer = this.buildReplyCallTransferPayload()
      const previousStatusId = this.getTicketCurrentStatusId(this.selectedTicket)
      const shouldChangeStatus = this.shouldUpdateTicketReplyStatus(previousStatusId)

      this.sendingTicketReply = true
      try {
        const { data } = await this.incallService.sendMessage(ticketId, message, [], { callTransfer })
        if (data?.success) {
          if (shouldChangeStatus) {
            const statusRes = await this.incallService.changeStatus(ticketId, this.ticketReplyStatusId)
            if (!statusRes?.success) {
              this.handleApiError({ message: 'Risposta inviata ma errore nel cambio stato del ticket' })
            }
          }

          this.ticketReplyMessage = ''
          this.resetTicketReplyCallTransfer()
          await this.loadAllTickets()
          const updatedTicket = this.tickets.find((ticket) => this.getTicketId(ticket) === ticketId)
          if (updatedTicket) {
            this.selectedTicket = { ...updatedTicket }
            if (!this.ticketHasEmbeddedDetails(updatedTicket)) {
              await this.loadSelectedTicketDetails(updatedTicket)
            }
          }
          if (this.ticketModalMode === 'reply') {
            this.initTicketReplyStatus(this.selectedTicket)
          }
          this.$nextTick(() => this.scrollTicketMessagesToBottom())
          if (this.$notify) {
            this.$notify.success({
              title: 'Successo',
              message: shouldChangeStatus
                ? 'Risposta inviata e stato ticket aggiornato'
                : 'Risposta inviata correttamente',
            })
          }
        } else {
          this.handleApiError({ message: 'Errore nell\'invio del messaggio' })
        }
      } catch (error) {
        this.handleApiError(error, 'Errore nell\'invio del messaggio')
      } finally {
        this.sendingTicketReply = false
      }
    },

    viewTicket(ticket) {
      this.openTicket(ticket, 'view')
    },

    editTicket(ticket) {
      this.selectedTicket = ticket
    },

    closeModal() {
      this.endTicketModalDrag()
      this.showTicketModal = false
      this.showTicketActionModal = false
      this.showAddTicketModal = false
      this.showActionModal = false
      this.selectedTicket = {}
      this.ticketForAction = null
      this.ticketModalMode = 'view'
      this.resetTicketReplyForm()
      this.loadingTicketDetails = false
      this.sendingTicketReply = false
      this.ticketModalDrag = { active: false, startX: 0, startY: 0, deltaX: 0, deltaY: 0 }

      this.newTicket = {
        tipo: 'Ticket',
        tipoDestinatario: '',
        titolo: '',
        descrizione: '',
        priorita: 'media',
        stato: 'In Attesa',
        statusCode: 'opened',
        recipient: null,
        recipient_id: null,
        area_id: 1,
        is_related: false,
        motivazioneId: null,
        callTransferSuccess: null,
        callTransferAreaId: null,
      }

      this.recipients = []
      this.recipientSearchQuery = ''
      this.showRecipientsList = false

      if (this.recipientSearchTimeout) {
        clearTimeout(this.recipientSearchTimeout)
      }
    },

    onCallTransferSuccessChange() {
      if (!this.requiresCallTransferArea(this.newTicket.callTransferSuccess)) {
        this.newTicket.callTransferAreaId = null
      }
    },

    requiresCallTransferArea(value) {
      return value === true || value === false
    },

    startTicketModalDrag(e) {
      if (e.target.closest('.close-button')) return
      this.ticketModalDrag = {
        ...this.ticketModalDrag,
        active: true,
        startX: e.clientX,
        startY: e.clientY
      }
      document.addEventListener('mousemove', this.onTicketModalDrag)
      document.addEventListener('mouseup', this.endTicketModalDrag)
    },

    onTicketModalDrag(e) {
      if (!this.ticketModalDrag.active) return
      const dx = e.clientX - this.ticketModalDrag.startX
      const dy = e.clientY - this.ticketModalDrag.startY
      this.ticketModalDrag = {
        ...this.ticketModalDrag,
        deltaX: this.ticketModalDrag.deltaX + dx,
        deltaY: this.ticketModalDrag.deltaY + dy,
        startX: e.clientX,
        startY: e.clientY
      }
    },

    endTicketModalDrag() {
      this.ticketModalDrag = { ...this.ticketModalDrag, active: false }
      document.removeEventListener('mousemove', this.onTicketModalDrag)
      document.removeEventListener('mouseup', this.endTicketModalDrag)
    },

    closeInvioEmailModal() {
      this.showInvioEmailModal = false
      this.loadingEmailModal = false
      this.$eventBus.off('email-sent', this.handleEmailSent)
    },

    openInvioEmailModal() {
      this.showInvioEmailModal = true
      this.loadingEmailModal = true
      this.$eventBus.on('email-sent', this.handleEmailSent)
      
      setTimeout(() => {
        this.loadingEmailModal = false
      }, 1000)
    },

    handleEmailSent(result) {
      if (result && result.success) {
        setTimeout(() => {
          this.closeInvioEmailModal()
        }, 1500)
      }
    },

    async createTicketAndReturnResult() {
      try {
        if (!this.newTicket.tipoDestinatario) {
          throw new Error('Seleziona un tipo di destinatario')
        }

        const hasMotivazione = !!this.newTicket.motivazioneId
        if (!hasMotivazione) {
          if (!this.newTicket.titolo?.trim()) {
            throw new Error('Inserisci un titolo per il ticket')
          }
          if (!this.newTicket.descrizione?.trim()) {
            throw new Error('Inserisci una descrizione per il ticket')
          }
        }

        if (!this.newTicket.recipient) {
          throw new Error('Seleziona un destinatario')
        }

        if (
          this.requiresCallTransferArea(this.newTicket.callTransferSuccess)
          && !this.newTicket.callTransferAreaId
        ) {
          throw new Error('Seleziona l\'area verso cui hai provato a trasferire la chiamata')
        }

        if (!this.selectedUser.id) {
          throw new Error('Nessun utente selezionato per collegare il ticket')
        }

        this.loading = true

        const nomeContatto = this.getContactDisplayName()
        
        const tipoContatto = this.getContactTypeForTicket()
        const prefisso = tipoContatto === 'rappresentante' ? 'Rappresentante' : 'Cliente'
        
        const motivazioneSelezionata = this.newTicket.motivazioneId
          ? this.motivazioniTicket.find(m => m.id === this.newTicket.motivazioneId)
          : null
        const motivazioneTesto = motivazioneSelezionata?.motivation || ''

        const titoloFinale = motivazioneTesto
          ? `[${motivazioneTesto}] ${(this.newTicket.titolo || '').trim()}`.trim() || motivazioneTesto
          : (this.newTicket.titolo || '').trim()

        const descrizioneBase = (this.newTicket.descrizione || '').trim()
        const contenutoConNome = motivazioneTesto
          ? `${prefisso}: ${nomeContatto}\n\nMotivazione: ${motivazioneTesto}\n\n${descrizioneBase}`
          : `${prefisso}: ${nomeContatto}\n\n${descrizioneBase}`

        let ticketData = {
          title: titoloFinale,
          content: contenutoConNome,
          is_related: this.newTicket.is_related,
          recipient: {},
          
          related_contact: {
            contact_id: this.getContactIdForTicket(),
            contact_type: this.getContactTypeForTicket()
          }
        }

        if (this.newTicket.motivazioneId) {
          ticketData.id_category_motivation = this.newTicket.motivazioneId
        }

        if (this.newTicket.statusCode) {
          ticketData.status_code = this.newTicket.statusCode
        }

        if (this.newTicket.tipoDestinatario === 'area') {
          ticketData.recipient = {
            id: null,
            type: 'area',
            id_ticket_area: this.newTicket.recipient.id_ticket_area
          }
        } else {
          ticketData.recipient = {
            id: this.newTicket.recipient.id,
            type: this.newTicket.tipoDestinatario,
            id_ticket_area: this.newTicket.recipient.id_ticket_area || 0
          }
        }

        if (this.newTicket.is_related && this.selectedEntity) {
          ticketData.type_entity = { id: (this.linkEntityType?.id || this.linkEntityType?.type || this.linkEntityType) }
          ticketData.entity = { id: this.selectedEntity.id }
        }

        if (this.requiresCallTransferArea(this.newTicket.callTransferSuccess)) {
          ticketData.call_transfer = {
            success: this.newTicket.callTransferSuccess === true,
            id_ticket_area: this.newTicket.callTransferAreaId,
          }
        }


        let response
        try {
          response = await this.incallService.createTicket(ticketData)
        } catch (serviceError) {
          response = await this.createTicketDirect(ticketData)
        }

        let res = response && response.data ? response.data : response
        if (res.success && typeof res.success === 'object') {
          res = res.success
        }
        let success = false
        if (
          res === true ||
          res.success === true ||
          res.data?.success === true ||
          res.ticket_id ||
          res.data?.ticket_id
        ) {
          success = true
        }

        if (success) {
          await this.loadAllTickets()
          return { success: true, message: `Ticket creato con successo per ${this.selectedUser.nome} ${this.selectedUser.cognome}!` }
        } else {
          throw new Error(response?.error || response?.message || 'Errore nella creazione del ticket')
        }

      } catch (error) {
        return { success: false, error: error.message }
      } finally {
        this.loading = false
      }
    },

    async createTicket() {
      try {
        const result = await this.createTicketAndReturnResult()
        if (result.success) {
          this.$notify && this.$notify.success({ title: 'Successo', message: result.message })
          this.closeModal()
        } else {
          throw new Error(result.error)
        }
      } catch (error) {
        this.handleApiError(error)
      }
    },

    getContactIdForTicket() {
      
     if (this.selectedUser.client_id) {
        return this.selectedUser.client_id
      }
      
      if (this.selectedUser.rappresentante_id) {
        return this.selectedUser.rappresentante_id
      }
      
      if (this.selectedUser.contatto_id) {
        return this.selectedUser.contatto_id
      }
      
      return this.selectedUser.id
    },

    getContactTypeForTicket() {
      
      if (this.selectedUser.entity_type === 'rappresentante' || 
          this.selectedUser.is_rappresentante ||
          (typeof this.selectedUser.id === 'string' && this.selectedUser.id.startsWith('rappresentante_'))) {
        return 'rappresentante'
      }
      
      if (this.selectedUser.contatto_id) {
        return 'contatto'
      }
      
      if (this.selectedUser.client_id || this.selectedUser.entity_type === 'client') {
        return 'client'
      }
      
      if (this.activeSearchType === 'pdp') {
        return 'client'
      }
      
      return 'client'
    },

    getTicketTypeClass(tipo) {
      switch (tipo?.toLowerCase()) {
        case 'dilazione':
          return 'type-dilazione'
        case 'ticket':
          return 'type-ticket'
        case 'reclamo':
          return 'type-reclamo'
        default:
          return 'type-ticket'
      }
    },

    getStatusClass(status) {
      switch (status?.toLowerCase()) {
        case 'attivo':
          return 'status-active'
        case 'in attesa':
        case 'opened':
          return 'status-pending'
        case 'risolto':
        case 'closed':
          return 'status-resolved'
        case 'scaduto':
          return 'status-expired'
        default:
          return 'status-pending'
      }
    },

    isSystemTicket(ticket) {
      const recipient = (ticket.recipient_name || ticket.destinatario || '').trim().toLowerCase()
      const recipientType = (ticket.recipient_type || ticket.type_recipient || '').trim().toLowerCase()
      return recipient === 'log' || recipientType === 'log'
    },

    nextUserTicketsPage() {
      if (this.currentPage < this.totalPagesUserTickets) {
        this.currentPage++
      }
    },

    previousUserTicketsPage() {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },

    nextSystemTicketsPage() {
      if (this.currentPageSystemTickets < this.totalPagesSystemTickets) {
        this.currentPageSystemTickets++
      }
    },

    previousSystemTicketsPage() {
      if (this.currentPageSystemTickets > 1) {
        this.currentPageSystemTickets--
      }
    },

    handleTicketSearch() {
      if (this.ticketSearchTimeout) {
        clearTimeout(this.ticketSearchTimeout)
      }

      this.ticketSearchTimeout = setTimeout(() => {
        this.currentPage = 1
        this.currentPageSystemTickets = 1
      }, 300)
    },

    clearTicketSearch() {
      this.ticketSearchQuery = ''
      this.currentPage = 1
      this.currentPageSystemTickets = 1
    },

    formatSuggestionLabel(item, searchType = 'nome') {
      const nome = item.cliente_nome
        || item.ragsoc
        || `${item.nome || ''} ${item.cognome || ''}`.trim()
        || item.display_name
        || ''
      const email = item.email || ''
      const telefono = item.telefono || ''
      const codiceFiscale = item.codfis || item.codiceFiscale || ''
      const codeCliente = item.code_cliente || item.cod_cliente || ''
      const pdpCode = item.code || item.pod_code || item.pdp || ''
      const numeroFattura = item.numero_fattura || ''

      let label = nome

      if (searchType === 'pdp' && pdpCode) {
        label = `${pdpCode} - ${nome || 'Cliente'}`.trim()
      } else if (searchType === 'codiceCliente' && codeCliente) {
        label = `${codeCliente} - ${nome || 'Cliente'}`.trim()
      } else if (searchType === 'numeroFattura' && numeroFattura) {
        label = `${numeroFattura} - ${nome || 'Cliente'}`.trim()
      } else if (searchType === 'codiceFiscale' && codiceFiscale) {
        label = `${nome || 'Contatto'} - ${codiceFiscale}`.trim()
      }

      if (email) label += ` - ${email}`
      if (telefono) label += ` - ${telefono}`

      return label
    },

    async selectSearchSuggestion(suggestion, searchType) {
      this.searchQueries[searchType] = this.getSuggestionPrimaryLabel(suggestion.label)
      this.showSearchSuggestions = false
      this.searchSuggestions = []

      try {
        this.loading = true
        await this.applySearchSelection(suggestion.data, searchType)
      } catch (error) {
        this.handleApiError(error, 'Errore nel caricamento del contatto selezionato')
      } finally {
        this.loading = false
      }
    },

    closeSuggestions(searchType) {
      if (searchType && this.activeSuggestionSearchType !== searchType) {
        return
      }
      setTimeout(() => {
        this.showSearchSuggestions = false
      }, 200)
    },

    clearSearch(searchType) {
      this.searchQueries[searchType] = ''
      this.showSearchSuggestions = false
      this.searchSuggestions = []

      if (!this.hasActiveSearch) {
        this.resetData()
      }
    },

    clearAllSearches() {
      this.searchQueries.pdp = ''
      this.searchQueries.codiceCliente = ''
      this.searchQueries.numeroFattura = ''
      this.searchQueries.codiceFiscale = ''
      this.searchQueries.nome = ''
      this.selectedSearchType = null
      this.searchCollapsed = false
      this.showSearchSuggestions = false
      this.searchSuggestions = []
      this.activeSuggestionSearchType = null
      this.resetData()
    },

    toggleSearchCollapsed() {
      this.searchCollapsed = !this.searchCollapsed
    },

    navigateToFatturaDetail(numero) {
      if (!numero) {
        if (this.$toast) {
          this.$toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Numero fattura non disponibile', life: 2000 });
        } else {
          alert('Numero fattura non disponibile');
        }
        return;
      }
      window.open(`/ask/clienti/fatture/${numero}/dettagli`);
    },
    navigateToClienteDetail(clienteId) {
      if (!clienteId) {
        if (this.$toast) {
          this.$toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'ID cliente non disponibile', life: 2000 });
        } else {
          alert('ID cliente non disponibile');
        }
        return;
      }
      window.open(`/ask/clienti/${clienteId}/dettagli`);
    },
    navigateToPdpDetail(codPod, codPdr) {
      if (codPod > 0) {
        window.open(`/ask/pods/${codPod}/dettagli`);
      } else if (codPdr > 0) {
        window.open(`/ask/pdrs/${codPdr}/dettagli`);
      } else {
        if (this.$toast) {
          this.$toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'ID POD/PDR non disponibile', life: 2000 });
        } else {
          alert('ID POD/PDR non disponibile');
        }
      }
    },
    async searchByNomeRagioneSociale(nome) {
      return await this.incallService.searchByNomeRagioneSociale(nome, this.selectedSearchType)
    },
    selectSearchType(type) {
      this.selectedSearchType = type
    },
    populateSelectedUserFromRappresentanteData(rappData) {
      this.loadingFatture = true
      
      this.selectedUser = {
        id: rappData.rappresentante_id || rappData.id,
        nome: rappData.nome || rappData.ragsoc || rappData.display_name || '',
        email: rappData.email || '',
        pec: rappData.pec || '',
        telefono: rappData.telefono || 'Non disponibile',
        codiceFiscale: rappData.codiceFiscale || rappData.codfis || '',
        entity_type: 'rappresentante',
        fatture_insolute: rappData.fatture_insolute || [],
      }

      setTimeout(() => {
        this.loadingFatture = false
      }, 500)
    },

    async executeEmailSend() {
      if (!this.$refs.invioEmailComponent) {
        return
      }

      this.emailSending = true
      try {
        await this.$refs.invioEmailComponent.onOkButton()
        
        const contactName = this.getContactDisplayName();
        const title = `Email fatture inviata a ${contactName}`;
        const content = `Email fatture inviata con successo a ${contactName} (${this.selectedUser.email})`;
        await this.createEmailTicket(title, content);
        
      } catch (error) {
        if (this.$notify) {
          this.$notify.error({
            title: 'Errore',
            message: 'Errore nell\'invio delle email: ' + error.message
          })
        } else {
          alert('Errore nell\'invio delle email: ' + error.message)
        }
      } finally {
        this.emailSending = false
      }
    },

    async downloadFattureZipModal(){
      try {
        this.downloadingZip = true
        const selected = (this.$refs?.invioEmailComponent?.selectedItems?.value)
          || (this.$refs?.invioEmailComponent?.selectedItems)
          || []
        const numeri = selected
          .map(f => f.numero || f?.data?.numero)
          .filter(Boolean)
        if (!numeri.length) {
          const fallback = (this.emailFattureData || []).map(f => f.numero).filter(Boolean)
          if (fallback.length) {
            const blob = await this.incallService.downloadFattureZip(fallback)
            const url = window.URL.createObjectURL(new Blob([blob]))
            const a = document.createElement('a')
            a.href = url
            a.download = `fatture_clienti.zip`
            document.body.appendChild(a)
            a.click()
            window.URL.revokeObjectURL(url)
            document.body.removeChild(a)
          }
          this.downloadingZip = false
          return
        }
        const blob = await this.incallService.downloadFattureZip(numeri)
        const url = window.URL.createObjectURL(new Blob([blob]))
        const a = document.createElement('a')
        a.href = url
        a.download = `fatture_clienti.zip`
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
      } catch (e) {
        // Errore download fatture ZIP
      } finally {
        this.downloadingZip = false
      }
    },

    getMeseFatturazione(dataEmissione) {
      if (!dataEmissione) return null;
      try {
        const date = new Date(dataEmissione);
        return date.getMonth() + 1; 
      } catch (error) {
        return null;
      }
    },

    async sendEstrattoConto(daInviare = 1, tipo = 'rappresentante', clienteId = null) {
      let idToSend = null;
      let errorMessage = '';
      let targetEmail = this.selectedUser.email;
      let contactName = this.getContactDisplayName();
      let fattureDaIncludere = this.fattureFiltratePerAnno;

      if (tipo === 'cliente' && clienteId) {
        idToSend = clienteId;
        errorMessage = 'Nessun ID cliente disponibile';
        fattureDaIncludere = this.getFattureClienteByAnno(clienteId);
        
        const cliente = this.getClientiRappresentante.find(c => c.id === clienteId);
        if (cliente) {
          contactName = cliente.nome;
        }
      } else if (this.selectedSearchType === 'rappresentante') {
        idToSend = this.selectedUser.id;
        errorMessage = 'Nessun ID rappresentante disponibile per l\'utente selezionato';
      } else {
        idToSend = this.selectedUser.client_id;
        errorMessage = 'Nessun ID cliente disponibile per l\'utente selezionato';
      }

      if (!idToSend) {
        
        this.showEstrattoContoMessage('error', 'Errore', errorMessage);
        return;
      }

      if (fattureDaIncludere.length === 0) {
        const annoMsg = this.selectedAnno ? ` dal ${this.selectedAnno}` : '';
        this.showEstrattoContoMessage('warning', 'Attenzione', `Nessuna fattura trovata${annoMsg} per questo ${tipo === 'cliente' ? 'cliente' : 'contatto'}`);
        return;
      }

      this.sendingEstrattoConto = true;
      let codPod = null;
      let codPdr = null;
      if (this.selectedPuntoId) {
        const puntoSel = (this.pods || []).find(p => p.id === this.selectedPuntoId);
        if (puntoSel) {
          if ((puntoSel.tipo_punto || '').toLowerCase() === 'pod') {
            codPod = puntoSel.id; 
          } else if ((puntoSel.tipo_punto || '').toLowerCase() === 'pdr') {
            codPdr = puntoSel.id; 
          }
        }
      }
      try {
        let result;
        const completoParam = (this.selectedTipoEstratto === 'completo') ? 1 : 0;
        const escludiCreditiParam = (this.selectedTipoEstratto === 'escludi_crediti') ? 1 : 0;
        if (tipo === 'cliente' && clienteId) {
          result = await this.incallService.sendEstrattoContoPdf(clienteId, 'cliente', this.selectedUser.id, daInviare, true, this.selectedAnno || null, completoParam, codPod, codPdr, escludiCreditiParam, this.selectedStatoFornitura);
        } else if (this.selectedSearchType === 'rappresentante') {
          result = await this.incallService.sendEstrattoContoPdf(null, 'rappresentante', idToSend, daInviare, false, this.selectedAnno || null, completoParam, codPod, codPdr, escludiCreditiParam, this.selectedStatoFornitura);
        } else {
          result = await this.incallService.sendEstrattoContoPdf(idToSend, 'cliente', null, daInviare, false, this.selectedAnno || null, completoParam, codPod, codPdr, escludiCreditiParam, this.selectedStatoFornitura);
        }
        
        if (daInviare === 1) {
          const annoMsg = this.selectedAnno ? ` (dal ${this.selectedAnno})` : '';
          const tipoMsg = this.selectedTipoEstratto === 'completo' 
            ? ' completo' 
            : (this.selectedTipoEstratto === 'escludi_crediti' ? ' (escludi crediti)' : ' (solo fatture da saldare)');
          const successMessage = tipo === 'cliente' && clienteId 
            ? `Estratto conto${tipoMsg} del cliente ${contactName}${annoMsg} inviato con successo al rappresentante!`
            : `Estratto conto${tipoMsg}${annoMsg} inviato con successo via email!`;
          
          this.showEstrattoContoMessage('success', 'Successo', successMessage);
          
          const title = tipo === 'cliente' && clienteId 
            ? `Email estratto conto${tipoMsg} cliente ${contactName}${annoMsg} inviata al rappresentante`
            : `Email estratto conto${tipoMsg}${annoMsg} inviata a ${contactName}`;
          
          const content = tipo === 'cliente' && clienteId 
            ? `Email estratto conto${tipoMsg} del cliente ${contactName}${annoMsg} inviata con successo al rappresentante (${targetEmail})`
            : `Email estratto conto${tipoMsg}${annoMsg} inviata con successo a ${contactName} (${targetEmail})`;
          
          await this.createEmailTicket(title, content);
        } else {
          try {
            const blob = new Blob([result], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            
            const annoSuffix = this.selectedAnno ? `_dal_${this.selectedAnno}` : '';
            const tipoSuffix = this.selectedTipoEstratto === 'completo' 
              ? '_completo' 
              : (this.selectedTipoEstratto === 'escludi_crediti' ? '' : '_da_saldare');
            const fileName = tipo === 'cliente' && clienteId 
              ? `estratto_conto_cliente_${contactName.replace(/[^a-zA-Z0-9]/g, '_')}${annoSuffix}${tipoSuffix}.pdf`
              : `estratto_conto${annoSuffix}${tipoSuffix}.pdf`;
            
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            
            const annoMsg = this.selectedAnno ? ` (dal ${this.selectedAnno})` : '';
            const tipoMsg = this.selectedTipoEstratto === 'completo' 
              ? ' completo' 
              : (this.selectedTipoEstratto === 'escludi_crediti' ? ' (escludi crediti)' : ' (solo fatture da saldare)');
            const successMessage = tipo === 'cliente' && clienteId 
              ? `Estratto conto${tipoMsg} del cliente ${contactName}${annoMsg} scaricato con successo!`
              : `Estratto conto${tipoMsg}${annoMsg} scaricato con successo!`;
            
            this.showEstrattoContoMessage('success', 'Successo', successMessage);
          } catch (downloadError) {
            this.showEstrattoContoMessage('error', 'Errore', 'Errore nel download dell\'estratto conto');
          }
        }
        
        setTimeout(() => {
          this.sendingEstrattoConto = false;
        }, 1000);
        
      } catch (error) {
        this.sendingEstrattoConto = false;
        
        this.showEstrattoContoMessage('error', 'Errore', 'Errore nell\'estratto conto: ' + (error.message || 'Errore sconosciuto'));
      }
    },

    closeEstrattoContoMessageModal() {
      this.showEstrattoContoMessageModal = false
    },

    showEstrattoContoMessage(type, title, message) {
      this.estrattoContoMessage = {
        type,
        title,
        message
      }
      this.showEstrattoContoMessageModal = true
    },

    closeBollettinoMessageModal() {
      this.showBollettinoMessageModal = false
    },

    showBollettinoMessage(type, title, message) {
      this.bollettinoMessage = {
        type,
        title,
        message
      }
      this.showBollettinoMessageModal = true
    },

    async sendBollettino() {
      let idToSend = null;
      let errorMessage = '';

      if (this.selectedSearchType === 'rappresentante') {
        idToSend = this.selectedUser.id;
        errorMessage = 'Nessun ID rappresentante disponibile per l\'utente selezionato';
      } else {
        idToSend = this.selectedUser.client_id;
        errorMessage = 'Nessun ID cliente disponibile per l\'utente selezionato';
      }

      if (!idToSend) {
        
        this.showBollettinoMessage('error', 'Errore', errorMessage);
        return;
      }

      this.sendingBollettino = true;
      try {
        if (this.selectedSearchType === 'rappresentante') {
          await this.incallService.sendBollettinoPostalePdf(null, 'rappresentante', idToSend);
        } else {
          await this.incallService.sendBollettinoPostalePdf(idToSend, 'cliente');
        }
        
        this.showBollettinoMessage('success', 'Successo', 'Bollettini postali inviati con successo via email!');
        
        
        const contactName = this.getContactDisplayName();
        const title = `Email bollettini inviata a ${contactName}`;
        const content = `Email bollettini inviata con successo a ${contactName} (${this.selectedUser.email})`;
        await this.createEmailTicket(title, content);
        
        setTimeout(() => {
          this.sendingBollettino = false;
        }, 1000);
        
      } catch (error) {
        this.sendingBollettino = false;
        
        this.showBollettinoMessage('error', 'Errore', 'Errore nell\'invio dei bollettini postali: ' + (error.message || 'Errore sconosciuto'));
      }
    },

    async showReclamoConfirmation() {
      const result = await this.createTicketAndReturnResult()
      if (result.success) {
        this.$notify && this.$notify.success({ title: 'Successo', message: result.message })
        this.closeModal()
        this.showReclamoDialog = true
      } else {
        this.handleApiError(new Error(result.error))
      }
    },

    async createTicketWithoutReclamo() {
      this.showReclamoDialog = false
      this.showReclamoLink = false
      await this.loadAllTickets()
    },

    async createTicketWithReclamo() {
      if (!this.showReclamoLink) {
        this.showReclamoLink = true
      } else {
        this.showReclamoDialog = false
        this.showReclamoLink = false
        await this.loadAllTickets()
      }
    },

    async closeReclamoDialog() {
      this.showReclamoDialog = false
      this.showReclamoLink = false
      await this.loadAllTickets()
    },

    showEstrattoContoConfirmation() {
      this.showEstrattoContoDialog = true
    },

    async downloadEstrattoConto() {
      this.showEstrattoContoDialog = false;
      await this.sendEstrattoConto(0, this.selectedSearchType === 'rappresentante' ? 'rappresentante' : 'cliente'); 
    },

    async sendEstrattoContoEmail() {
      this.showEstrattoContoDialog = false;
      await this.sendEstrattoConto(1, this.selectedSearchType === 'rappresentante' ? 'rappresentante' : 'cliente'); 
    },

    closeEstrattoContoDialog() {
      this.showEstrattoContoDialog = false;
      this.selectedAnno = '';
      this.selectedTipoEstratto = 'da_saldare';
      this.selectedStatoFornitura = 'all_state';
      this.selectedPuntoId = null;
    },

    async createEmailTicket(title, content) {
      try {
        let idAssignedUser = null;
        let assignedUserType = null;
        
        if (this.selectedSearchType === 'rappresentante') {
          idAssignedUser = this.selectedUser.id;
          assignedUserType = 'Rappresentante';
        } else {
          idAssignedUser = this.selectedUser.client_id || this.selectedUser.id;
          assignedUserType = 'Cliente';
        }

        const nomeContatto = this.getContactDisplayName()
        const prefisso = this.selectedSearchType === 'rappresentante' ? 'Rappresentante' : 'Cliente'
        const contenutoConNome = `${prefisso}: ${nomeContatto}\n\n${content}`

        const params = {
          title: title,
          content: contenutoConNome,
          id_user: 10,
          user_type: 'system', 
          id_ticket_area: 10, 
          id_recipient: null, 
          type_recipient: null, 
          is_related: false, 
          id_entity_type: null, 
          id_entity: null, 
          status_code: 'closed',
          id_assigned_user: idAssignedUser,
          assigned_user_type: assignedUserType
        };

        const result = await this.incallService.createTicketBase(params);
        
        if (result && result.success) {
          // Ticket creato automaticamente con successo
        } else {
          // Errore nella creazione automatica del ticket
        }
      } catch (error) {
        // Errore nella chiamata per creare il ticket automatico
      }
    },



    getContactDisplayName() {
      if (!this.selectedUser || !this.selectedUser.id) {
        return 'Cliente/Rappresentante non selezionato';
      }
      
      if (this.selectedUser.ragsoc) {
        return this.selectedUser.ragsoc;
      } else if (this.selectedUser.nome && this.selectedUser.cognome) {
        return `${this.selectedUser.nome} ${this.selectedUser.cognome}`;
      } else if (this.selectedUser.nome) {
        return this.selectedUser.nome;
      } else if (this.selectedUser.cognome) {
        return this.selectedUser.cognome;
      } else {
        return 'Cliente';
      }
    },

    getIncallPraticaDisplayName(group = null, file = null) {
      const code = String(group?.code || '').toUpperCase()
      const name = String(group?.name || '')
      const filename = String(file?.filename || '').toLowerCase()
      const official = /modifica condizioni di connession[ei] e contrattuali/i

      if (code === 'MC1' || filename.includes('mc1') || official.test(name)) {
        return 'Modifica Mc1'
      }

      return name || file?.filename || ''
    },

    startDilazioniLoading() {
      this.loadingDilazioni = true;
      this.dilazioniRefreshKey++; 
      setTimeout(() => {
        this.loadingDilazioni = false;
      }, 500);
    },

    openAggiungiDilazioneModal() {
      this.filtered = {
        ids:{
          fattureClientiDataTable:[]
        }
      }
      this.fattureNumeri.forEach(fattura => {
        this.filtered.ids.fattureClientiDataTable.push({key: "fattura_vendita.numeri", property: "numero", value: fattura})
      })
      this.methodAggiungiDilazione.method.apply(this, [])
    },

    closeAggiungiDilazioneModal() {
      this.showAggiungiDilazioneModal = false;
    },

    handleDilazioneCreata(event) {
      if (event.success) {
        if (this.$notify) {
          this.$notify.success({
            title: 'Successo',
            message: 'Dilazione creata con successo'
          });
        }
        this.closeAggiungiDilazioneModal();
        this.startDilazioniLoading();
      }
    },

    handleDilazioneRimossa(event) {
      if (event.success) {
        if (this.$notify) {
          this.$notify.info({
            title: 'Info',
            message: 'Dilazione rimossa'
          });
        }
        this.closeAggiungiDilazioneModal();
        this.startDilazioniLoading();
      }
    },

    async getClientIdsForRappresentante(rappresentanteId) {
      try {
        const response = await this.incallService.getClientiByRappresentante(rappresentanteId);
        if (response && response.data && response.data.success && response.data.data) {
          return response.data.data.map(cliente => cliente.id);
        }
        return [];
      } catch (error) {
        // Errore nel recupero dei clienti del rappresentante
        return [];
      }
    },

    downloadEstrattoContoRappresentante() {
      this.showEstrattoContoDialog = false;
      this.sendEstrattoConto(0, 'rappresentante');
    },

    sendEstrattoContoEmailRappresentante() {
      this.showEstrattoContoDialog = false;
      this.sendEstrattoConto(1, 'rappresentante');
    },

    downloadEstrattoContoCliente(clienteId) {
      this.showEstrattoContoDialog = false;
      this.sendEstrattoConto(0, 'cliente', clienteId);
    },

    sendEstrattoContoEmailCliente(clienteId) {
      this.showEstrattoContoDialog = false;
      this.sendEstrattoConto(1, 'cliente', clienteId);
    },

    getFattureClienteByAnno(clienteId) {
      if (!this.fattureInsolute || this.fattureInsolute.length === 0) {
        return [];
      }
      
      const fattureCliente = this.fattureInsolute.filter(fattura => 
        fattura.cod_cliente === clienteId
      );
      
      if (!this.selectedAnno) {
        return fattureCliente;
      }
      
      const annoSelezionato = parseInt(this.selectedAnno);
      
      return fattureCliente.filter(fattura => {
        if (!fattura.data_emissione) {
          return false;
        }
        
        const dataEmissione = new Date(fattura.data_emissione);
        if (isNaN(dataEmissione.getTime())) {
          return false;
        }
        
        return dataEmissione.getFullYear() >= annoSelezionato;
      });
    },

    isFatturaSelezionabile(fattura) {
      const rawSaldo = fattura?.saldo_fattura;
      const normalizedSaldo = typeof rawSaldo === 'string' && rawSaldo.includes(',')
        ? rawSaldo.replace(/\./g, '').replace(',', '.')
        : rawSaldo;
      const saldo = Number(normalizedSaldo);

      return Number.isFinite(saldo) && saldo > 0;
    },

    toggleSelectAllFatture(event) {
      this.selectedFatture = event.target.checked
        ? this.filteredFatture
          .filter(fattura => this.isFatturaSelezionabile(fattura))
          .map(fattura => fattura.numero)
        : [];
    },

    closeBollettinoDialog() {
      this.showBollettinoDialog = false;
      this.selectedFatture = [];
      this.bollettinoIsSaldo = 1;
      this.bollettinoComposizione = 'singoli';
      this.showFattureNonSelezionabili = false;
    },

    async sendBollettinoWithSelection() {
      if (this.selectedFatture.length === 0) {
        this.showBollettinoMessage('error', 'Errore', 'Seleziona almeno una fattura');
        return;
      }

      let idToSend = null;
      let errorMessage = '';

      if (this.selectedSearchType === 'rappresentante') {
        idToSend = this.selectedUser.id;
        errorMessage = 'Nessun ID rappresentante disponibile per l\'utente selezionato';
      } else {
        idToSend = this.selectedUser.client_id;
        errorMessage = 'Nessun ID cliente disponibile per l\'utente selezionato';
      }

      if (!idToSend) {
        
        this.showBollettinoMessage('error', 'Errore', errorMessage);
        return;
      }

      this.sendingBollettino = true;
      try {
        const isSaldo = !!this.bollettinoIsSaldo;
        const tipoBollettinoLabel = 'a saldo';

        let idCliente = null
        let idRappresentante = null
        if (this.selectedSearchType === 'rappresentante') {
          idRappresentante = idToSend
        } else {
          idCliente = idToSend
        }
        await this.incallService.sendBollettinoPostalePdf(
          idCliente,
          this.selectedSearchType,
          idRappresentante,
          this.selectedFatture,
          isSaldo,
          this.bollettinoComposizione
        );
        
        this.showBollettinoMessage('success', 'Successo', `Bollettini postali ${tipoBollettinoLabel} inviati con successo via email per ${this.selectedFatture.length} fatture!`);
        
        const contactName = this.getContactDisplayName();
        const title = `Email bollettini ${tipoBollettinoLabel} inviata a ${contactName}`.replace(/\s+/g, ' ').trim();
        const content = `Email bollettini ${tipoBollettinoLabel} inviata con successo a ${contactName} (${this.selectedUser.email}) per ${this.selectedFatture.length} fatture`.replace(/\s+/g, ' ').trim();
        await this.createEmailTicket(title, content);
        
        this.closeBollettinoDialog();
        
        setTimeout(() => {
          this.sendingBollettino = false;
        }, 1000);
        
      } catch (error) {
        this.sendingBollettino = false;
        
        this.showBollettinoMessage('error', 'Errore', 'Errore nell\'invio dei bollettini postali: ' + (error.message || 'Errore sconosciuto'));
      }
    },

    async downloadBollettinoZip(){
      if (this.selectedFatture.length === 0) {
        this.showBollettinoMessage('error', 'Errore', 'Seleziona almeno una fattura');
        return;
      }

      try {
        this.downloadingBollettino = true;
        const blob = await this.incallService.downloadBollettiniPostaliZip(
          this.selectedFatture,
          this.bollettinoIsSaldo,
          this.bollettinoComposizione
        );
        const url = window.URL.createObjectURL(new Blob([blob]));
        const a = document.createElement('a');
        a.href = url;
        a.download = 'bollettino_postale_saldo_fatture_clienti.zip';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } catch (e) {
        this.showBollettinoMessage('error', 'Errore', 'Errore nel download dei bollettini');
      } finally {
        this.downloadingBollettino = false;
      }
    },

    filterFatture() {
      this.searchFattureQuery = this.searchFattureQuery.trim();
      if (this.searchFattureQuery.length < 3) {
        this.filteredFatture = [];
        return;
      }
      this.filteredFatture = this.fattureInsolute.filter(fattura => {
        return fattura.numero.toLowerCase().includes(this.searchFattureQuery.toLowerCase());
      });
    },

    clearSearchFatture() {
      this.searchFattureQuery = '';
      this.filteredFatture = [];
    },

    openTotaliDialog() {
      this.showTotaliDialog = true;
    },

    closeTotaliDialog() {
      this.showTotaliDialog = false;
      this.selectedAnnoPartenza = '';
      this.totaliData = null;
      this.selectedTipoEstrattoTotali = 'da_saldare';
      this.selectedStatoFornituraTotali = 'all_state';
    },

    async openPratichePdfDialog() {
      this.showPratichePdfDialog = true
      await this.loadPratichePdfFiles()
    },

    closePratichePdfDialog() {
      this.showPratichePdfDialog = false
      this.downloadingPraticaFile = null
      this.loadingPraticaPreview = false
      this.closePraticaEmailDialog()
      this.closePraticaPdfPreviewDialog(true)
    },

    revokePraticaPdfPreviewUrl() {
      if (this.praticaPdfPreviewUrl) {
        URL.revokeObjectURL(this.praticaPdfPreviewUrl)
      }
      this.praticaPdfPreviewUrl = null
    },

    getPraticaPrefillMap() {
      const user = this.selectedUser || {}
      const nome = this.getContactDisplayName() || [user.nome, user.cognome].filter(Boolean).join(' ').trim()
      const podCode = this.getPraticaSupplyCode('pod')
      const pdrCode = this.getPraticaSupplyCode('pdr')
      const fallbackPdp = this.normalizePraticaSupplyCode(user.pdp || user.pod || user.pdr || '')

      return {
        nome,
        email: user.email || user.pec || '',
        telefono: user.telefono || '',
        cf: user.codiceFiscale || user.codice_fiscale || user.cf || '',
        indirizzo: user.via || user.indirizzo || '',
        citta: user.citta || '',
        cap: user.cap || '',
        pod: podCode,
        pdr: pdrCode,
        pdp: podCode || pdrCode || fallbackPdp,
      }
    },

    normalizePraticaSupplyCode(value) {
      const code = String(value || '').trim()
      if (!code || code.toLowerCase() === 'non disponibile') {
        return ''
      }
      return code
    },

    detectPraticaSupplyType(typeHint = null, code = '') {
      const hint = String(typeHint || '').toLowerCase().trim()
      if (hint === 'pdr' || hint === 'pod') {
        return hint
      }

      const normalized = this.normalizePraticaSupplyCode(code).toUpperCase()
      if (!normalized) {
        return 'pod'
      }

      if (/^IT\d{3}E/i.test(normalized) || (normalized.startsWith('IT') && normalized.includes('E'))) {
        return 'pod'
      }

      if (/^\d{10,16}$/.test(normalized)) {
        return 'pdr'
      }

      return 'pod'
    },

    getPraticaSupplyCode(preferredType = null) {
      const points = Array.isArray(this.supplyPointsForPratiche)
        ? this.supplyPointsForPratiche
        : []

      if (preferredType) {
        const preferred = points.find(
          (point) => String(point.type || '').toLowerCase() === preferredType && this.normalizePraticaSupplyCode(point.code)
        )
        if (preferred) {
          return this.normalizePraticaSupplyCode(preferred.code)
        }

        
        return ''
      }

      const anyPoint = points.find((point) => this.normalizePraticaSupplyCode(point.code))
      if (anyPoint) {
        return this.normalizePraticaSupplyCode(anyPoint.code)
      }

      const user = this.selectedUser || {}
      return this.normalizePraticaSupplyCode(user.pdp || user.pod || user.pdr || '')
    },

    resolvePraticaPdpPrefill(field = {}, filename = '') {
      const key = String(field.key || '').toLowerCase()
      const file = String(filename || '').toLowerCase()
      const label = String(field.label || '').toLowerCase()

      let preferredType = null
      const keyHasPod = key.includes('pod')
      const keyHasPdr = key.includes('pdr') || key === 'pdr'
      const labelHasPod = label.includes('pod')
      const labelHasPdr = label.includes('pdr')

      if (keyHasPdr && !keyHasPod) {
        preferredType = 'pdr'
      } else if (keyHasPod && !keyHasPdr) {
        preferredType = 'pod'
      } else if (labelHasPdr && !labelHasPod) {
        preferredType = 'pdr'
      } else if (labelHasPod && !labelHasPdr) {
        preferredType = 'pod'
      } else if (
        file.includes('gas') ||
        file.includes('accisa')
      ) {
        preferredType = 'pdr'
      } else if (
        file.includes('energia') ||
        file.includes('_ee') ||
        file.includes(' elettric')
      ) {
        preferredType = 'pod'
      }

      if (preferredType === 'pdr' || preferredType === 'pod') {
        return this.getPraticaSupplyCode(preferredType)
      }

      return this.getPraticaSupplyCode()
    },

    buildPraticaCompileValues(fields = [], filename = '') {
      const prefill = this.getPraticaPrefillMap()
      const values = {}
      fields.forEach((field) => {
        if (field.type === 'checkbox') {
          values[field.key] = ''
          return
        }
        if (field.prefill === 'pdp') {
          values[field.key] = this.resolvePraticaPdpPrefill(field, filename)
          return
        }
        const source = field.prefill ? prefill[field.prefill] : ''
        values[field.key] = source || ''
      })
      if (!values.data) {
        const today = new Date()
        const dd = String(today.getDate()).padStart(2, '0')
        const mm = String(today.getMonth() + 1).padStart(2, '0')
        const yyyy = today.getFullYear()
        if (Object.prototype.hasOwnProperty.call(values, 'data')) {
          values.data = `${dd}/${mm}/${yyyy}`
        }
      }
      return values
    },

    getPraticaRadioGroupId(field) {
      if (!field || field.type !== 'checkbox') return null
      const key = String(field.key || '')
      const pair = key.match(/^(.*)_(si|no)(_\d+)?$/)
      if (pair) return `${pair[1]}${pair[3] || ''}`
      if (key === 'entro_10' || key === 'oltre_10') return 'spostamento_metri'
      if (key === 'tutti_punti' || key === 'solo_tabella') return 'punti_erogazione'

      const tensione = {
        bt_monofase: 'tensione',
        bt_trifase: 'tensione',
        mt: 'tensione',
        at: 'tensione',
        bt_monofase_2: 'tensione_2',
        bt_trifase_2: 'tensione_2',
        mt_2: 'tensione_2',
        at_2: 'tensione_2',
      }
      if (tensione[key]) return tensione[key]

      const tipologia = {
        altri_usi: 'tipologia',
        domestico_nr: 'tipologia',
        domestico_r: 'tipologia',
        illuminazione: 'tipologia',
        altri_usi_2: 'tipologia_2',
        domestico_nr_2: 'tipologia_2',
        domestico_r_2: 'tipologia_2',
        illuminazione_2: 'tipologia_2',
      }
      return tipologia[key] || null
    },

    getPraticaRadioGroupLabel(groupId, fields = []) {
      const labels = {
        sollevamento: 'Sollevamento persone',
        stagionalita: 'Stagionalità (attuale)',
        stagionalita_2: 'Stagionalità (richiesta)',
        spostamento_metri: 'Distanza spostamento',
        tensione: 'Tensione (attuale)',
        tensione_2: 'Tensione (richiesta)',
        tipologia: 'Tipologia contrattuale (attuale)',
        tipologia_2: 'Tipologia contrattuale (richiesta / nuova)',
        punti_erogazione: 'Punti di erogazione',
        privacy_marketing: 'Marketing diretto (2a)',
        privacy_cessione: 'Cessione dati a terzi (2b)',
      }
      if (labels[groupId]) return labels[groupId]
      const first = String(fields[0]?.label || groupId)
      return first
        .replace(/\s*\((attuale|richiesta|nuovo|nuova)\)\s*$/i, '')
        .replace(/\s*(SI|NO|Sì|No)\s*$/i, '')
        .trim()
    },

    getPraticaRadioOptionLabel(field) {
      const key = String(field.key || '')
      if (/_si(_\d+)?$/.test(key)) return 'Sì'
      if (/_no(_\d+)?$/.test(key)) return 'No'
      if (key === 'entro_10') return 'Entro i 10 metri'
      if (key === 'oltre_10') return 'Oltre i 10 metri'
      if (key === 'tutti_punti') return 'Tutti i punti'
      if (key === 'solo_tabella') return 'Solo tabella'
      return String(field.label || key)
        .replace(/\s*\((attuale|richiesta|nuovo|nuova)\)\s*$/i, '')
        .replace(/\s+(attuale|richiesta|nuovo|nuova)$/i, '')
        .trim()
    },

    getPraticaRadioOrientation(fields = []) {
      const xs = new Set()
      const ys = new Set()
      fields.forEach((field) => {
        if (Number.isFinite(Number(field.x))) xs.add(Number(field.x).toFixed(1))
        if (Number.isFinite(Number(field.y))) ys.add(Number(field.y).toFixed(1))
      })
      if (ys.size > 1 && xs.size <= 1) return 'column'
      if (xs.size > 1 && ys.size <= 1) return 'row'
      return fields.length > 2 ? 'column' : 'row'
    },

    getPraticaRowColumns(row = []) {
      if (!row.length) return '1fr'
      const weights = row.map((field) => {
        const width = Number(field.max_width)
        if (Number.isFinite(width) && width > 0) return Math.max(width, 12)
        const key = String(field.key || '').toLowerCase()
        if (field.type === 'checkbox') return 28
        if (/(^|_)(cap|pr|civico)(_|$)/.test(key) || key === 'provincia' || key.endsWith('_pr')) {
          return 18
        }
        if (key.includes('email')) return 50
        return 40
      })
      return weights.map((weight) => `${weight}fr`).join(' ')
    },

    buildPraticaCompileLayout(fields = []) {
      const yThreshold = 2.5
      const radioGroups = new Map()
      fields.forEach((field) => {
        const groupId = this.getPraticaRadioGroupId(field)
        if (!groupId) return
        if (!radioGroups.has(groupId)) radioGroups.set(groupId, [])
        radioGroups.get(groupId).push(field)
      })
      Array.from(radioGroups.entries()).forEach(([groupId, options]) => {
        if (options.length < 2) radioGroups.delete(groupId)
      })

      const used = new Set()
      const fieldY = (field) => (Number.isFinite(Number(field?.y)) ? Number(field.y) : null)
      const fieldX = (field) => (Number.isFinite(Number(field?.x)) ? Number(field.x) : 0)
      const fieldPage = (field) => Number(field?.page) || 1

      const makeRadioGroup = (groupId, options) => {
        const sorted = [...options].sort((a, b) => (fieldY(a) || 0) - (fieldY(b) || 0) || fieldX(a) - fieldX(b))
        const ys = sorted.map(fieldY).filter((value) => value != null)
        return {
          id: groupId,
          label: this.getPraticaRadioGroupLabel(groupId, sorted),
          options: sorted.map((field) => ({
            key: field.key,
            label: this.getPraticaRadioOptionLabel(field),
          })),
          orientation: this.getPraticaRadioOrientation(sorted),
          page: fieldPage(sorted[0]),
          yMin: ys.length ? Math.min(...ys) : 0,
          yMax: ys.length ? Math.max(...ys) : 0,
        }
      }

      const items = []
      fields.forEach((field) => {
        if (!field?.key || used.has(field.key)) return
        const groupId = this.getPraticaRadioGroupId(field)
        if (groupId && radioGroups.has(groupId)) {
          const options = radioGroups.get(groupId)
          options.forEach((option) => used.add(option.key))
          items.push({
            type: 'radio',
            id: `radio-${groupId}`,
            group: makeRadioGroup(groupId, options),
          })
          return
        }

        const page = fieldPage(field)
        const y = fieldY(field)
        const row = [field]
        used.add(field.key)
        if (y != null) {
          fields.forEach((other) => {
            if (!other?.key || used.has(other.key)) return
            const otherGroupId = this.getPraticaRadioGroupId(other)
            if (otherGroupId && radioGroups.has(otherGroupId)) return
            if (fieldPage(other) !== page) return
            const otherY = fieldY(other)
            if (otherY == null || Math.abs(otherY - y) > yThreshold) return
            row.push(other)
            used.add(other.key)
          })
          row.sort((a, b) => fieldX(a) - fieldX(b))
        }

        const checkboxes = row.filter((item) => item.type === 'checkbox')
        const others = row.filter((item) => item.type !== 'checkbox')

        if (checkboxes.length && others.length) {
          items.push({
            type: 'fields',
            id: `fields-cb-${field.key}`,
            fields: checkboxes,
            allCheckboxes: true,
            columns: this.getPraticaRowColumns(checkboxes),
          })
          items.push({
            type: 'fields',
            id: `fields-${others[0].key}`,
            fields: others,
            allCheckboxes: false,
            columns: this.getPraticaRowColumns(others),
          })
          return
        }

        items.push({
          type: 'fields',
          id: `fields-${field.key}`,
          fields: row,
          allCheckboxes: checkboxes.length === row.length,
          columns: this.getPraticaRowColumns(row),
        })
      })

      const merged = []
      items.forEach((item) => {
        const previous = merged[merged.length - 1]
        if (
          item.type === 'radio' &&
          previous &&
          (previous.type === 'radio' || previous.type === 'radio-row')
        ) {
          const previousGroups = previous.type === 'radio-row' ? previous.groups : [previous.group]
          const last = previousGroups[previousGroups.length - 1]
          const samePage = last.page === item.group.page
          const overlap =
            last.yMax >= item.group.yMin - yThreshold && item.group.yMax >= last.yMin - yThreshold
          if (samePage && overlap) {
            const groups = [...previousGroups, item.group]
            merged[merged.length - 1] = {
              type: 'radio-row',
              id: `radio-row-${groups.map((group) => group.id).join('-')}`,
              groups,
            }
            return
          }
        }
        merged.push(item)
      })

      return merged
    },

    isPraticaRadioSelected(group, key) {
      const values = this.praticaCompileValues || {}
      return values[key] === 'X' || values[key] === true
    },

    setPraticaRadioValue(group, key) {
      if (!group?.options?.length) return
      const nextValues = { ...this.praticaCompileValues }
      group.options.forEach((option) => {
        nextValues[option.key] = option.key === key ? 'X' : ''
      })
      this.praticaCompileValues = nextValues
    },

    openPraticaCompileDialog(file, group = null) {
      if (
        !file?.exists ||
        !file?.filename ||
        this.downloadingPraticaFile ||
        this.sendingPraticaEmail ||
        this.loadingPraticaPreview
      ) {
        return
      }

      const fields = Array.isArray(file?.form?.fields) ? file.form.fields : []
      if (!fields.length) {
        this.handleApiError(
          { message: 'Schema campi non disponibile per questo documento' },
          'Compilazione non disponibile'
        )
        return
      }

      this.praticaCompileFile = file
      this.praticaCompileGroup = group
      this.praticaCompileFields = fields
      this.praticaCompileValues = this.buildPraticaCompileValues(fields, file.filename)
      this.praticaPdfPreviewFilename = file.form?.title || file.filename
      this.revokePraticaPdfPreviewUrl()
      this.showPraticaPdfPreviewDialog = true
      // Nessun refresh automatico: l'utente clicca "Aggiorna anteprima"
    },

    async refreshPraticaCompilePreview() {
      if (!this.praticaCompileFile?.filename || this.loadingPraticaPreview) {
        return
      }

      this.loadingPraticaPreview = true
      try {
        if (!this.incallService) {
          this.incallService = new IncallService(this.$http, this.$eventBus)
        }

        const previousUrl = this.praticaPdfPreviewUrl
        const fieldsPayload = { ...this.praticaCompileValues }
        const previewUrl = await this.incallService.previewPraticaFile(
          this.praticaCompileFile.filename,
          fieldsPayload
        )
        this.praticaPdfPreviewUrl = previewUrl
        if (previousUrl) {
          URL.revokeObjectURL(previousUrl)
        }
      } catch (error) {
        this.handleApiError(error, 'Errore nell\'anteprima del PDF compilato')
      } finally {
        this.loadingPraticaPreview = false
      }
    },

    openPraticaPdfPreviewInNewTab() {
      if (this.praticaPdfPreviewUrl) {
        window.open(this.praticaPdfPreviewUrl, '_blank')
      }
    },

    async downloadCompiledPraticaPdf() {
      if (!this.praticaCompileFile?.filename || this.loadingPraticaPreview) {
        return
      }

      this.downloadingPraticaFile = this.praticaCompileFile.filename
      try {
        if (!this.incallService) {
          this.incallService = new IncallService(this.$http, this.$eventBus)
        }
        await this.incallService.downloadPraticaFile(this.praticaCompileFile.filename, {
          fill: true,
          fields: { ...this.praticaCompileValues },
        })
      } catch (error) {
        this.handleApiError(error, 'Errore nel download del PDF compilato')
      } finally {
        this.downloadingPraticaFile = null
      }
    },

    openEmailFromCompiledPratica() {
      if (!this.praticaCompileFile) {
        return
      }
      this.openPraticaEmailDialog(this.praticaCompileFile, this.praticaCompileGroup, {
        fields: { ...this.praticaCompileValues },
      })
    },

    closePraticaPdfPreviewDialog(force = false) {
      if (!force && this.loadingPraticaPreview) {
        return
      }
      if (this.praticaCompilePreviewTimeout) {
        clearTimeout(this.praticaCompilePreviewTimeout)
        this.praticaCompilePreviewTimeout = null
      }
      this.showPraticaPdfPreviewDialog = false
      this.revokePraticaPdfPreviewUrl()
      this.praticaPdfPreviewFilename = ''
      this.previewingPraticaFile = null
      this.praticaCompileFile = null
      this.praticaCompileGroup = null
      this.praticaCompileFields = []
      this.praticaCompileValues = {}
    },

    async loadPratichePdfFiles() {
      this.loadingPraticheFiles = true
      try {
        if (!this.incallService) {
          this.incallService = new IncallService(this.$http, this.$eventBus)
        }

        const response = await this.incallService.getPraticheFiles(this.getPraticaFilesContext())
        const items = Array.isArray(response?.data) ? response.data : []

        this.pratichePdfGroups = items
          .map((item) => ({
            id: item.id,
            code: item.code,
            name: item.name,
            files: Array.isArray(item.files) ? item.files : [],
          }))
          .filter((item) => item.files.length > 0)
      } catch (error) {
        this.pratichePdfGroups = []
        this.handleApiError(error, 'Errore nel recupero dei PDF pratiche')
      } finally {
        this.loadingPraticheFiles = false
      }
    },

    async downloadPraticaPdf(file) {
      if (
        !file?.exists ||
        !file?.filename ||
        this.downloadingPraticaFile ||
        this.sendingPraticaEmail ||
        this.loadingPraticaPreview
      ) {
        return
      }

      this.downloadingPraticaFile = file.filename
      try {
        if (!this.incallService) {
          this.incallService = new IncallService(this.$http, this.$eventBus)
        }
        await this.incallService.downloadPraticaFile(file.filename)
      } catch (error) {
        this.handleApiError(error, 'Errore nel download del PDF pratica')
      } finally {
        this.downloadingPraticaFile = null
      }
    },

    openPraticaEmailDialog(file, group = null, options = {}) {
      if (
        !file?.exists ||
        !file?.filename ||
        this.downloadingPraticaFile ||
        this.sendingPraticaEmail
      ) {
        return
      }

      if (this.loadingPraticaPreview && !options.fields) {
        return
      }

      const praticaName = this.getIncallPraticaDisplayName(group, file)
      const contactName = this.getContactDisplayName() || 'Cliente'
      const fields = options.fields && typeof options.fields === 'object'
        ? options.fields
        : null

      this.praticaEmailForm = {
        filename: file.filename,
        praticaName,
        praticaCode: group?.code || '',
        email: this.selectedUser?.email || '',
        subject: `Documentazione pratica - ${praticaName}`,
        body: [
          `Gentile ${contactName},`,
          '',
          `in allegato trova la documentazione relativa alla pratica "${praticaName}".`,
          '',
          'La invitiamo a verificare il modulo, firmarlo e datarlo dove richiesto.',
          '',
          'Cordiali saluti,',
          'AGF ENERGY',
        ].join('\n'),
        nominativo: contactName,
        contatto: this.normalizePraticaPhone(this.selectedUser?.telefono || ''),
        fields,
      }
      this.praticaEmailSendMode = 'email'
      this.showPraticaEmailDialog = true
    },

    closePraticaEmailDialog() {
      if (this.sendingPraticaEmail) {
        return
      }
      this.showPraticaEmailDialog = false
      this.praticaEmailSendMode = 'email'
      this.praticaEmailForm = {
        filename: '',
        praticaName: '',
        praticaCode: '',
        email: '',
        subject: '',
        body: '',
        nominativo: '',
        contatto: '',
        fields: null,
      }
    },

    getPraticaFilesContext() {
      const ticketContext = this.getPraticaEmailTicketContext()
      return {
        idCliente: ticketContext.idCliente,
        idRappresentante: ticketContext.idRappresentante,
        idAssignedUser: ticketContext.idAssignedUser,
        assignedUserType: ticketContext.assignedUserType,
      }
    },

    normalizePraticaPhone(phone) {
      const digits = String(phone || '').replace(/\D/g, '')
      if (digits.length >= 10) {
        return digits.slice(-10)
      }
      return digits
    },

    formatPraticaSignDate(value) {
      if (!value) return ''
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) {
        return value
      }
      return date.toLocaleString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },

    submitPraticaEmailDialog() {
      if (this.praticaEmailSendMode === 'otp') {
        this.sendPraticaOtpSign()
        return
      }
      this.sendPraticaPdfEmail()
    },

    async sendPraticaOtpSign() {
      if (!this.canSendPraticaEmail || this.sendingPraticaEmail) {
        return
      }

      this.sendingPraticaEmail = true
      try {
        if (!this.incallService) {
          this.incallService = new IncallService(this.$http, this.$eventBus)
        }

        const ticketContext = this.getPraticaEmailTicketContext()
        const result = await this.incallService.sendPraticaOtpSign({
          filename: this.praticaEmailForm.filename,
          pratica_name: this.praticaEmailForm.praticaName || '',
          pratica_code: this.praticaEmailForm.praticaCode || '',
          email: this.praticaEmailForm.email.trim(),
          nominativo: this.praticaEmailForm.nominativo.trim(),
          contatto: this.praticaEmailForm.contatto.trim(),
          cliente_nome: ticketContext.clienteNome || '',
          fill: !!(this.praticaEmailForm.fields && Object.keys(this.praticaEmailForm.fields).length),
          fields: this.praticaEmailForm.fields || null,
          ...ticketContext,
        })

        if (result?.success) {
          if (this.$toast) {
            this.$toast.add({
              severity: 'success',
              summary: 'Richiesta OTP inviata',
              detail: result.message || `Richiesta firma inviata a ${this.praticaEmailForm.email}`,
              life: 3000,
            })
          }
          this.sendingPraticaEmail = false
          this.closePraticaEmailDialog()
          await this.loadPratichePdfFiles()
          await this.refreshTicketsBlock()
        } else {
          this.handleApiError(
            { message: result?.message || 'Invio OTP non riuscito' },
            'Errore nell\'invio della richiesta firma OTP'
          )
        }
      } catch (error) {
        this.handleApiError(error, 'Errore nell\'invio della richiesta firma OTP')
      } finally {
        this.sendingPraticaEmail = false
      }
    },

    async downloadSignedPraticaPdf(codRichiestaFirma) {
      if (!codRichiestaFirma || this.downloadingSignedPraticaFile) {
        return
      }

      this.downloadingSignedPraticaFile = codRichiestaFirma
      try {
        if (!this.incallService) {
          this.incallService = new IncallService(this.$http, this.$eventBus)
        }
        await this.incallService.downloadSignedPraticaFile(codRichiestaFirma)
        await this.loadPratichePdfFiles()
      } catch (error) {
        this.handleApiError(error, 'Errore nel download del PDF firmato')
      } finally {
        this.downloadingSignedPraticaFile = null
      }
    },

    getPraticaEmailTicketContext() {
      const isRappresentante =
        this.selectedSearchType === 'rappresentante' ||
        this.selectedUser?.entity_type === 'rappresentante'

      const clienteNome = this.getContactDisplayName() || ''

      if (isRappresentante) {
        const idRappresentante = Number(this.selectedUser?.id) || 0
        return {
          clienteNome,
          idCliente: 0,
          idRappresentante,
          idAssignedUser: idRappresentante,
          assignedUserType: 'rappresentante',
        }
      }

      const idCliente = Number(this.selectedUser?.client_id || this.selectedUser?.id) || 0
      return {
        clienteNome,
        idCliente,
        idRappresentante: 0,
        idAssignedUser: idCliente,
        assignedUserType: 'client',
      }
    },

    async sendPraticaPdfEmail() {
      if (!this.canSendPraticaEmail || this.sendingPraticaEmail) {
        return
      }

      this.sendingPraticaEmail = true
      try {
        if (!this.incallService) {
          this.incallService = new IncallService(this.$http, this.$eventBus)
        }

        const ticketContext = this.getPraticaEmailTicketContext()

        const result = await this.incallService.downloadPraticaFile(this.praticaEmailForm.filename, {
          sendEmail: true,
          email: this.praticaEmailForm.email.trim(),
          subject: this.praticaEmailForm.subject.trim(),
          body: this.praticaEmailForm.body,
          praticaName: this.praticaEmailForm.praticaName || '',
          fill: !!(this.praticaEmailForm.fields && Object.keys(this.praticaEmailForm.fields).length),
          fields: this.praticaEmailForm.fields || null,
          ...ticketContext,
        })

        if (result?.success) {
          if (this.$toast) {
            this.$toast.add({
              severity: 'success',
              summary: 'Email inviata',
              detail: result.message || `PDF inviato a ${this.praticaEmailForm.email}`,
              life: 3000,
            })
          }
          this.sendingPraticaEmail = false
          this.closePraticaEmailDialog()
          await this.refreshTicketsBlock()
        } else {
          this.handleApiError(
            { message: result?.message || 'Invio email non riuscito' },
            'Errore nell\'invio del PDF pratica'
          )
        }
      } catch (error) {
        this.handleApiError(error, 'Errore nell\'invio del PDF pratica')
      } finally {
        this.sendingPraticaEmail = false
      }
    },

    async refreshTicketsBlock() {
      await this.$nextTick()
      const block = this.$refs.ticketsBlock
      if (block && typeof block.loadAllTickets === 'function') {
        await block.loadAllTickets()
      }
    },

    openBloccoCalamitaDialog() {
      this.showBloccoCalamitaDialog = true;
      this.loadBloccoCalamitaChecks();
    },

    closeBloccoCalamitaDialog() {
      this.showBloccoCalamitaDialog = false;
      this.calamitaDocumentoCaricato = {};
      this.calamitaCheckLoading = {};
    },

    async loadBloccoCalamitaChecks() {
      if (!this.puntiCalamita || this.puntiCalamita.length === 0) return;
      const loading = { ...this.calamitaCheckLoading };
      this.puntiCalamita.forEach(pdr => { loading[pdr.code] = true; });
      this.calamitaCheckLoading = loading;

      const baseUrl = `${services.ask_pratiche.url}/incall/get-richiesta-blocco-sospensione`;

      await Promise.all(
        this.puntiCalamita.map(async (pdr) => {
          const params = pdr.cod_pod > 0
            ? { pod_id: pdr.cod_pod }
            : { pdr_id: pdr.cod_pdr };
          const qs = new URLSearchParams(params).toString();
          try {
            const response = await this.$http.get(`${baseUrl}?${qs}`);
            const data = response.data || {};
            const exists = data.success && data.exists === true;
            const dettaglio = data.data || {};

            this.calamitaDocumentoCaricato = {
              ...this.calamitaDocumentoCaricato,
              [pdr.code]: exists
            };

            this.calamitaDettagli = {
              ...this.calamitaDettagli,
              [pdr.code]: exists
                ? {
                    ...(this.calamitaDettagli[pdr.code] || {}),
                    data_inserimento: dettaglio.data_inserimento || null,
                    data_fine: dettaglio.data_fine || null,
                    path: dettaglio.path || null
                  }
                : null
            };
          } catch (e) {
            this.calamitaDocumentoCaricato = {
              ...this.calamitaDocumentoCaricato,
              [pdr.code]: false
            };
          }
          this.calamitaCheckLoading = {
            ...this.calamitaCheckLoading,
            [pdr.code]: false
          };
        })
      );
    },

    triggerBloccoFileInput(code) {
      const el = document.getElementById(`file-blocco-${code}`);
      if (el) {
        el.click();
      }
    },

    onSelectBloccoFile(pdr, event) {
      const file = event.target.files && event.target.files[0];
      if (!file) {
        return;
      }

      const ext = file.name.split('.').pop().toLowerCase();
      const allowed = ['pdf', 'jpg', 'jpeg', 'png'];
      if (!allowed.includes(ext)) {
        if (this.$toast) {
          this.$toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Il file deve essere un PDF o un\'immagine (jpg, jpeg, png)',
            life: 3000
          });
        } else {
          alert('Il file deve essere un PDF o un\'immagine (jpg, jpeg, png)');
        }
        event.target.value = '';
        return;
      }

      const current = this.calamitaUploads[pdr.code] || {};
      this.calamitaUploads = {
        ...this.calamitaUploads,
        [pdr.code]: {
          ...current,
          file,
          fileName: file.name,
          uploading: false,
          success: false,
          error: null
        }
      };
    },

    async confirmBloccoUpload(pdr) {
      const uploadState = this.calamitaUploads[pdr.code];
      if (!uploadState || !uploadState.file) {
        if (this.$toast) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Attenzione',
            detail: 'Seleziona prima un documento PDF',
            life: 3000
          });
        } else {
          alert('Seleziona prima un documento PDF');
        }
        return;
      }

      this.calamitaUploads = {
        ...this.calamitaUploads,
        [pdr.code]: {
          ...uploadState,
          uploading: true,
          success: false,
          error: null
        }
      };

      try {
        const formData = new FormData();
        formData.append('file', uploadState.file);

        if (pdr.cod_pod > 0) {
          formData.append('pod_id', pdr.cod_pod);
        } else if (pdr.cod_pdr > 0) {
          formData.append('pdr_id', pdr.cod_pdr);
        } else {
          throw new Error('ID POD/PDR non valido');
        }

        const response = await this.$http.post(
          `${services.ask_pratiche.url}/incall/upload-documento-richiesta-blocco-sospensione`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );

        const data = response.data || {};
        if (!data.success) {
          throw new Error(data.message || 'Errore nel caricamento del documento');
        }

        this.calamitaUploads = {
          ...this.calamitaUploads,
          [pdr.code]: {
            ...uploadState,
            uploading: false,
            success: true,
            error: null
          }
        };

        this.calamitaDocumentoCaricato = {
          ...this.calamitaDocumentoCaricato,
          [pdr.code]: true
        };

        if (this.$toast) {
          this.$toast.add({
            severity: 'success',
            summary: 'Successo',
            detail: 'Documento caricato correttamente',
            life: 3000
          });
        }
      } catch (error) {
        this.calamitaUploads = {
          ...this.calamitaUploads,
          [pdr.code]: {
            ...uploadState,
            uploading: false,
            success: false,
            error: error.message || 'Errore nel caricamento del documento'
          }
        };
        this.handleApiError(error, 'Errore nel caricamento del documento di blocco sospensione');
      }
    },

    openQuietanzaDialog() {
      this.selectedFattureQuietanza = [];
      this.showSelezioneFattureDialog = true;
    },

    openEmailBonariaDialog() {
      this.selectedFattureEmailBonaria = [];
      this.showEmailBonariaDialog = true;
    },

    closeEmailBonariaDialog() {
      this.showEmailBonariaDialog = false;
      this.selectedFattureEmailBonaria = [];
    },

    openCallDialog() {
      if (!this.selectedUser.telefono || this.selectedUser.telefono === 'Non disponibile') {
        if (this.$toast) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Attenzione',
            detail: 'Numero di telefono non disponibile',
            life: 3000,
          });
        }
        return;
      }
      this.showCallDialog = true;
    },

    closeCallDialog() {
      this.showCallDialog = false;
    },

    async confirmCall() {

      try {
        const result = await this.incallService.makeCall(
          this.getCurrentUserId(),
          this.selectedUser.telefono,
          ''
        );

        if (this.$toast) {
          if (result && result.success) {
            this.$toast.add({
              severity: 'success',
              summary: 'Chiamata avviata',
              detail: result.message || 'Chiamata avviata con successo',
              life: 3000,
            });

            this.currentCallId = result.chiamata_id || null;

            this.closeCallDialog();
            this.openCallNotesDialog();
          } else {
            this.$toast.add({
              severity: 'info',
              summary: 'Esito chiamata',
              detail: (result && result.message) || 'Richiesta di chiamata inviata',
              life: 3000,
            });

            this.currentCallId = result.chiamata_id || null;

            this.closeCallDialog();
            this.openCallNotesDialog();
          }
        }
      } catch (error) {
        if (this.$toast) {
          this.$toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Errore durante l\'avvio della chiamata',
            life: 3000,
          });
        }
      } finally {
        this.closeCallDialog();
      }
    },

    openCallNotesDialog() {
      this.showCallNotesDialog = true
    },

    closeCallNotesDialog() {
      this.showCallNotesDialog = false
    },

    async saveCallNotes() {
      try {
        this.savingCallNotes = true

        await this.incallService.saveCallNotes(
          this.currentCallId,
          this.callNotes
        )

        if (this.$toast) {
          this.$toast.add({
            severity: 'success',
            summary: 'Appunti salvati',
            detail: 'Gli appunti della chiamata sono stati salvati correttamente',
            life: 3000,
          })
        }

        console.log('Appunti chiamata salvati:', this.callNotes)

        this.closeCallNotesDialog()
      } catch (error) {
        if (this.$toast) {
          this.$toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Errore durante il salvataggio degli appunti',
            life: 3000,
          })
        }
      } finally {
        this.savingCallNotes = false
      }
    },

    getCurrentUserId() {
      try {
        const userStr = localStorage.getItem('user');
        if (!userStr) return null;
        
        const user = JSON.parse(atob(userStr));
        
        if (user.user && Array.isArray(user.user) && user.user.length > 0) {
          return user.user[0].id || user.user[0].cod_user || user.user[0].user_id || null;
        }
        if (Array.isArray(user) && user.length > 0) {
          return user[0].id || user[0].cod_user || user[0].user_id || null;
        }
        return user.id || user.cod_user || user.user_id || null;
      } catch (error) {
        console.error('Errore nel recupero ID utente:', error);
        return null;
      }
    },

    async confermaInvioEmailBonaria() {
      if (this.selectedFattureEmailBonaria.length === 0) {
        this.$toast.add({ 
          severity: 'warn', 
          summary: 'Attenzione', 
          detail: 'Seleziona almeno una fattura per inviare l\'email bonaria',
          life: 3000 
        });
        return;
      }

      const userId = this.getCurrentUserId();
      if (!userId) {
        this.$toast.add({ 
          severity: 'error', 
          summary: 'Errore', 
          detail: 'Impossibile recuperare l\'ID utente corrente',
          life: 3000 
        });
        return;
      }

      this.sendingEmailBonaria = true;

      try {
        const result = await this.incallService.inviaEmailBonaria(this.selectedFattureEmailBonaria, userId);
        
        if (result && result.message) {
          this.$toast.add({ 
            severity: 'success', 
            summary: 'Successo', 
            detail: result.message,
            life: 5000 
          });

          if (result.email_non_trovate && result.email_non_trovate.length > 0) {
            this.$toast.add({ 
              severity: 'warn', 
              summary: 'Attenzione', 
              detail: `Email non trovate per ${result.email_non_trovate.length} clienti`,
              life: 5000 
            });
          }

          this.closeEmailBonariaDialog();
        }
      } catch (error) {
        this.handleApiError(error, 'Errore nell\'invio delle email bonarie');
      } finally {
        this.sendingEmailBonaria = false;
      }
    },

    async openSmsDialog() {
      this.showSmsDialog = true;
      this.selectedSmsTemplate = null;
      this.caricaSms();
    },

    async caricaSms() {
      try {
        const result = await this.incallService.getSmsTemplates();
        this.smsTemplates = result.data;
        this.smsTemplatesCategories = result.categories;
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante l\'avvio della chiamata',
          life: 3000,
        });
      }
    },

    closeSmsDialog() {
      this.showSmsDialog = false;
      this.selectedSmsTemplate = null;
    },

    templatesByCategory(cat) {
      return (this.smsTemplates || []).filter(t => t.category === cat);
    },

    selectTemplate(tpl) {
      this.selectedSmsTemplate = tpl;
    },

    snippet(text, max = 90) {
      const t = (text || "").replace(/\s+/g, " ").trim();
      return t.length > max ? t.slice(0, max) + "..." : t;
    },

    async confermaInvioSms() {
      if (!this.selectedSmsTemplate) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Seleziona il messaggio da inviare',
          life: 3000
        });
        return;
      }

      if (!this.selectedSmsTemplate.body.trim()) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Il messaggio è vuoto',
          life: 3000
        });
        return;
      }

      // invio sms
      try {
        const result = await this.incallService.sendSms(this.selectedUser.telefono, this.selectedSmsTemplate.body, this.selectedSearchType);

        if(result.ok) {
          this.$toast.add({
            severity: 'success',
            summary: 'INVIATO',
            detail: 'SMS Inviato Con Successo',
            life: 10000,
          });
        }
      } catch (error) {
        const data = error?.response?.data;

        const messages = data?.errors
          ? Object.values(data.errors).flat()
          : [data?.message || 'Errore durante l\'invio dell\'SMS'];

        this.$toast.add({
          severity: 'error',
          summary: 'Errore validazione',
          detail: messages.join('\n'),
          life: 10000,
        });
      }
    },

    confermaSelezioneFatture() {
      if (this.selectedFattureQuietanza.length === 0) {
        alert('Seleziona almeno una fattura per creare la quietanza');
        return;
      }
      const isRappresentante = this.selectedSearchType === 'rappresentante';
      const fattureSelezionate = this.fattureInsolute.filter(fattura => 
        this.selectedFattureQuietanza.includes(fattura.numero)
      );
      
      this.quietanzaData = fattureSelezionate.map(fattura => {
        const rappresentante = isRappresentante ? 
          this.selectedUser.nome : 
          (this.selectedUser.agente_name || fattura.agente_name || fattura.rappresentante || 'Rappresentante');
        
        const cliente = isRappresentante ? 
          (fattura.cliente_ragsoc || `${fattura.cliente_nome || ''} ${fattura.cliente_cognome || ''}`.trim() || 'Cliente') :
          (this.selectedUser.ragsoc || `${this.selectedUser.nome || ''} ${this.selectedUser.cognome || ''}`.trim() || 'Cliente');
        
        return {
          numero: fattura.numero,
          rappresentante: rappresentante,
          ragsoc: cliente,
          saldo: parseFloat(fattura.saldo_fattura) || 0
        };
      });
      
      
      this.processQuietanzaData();
      
      this.showSelezioneFattureDialog = false;
      this.showQuietanzaDialog = true;
    },

    closeSelezioneFattureDialog() {
      this.showSelezioneFattureDialog = false;
      this.selectedFattureQuietanza = [];
    },

    closeQuietanzaDialog() {
      this.showQuietanzaDialog = false;
      this.quietanzaData = null;
    },

    processQuietanzaData() {
      this.processedQuietanzaData = [];
      this.selectedQuietanzeInline = [];
      let arr = [];
      
      this.quietanzaData.forEach(el => {
        if (!arr[el.rappresentante]) {
          arr[el.rappresentante] = {
            rapp: el.rappresentante,
            invoices: [],
            quietanze: [],
          };
        }
        arr[el.rappresentante]['invoices'].push(el);
        if (!arr[el.rappresentante]['quietanze'][el.ragsoc]) {
          arr[el.rappresentante]['quietanze'][el.ragsoc] = {
            cliente: el.ragsoc,
            date: new Date(),
            type_payment: 'Contanti',
            amount: 0,
            n_invoices: []
          };
        }
        arr[el.rappresentante]['quietanze'][el.ragsoc]['amount'] += el.saldo;
        arr[el.rappresentante]['quietanze'][el.ragsoc]['n_invoices'].push(el.numero);
      });

      for (const k in arr) {
        this.selectedQuietanzeInline.push(k);
        this.processedQuietanzaData.push(arr[k]);
      }
      
      this.processedQuietanzaData.forEach((el, i) => {
        for (const q in el.quietanze) {
          this.processedQuietanzaData[i]['quietanze'].push(this.processedQuietanzaData[i]['quietanze'][q]);
          delete this.processedQuietanzaData[i]['quietanze'][q];
        }
      });
    },

    eseguiQuietanza() {
      
      if (this.selectedQuietanzeInline.length === 0) {
        alert('Seleziona almeno una quietanza');
        return;
      }

      let temp = this.processedQuietanzaData.filter(el => this.selectedQuietanzeInline.includes(el.rapp));
      let isValid = temp.every(item => {
        return item.quietanze.every(q => q.amount != 0 && q.type_payment != '');
      });
      
      if (!isValid) {
        alert('Mezzo pagamento/importo non sono valorizzati o sono uguale a 0');
        return;
      }

      let objs = this.processedQuietanzaData.map(item => ({
        ...item,
        quietanze: item.quietanze.map(quietanza => ({
          ...quietanza,
          date: this.formatDateForExport(quietanza.date)
        }))
      })).filter(el => this.selectedQuietanzeInline.includes(el.rapp));

   
      this.downloadQuietanzaPdf(objs);
    },

    formatDateForExport(date) {
      if (!date) return '';
      const d = new Date(date);
      return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()}`;
    },

    async downloadQuietanzaPdf(data) {
      this.downloadingQuietanza = true;
      try {
        
        const blob = await this.incallService.downloadQuietanzaPdf(data);
        
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'quietanza.zip';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        this.closeQuietanzaDialog();
      } catch (error) {
        alert('Errore nel download del PDF: ' + (error.message || 'Errore sconosciuto'));
      } finally {
        this.downloadingQuietanza = false;
      }
    },

    async loadTotali() {
      if (!this.selectedAnnoPartenza) {
        this.totaliData = null;
        return;
      }

      this.loadingTotali = true;
      try {
        let idToSend = null;
        let tipo = 'cliente';

        if (this.selectedSearchType === 'rappresentante') {
          idToSend = this.selectedUser.id;
          tipo = 'rappresentante';
        } else {
          idToSend = this.selectedUser.client_id;
        }

        if (!idToSend) {
          this.totaliData = null;
          return;
        }

        const annoPartenza = this.selectedAnnoPartenza;
        const completo = (this.selectedTipoEstrattoTotali === 'completo') ? 1 : 0;
        const escludiCrediti = this.selectedTipoEstrattoTotali === 'escludi_crediti' ? 1 : 0;

        let codPod = null;
        let codPdr = null;
        if (this.selectedPuntoId) {
          const puntoSel = (this.pods || []).find(p => p.id === this.selectedPuntoId);
          if (puntoSel) {
            if ((puntoSel.tipo_punto || '').toLowerCase() === 'pod') {
              codPod = puntoSel.id; 
            } else if ((puntoSel.tipo_punto || '').toLowerCase() === 'pdr') {
              codPdr = puntoSel.id; 
            }
          }
        }

        let result;
        if (tipo === 'rappresentante') {
          result = await this.incallService.getTotaliEstrattiConto(null, 'rappresentante', idToSend, annoPartenza, completo, codPod, codPdr, escludiCrediti, this.selectedStatoFornituraTotali);
        } else {
          result = await this.incallService.getTotaliEstrattiConto(idToSend, 'cliente', null, annoPartenza, completo, codPod, codPdr, escludiCrediti, this.selectedStatoFornituraTotali);
        }

        if (result && result.data) {
          this.totaliData = result.data;
        } else if (result && (result.totali_per_mese || result.error)) {
          this.totaliData = result;
        } else {
          this.totaliData = null;
        }
      } catch (error) {
        this.totaliData = null;
      } finally {
        this.loadingTotali = false;
      }
    },

    formatMeseAnno(meseAnno) {
      const [year, month] = meseAnno.split('-');
      const monthNames = [
        'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
        'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
      ];
      return `${monthNames[parseInt(month) - 1]} ${year}`;
    },

    getTotaleFatture() {
      if (!this.totaliData || !this.totaliData.totali_per_mese || !Array.isArray(this.totaliData.totali_per_mese)) return 0;
      return this.totaliData.totali_per_mese.reduce((total, mese) => total + (mese.numero_fatture || 0), 0);
    }
  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');

* {
  font-family: 'Montserrat', sans-serif;
  box-sizing: border-box;
}

.incall-dashboard {
  max-width: 1800px;
  width: 100%;
  margin: 0 auto;
  padding: 1.5rem;
  background-color: #eef2f7;
  min-height: 100vh;
  box-sizing: border-box;
  overflow-x: hidden;
}


.search-header {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(13, 60, 97, 0.1);
  padding: 2rem;
  margin-bottom: 2rem;
  border: 1px solid rgba(13, 60, 97, 0.1);
  transition: padding 0.2s ease;
}

.search-header--collapsed {
  padding: 0.85rem 1.25rem;
  margin-bottom: 1.25rem;
}

.search-title-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 0;
}

.search-header--collapsed .search-title-container {
  margin-bottom: 0;
}

.search-title-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}

.search-title-text {
  min-width: 0;
}

.search-title-text h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.search-header--collapsed .search-title-text h2 {
  font-size: 1.05rem;
  letter-spacing: 0.04em;
}

.search-collapsed-summary {
  margin: 0.2rem 0 0;
  font-size: 0.85rem;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 52vw;
}

.back-button {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #666;
  padding: 8px;
  border-radius: 8px;
  flex-shrink: 0;
}

.back-button:hover {
  background: #f1f5f9;
  color: #0d3c61;
}

.back-button .pi {
  font-size: 1.2rem;
}

.search-collapse-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  flex-shrink: 0;
  padding: 0.45rem 0.85rem;
  border: 1px solid #c5d4e4;
  border-radius: 8px;
  background: #f8fafc;
  color: #0d3c61;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.search-collapse-btn:hover {
  background: #e8f1fb;
  border-color: #1a5490;
}

.search-bars-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  align-items: end;
}

.search-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.search-wrapper {
  position: relative;
  width: 100%;
}

.search-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #64748b !important;
  font-size: 1.3rem !important;
  font-weight: 900 !important;
  z-index: 2;
}

.search-input {
  width: 100%;
  padding: 1rem 1rem 1rem 3rem;
  border: 2px solid #e1edf7;
  border-radius: 10px;
  font-size: 0.95rem;
  font-family: inherit;
  transition: all 0.3s ease;
  background: white;
  font-weight: 500;
}

.search-input:focus {
  outline: none;
  border-color: #3388b3;
  box-shadow: 0 0 0 3px rgba(51, 136, 179, 0.1);
}

.clear-search {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  background: #374151;
  border: none;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 2;
}

.clear-search:hover {
  background: #374151;
  transform: translateY(-50%) scale(1.1);
}

.clear-search i {
  font-size: 1rem !important;
  font-weight: 900 !important;
  color: #374151 !important;
}

.search-label {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #0d3c61;
  text-align: center;
  padding: 0.25rem;
  background: linear-gradient(135deg, #e1edf7, #d1e3f4);
  border-radius: 6px;
  border: 1px solid rgba(13, 60, 97, 0.1);
}


.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 3rem;
}

.empty-state-content {
  text-align: center;
  max-width: 600px;
  background: white;
  padding: 3rem;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(13, 60, 97, 0.1);
  border: 1px solid rgba(13, 60, 97, 0.1);
}

.empty-icon {
  font-size: 4rem !important;
  color: #3388b3 !important;
  font-weight: 900 !important;
  margin-bottom: 1.5rem;
  opacity: 0.8;
}

.empty-title {
  font-size: 2rem;
  font-weight: 700;
  color: #0d3c61;
  margin-bottom: 1rem;
  font-family: 'Montserrat', sans-serif;
}

.empty-description {
  font-size: 1.1rem;
  color: #64748b;
  margin-bottom: 2rem;
  font-weight: 500;
  line-height: 1.6;
}

.search-instructions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
  max-width: 400px;
  margin: 0 auto;
}

.instruction-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: linear-gradient(135deg, #f8fafc, #e2e8f0);
  border-radius: 8px;
  width: 100%;
  border-left: 4px solid #3388b3;
  transition: all 0.2s ease;
}

.instruction-item:hover {
  transform: translateX(4px);
  box-shadow: 0 4px 12px rgba(51, 136, 179, 0.2);
}

.instruction-icon {
  font-size: 1.5rem !important;
  color: #3388b3 !important;
  font-weight: 900 !important;
  flex-shrink: 0;
}

.instruction-item span {
  font-size: 0.95rem;
  color: #0d3c61;
  font-weight: 500;
  text-align: left;
}

.instruction-item strong {
  color: #0d3c61;
  font-weight: 700;
}

.user-header {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(13, 60, 97, 0.1);
  padding: 2rem;
  margin-bottom: 2rem;
  border: 1px solid rgba(13, 60, 97, 0.1);
}

.header-top-row {
  display: grid;
  grid-template-columns: 3fr 1fr;
  gap: 2rem;
  align-items: center;
}

.user-name-container {
  display: flex;
  align-items: center;
}

.totale-insoluto-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.dashboard-title {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.totale-insoluto {
  font-size: 1.5rem;
  font-weight: 500;
  color: #d32f2f;
  background: rgba(211, 47, 47, 0.1);
  padding: 0.5rem 1rem;
  border-radius: 25px;
  border: 1px solid rgba(211, 47, 47, 0.3);
  white-space: nowrap;
}

.importo-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
  background: linear-gradient(135deg, #f0f7ff, #e8f4fd);
  padding: 1rem 1.5rem;
  border-radius: 10px;
  border-left: 4px solid #3388b3;
  box-shadow: 0 2px 10px rgba(51, 136, 179, 0.1);
}

.importo-label {
  font-weight: 600;
  color: #0d3c61;
  font-size: 0.9rem;
}

.importo-value {
  font-weight: 700;
  color: #3388b3;
  font-size: 1.8rem;
  letter-spacing: -0.01em;
}

.main-content {
  display: grid;
  grid-template-columns: minmax(200px, 260px) minmax(0, 1fr);
  gap: 1.25rem;
  align-items: start;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

.incall-right-column {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}

.tables-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
}

.user-details-card {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(13, 60, 97, 0.1);
  overflow: hidden;
  border: 1px solid rgba(13, 60, 97, 0.1);
  width: 100%;
  min-width: 0;
  max-width: none;
  height: auto;
}

.info-card-header {
  background: linear-gradient(135deg, #0d3c61, #1a5490);
  color: white;
  padding: 0.85rem 1rem;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-title {
  font-size: 1.05rem;
  font-weight: 600;
  margin: 0;
}

.toggle-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  font-size: 1.1rem !important;
  font-weight: 900 !important;
  color: white !important;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

.info-card-content {
  padding: 0.85rem 1rem;
}

.info-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0.65rem 0;
  border-bottom: 1px solid #e8eef5;
  gap: 0.15rem;
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  font-weight: 600;
  color: #64748b;
  min-width: 0;
  flex-shrink: 0;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.info-value {
  font-weight: 600;
  color: #1e3a5f;
  text-align: left;
  flex: 1;
  word-break: break-word;
  font-size: 0.9rem;
  width: 100%;
}
.ticket-search-container {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  padding: 1rem;
}

.ticket-search-container .search-wrapper {
  position: relative;
  max-width: 400px;
}

.ticket-search-container input {
  width: 100%;
  padding: 8px 12px 8px 35px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.ticket-search-container input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.ticket-search-container .pi-search {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  font-size: 0.9rem;
  pointer-events: none;
}

.ticket-search-container button {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 4px;
  border-radius: 2px;
  transition: color 0.2s ease;
}

.ticket-search-container button:hover {
  color: #333;
  background-color: rgba(0, 0, 0, 0.05);
}

.ticket-search-container .search-info {
  margin-top: 8px;
  font-size: 0.85rem;
  color: #666;
  font-style: italic;
}


.search-title-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 0;
  background-color: transparent;
  border-bottom: none;
}

.back-button {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  color: #666;
  margin-right: 0;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.2s ease;
  width: 40px;
  height: 40px;
  justify-content: center;
  flex-shrink: 0;
}

.back-button:hover {
  color: #333;
  background-color: #f8f9fa;
  transform: translateX(-2px);
}

.back-button .pi-arrow-left {
  font-size: 1.2rem;
}

.search-title-container h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
  text-transform: uppercase;
  letter-spacing: 1px;
}


.suggestions-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  max-height: 200px;
  overflow-y: auto;
}

.suggestion-item {
  padding: 10px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;
}

.suggestion-item:hover {
  background-color: #f8f9fa;
}

.suggestion-item:last-child {
  border-bottom: none;
}

.suggestion-item:active {
  background-color: #e9ecef;
}

.suggestion-primary {
  font-weight: 500;
  color: #333;
  font-size: 0.9rem;
}

.suggestion-secondary {
  font-size: 0.8rem;
  color: #666;
  margin-top: 2px;
}

.suggestion-empty {
  padding: 12px;
  color: #999;
  font-style: italic;
  text-align: center;
  font-size: 0.85rem;
}

.loading-suggestions {
  position: absolute;
  right: 35px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
}

.loading-suggestions i {
  font-size: 0.8rem;
}

.search-container {
  position: relative;
}

.back-button {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #666;
  margin-right: 1rem;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.2s ease;
  width: 40px;
  height: 40px;
  justify-content: center;
}

.back-button:hover {
  color: #333;
  background-color: #f8f9fa;
  transform: translateX(-2px);
}

.back-button .pi-arrow-left {
  font-size: 1.2rem;
}

.search-title-container h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.back-button {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #666;
  font-size: 0.9rem;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.back-button:hover {
  color: #333;
  background-color: #f8f9fa;
}

.back-button .pi-arrow-left {
  margin-right: 8px;
  font-size: 0.8rem;
}

.search-title-container .search-title {
  margin-left: auto;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
}

.tickets-table-container {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(13, 60, 97, 0.1);
  overflow: hidden;
  border: 1px solid rgba(13, 60, 97, 0.1);
  margin-top: 2rem;
}

.tickets-subsection {
  border-top: 1px solid #e8edf2;
}

.tickets-subsection:first-of-type {
  border-top: none;
}

.tickets-subsection-title {
  margin: 0;
  padding: 0.85rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: #0d3c61;
  background-color: #f8fafc;
  border-bottom: 1px solid #e8edf2;
}

.tickets-subsection-system .tickets-subsection-title {
  color: #5a6a7a;
}

.ticket-action-preview {
  margin: 0 0 0.5rem;
  font-weight: 600;
  color: #0d3c61;
}

.ticket-action-hint {
  margin: 0 0 1rem;
  color: #666;
  font-size: 0.9rem;
}

.ticket-action-buttons {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.ticket-action-btn {
  flex: 1;
  min-width: 140px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.ticket-details-summary {
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e8edf2;
}

.ticket-conversation-section {
  margin-top: 0.5rem;
}

.ticket-history-section {
  margin-bottom: 1rem;
}

.ticket-history-table th,
.ticket-history-table td {
  font-size: 0.85rem;
}

.ticket-conversation-title {
  margin: 0 0 0.75rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: #0d3c61;
}

.ticket-conversation-loading {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #666;
  padding: 1rem 0;
}

.ticket-messages-list {
  max-height: 320px;
  overflow-y: auto;
  padding: 0.5rem;
  background: #f8fafc;
  border: 1px solid #e8edf2;
  border-radius: 8px;
}

.ticket-message {
  margin-bottom: 0.75rem;
  padding: 0.75rem;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #e8edf2;
}

.ticket-message-own {
  background: #eef6ff;
  border-color: #cfe3f8;
}

.ticket-message-meta {
  font-size: 0.75rem;
  color: #666;
  margin-bottom: 0.35rem;
}

.ticket-message-content {
  font-size: 0.9rem;
  color: #333;
  word-break: break-word;
}

.ticket-reply-form {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e8edf2;
  width: 100%;
}

.ticket-reply-form .form-textarea {
  width: 100%;
  box-sizing: border-box;
  display: block;
}

.ticket-reply-transfer-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.call-transfer-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.82rem;
  font-weight: 600;
}

.call-transfer-badge--success {
  color: #166534;
  background: #ecfdf3;
}

.call-transfer-badge--failed {
  color: #b91c1c;
  background: #fef2f2;
}

.ticket-message-transfer {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin-bottom: 0.45rem;
  padding: 0.3rem 0.65rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 600;
}

.fatture-table-header {
  background: linear-gradient(135deg, #0d3c61, #1a5490);
  color: white;
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  flex-wrap: wrap;
  border-radius: 12px 12px 0 0;
}

.pdp-table-header {
  background: linear-gradient(135deg, #0d3c61, #1a5490);
  color: white;
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  flex-wrap: wrap;
  border-radius: 5px 5px 0 0;
}

.fatture-table-container {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(13, 60, 97, 0.1);
  overflow: hidden;
  border: 1px solid rgba(13, 60, 97, 0.1);
  min-width: 0;
  max-width: 100%;
}

.pdr-section {
  margin-top: 5px;
  padding-top: 5px;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}

.pdr-section .fatture-table-wrapper {
  max-height: 180px; 
  overflow-x: auto;
  overflow-y: auto;
  border-radius: 8px;
}


.pdr-section .fatture-table thead th {
  position: sticky;
  top: 0;
  background: #f8fafc;
  z-index: 10;
  border-bottom: 2px solid #e0e0e0;
}

.table-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.45rem;
  max-width: 100%;
  min-width: 0;
}

.add-ticket-btn {
  background: linear-gradient(135deg, #4CAF50, #45a049);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.add-ticket-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.add-ticket-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.add-icon {
  font-size: 1.2rem !important;
  font-weight: 900 !important;
  color: white !important;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

.fatture-table-wrapper {
  overflow-x: auto;
  max-width: 100%;
  max-height: 320px;
  overflow-y: auto;
}

.fatture-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.fatture-table thead {
  background: linear-gradient(135deg, #e1edf7, #d1e3f4);
}

.fatture-table th {
  padding: 1rem 0.75rem;
  text-align: left;
  font-weight: 600;
  color: #0d3c61;
  border-bottom: 2px solid #c5d3e4;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.fatture-table th.sortable {
  cursor: pointer;
  user-select: none;
  position: relative;
  transition: background-color 0.2s ease;
}

.fatture-table th.sortable:hover {
  background-color: rgba(13, 60, 97, 0.1);
}

.fatture-table th.sortable .sort-icon {
  margin-left: 0.5rem;
  display: inline-flex;
  align-items: center;
  color: #3388b3;
  font-size: 0.9rem;
}

.fatture-table th.sortable .sort-icon i {
  font-size: 0.75rem;
}

.fatture-table th .sort-button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.fatture-table td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid #e8eef5;
  color: #374151;
  font-weight: 500;
}

.fatture-table tbody tr:nth-child(even) {
  background-color: #f8fafc;
}

.fatture-table tbody tr:hover {
  background-color: #e8f4fd;
  transition: background-color 0.2s ease;
}

.row-ech {
  background-color: #ffe4b5 !important; 
}

.ech-legend {
  font-size: 0.8rem;
  font-weight: 400;
  margin-left: 0.1rem;
  opacity: 0.9;
}

.ech-legend-square {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 3px;
  background-color: #ffe4b5; 
  border: 1px solid #f59e0b;
  margin-right: 1px;
  vertical-align: middle;
}

.text-center {
  text-align: center !important;
}

.table-row {
  transition: all 0.2s ease;
}

.table-row:hover {
  transform: translateX(2px);
}

.ticket-type {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.2s ease;
}

.ticket-type:hover {
  transform: scale(1.05);
}

.type-dilazione {
  background: #e8f5e8;
  color: #2d5016;
}

.type-ticket {
  background: #e8f4fd;
  color: #1e40af;
}

.type-reclamo {
  background: #fef2f2;
  color: #dc2626;
}

.status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.2s ease;
}

.status-badge:hover {
  transform: scale(1.05);
}

.status-active {
  background: #d1fae5;
  color: #065f46;
}

.status-pending {
  background: #fef3c7;
  color: #92400e;
}

.status-resolved {
  background: #dbeafe;
  color: #1e40af;
}

.status-expired {
  background: #fee2e2;
  color: #dc2626;
}

.fattura-actions {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
}

.action-btn {
  background: white;
  border: 2px solid;
  padding: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.action-btn:hover .table-icon {
  transform: scale(1.1);
}

.view-btn {
  border-color: #6c757d;
  color: #6c757d;
}

.view-btn:hover {
  background: #6c757d;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}

.edit-btn {
  border-color: #3388b3;
  color: #3388b3;
}

.edit-btn:hover {
  background: #3388b3;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(51, 136, 179, 0.3);
}

.table-icon {
  font-size: 1.1rem !important;
  font-weight: 900 !important;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;
}

.no-data-message {
  text-align: center;
  padding: 2rem;
  color: #64748b;
  font-style: italic;
  background: linear-gradient(135deg, #f8fafc, #e2e8f0);
  border-radius: 8px;
  margin: 1rem;
}

.no-data-message::before {
  content: '📋';
  display: block;
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background: #f8fafc;
  border-top: 1px solid #e8eef5;
}

.pagination-info {
  font-size: 0.85rem;
  color: #64748b;
  font-weight: 500;
}

.pagination-controls {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.pagination-btn {
  background: white;
  border: 1px solid #d1d5db;
  color: #374151;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
  min-width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-btn:hover:not(:disabled) {
  background: #f3f4f6;
  border-color: #9ca3af;
  transform: translateY(-1px);
}

.pagination-btn:disabled {
  background: #f9fafb;
  color: #d1d5db;
  cursor: not-allowed;
  border-color: #e5e7eb;
}

.page-indicator {
  padding: 0.5rem 1rem;
  font-weight: 600;
  color: #0d3c61;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  min-width: 80px;
  text-align: center;
}

.pagination-icon {
  font-size: 1rem !important;
  font-weight: 900 !important;
}

.main-action-buttons {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 2rem;
  padding: 2rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(13, 60, 97, 0.1);
  border: 1px solid rgba(13, 60, 97, 0.1);
}

.main-action-btn {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem 3rem;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 700;
  font-size: 1.1rem;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  justify-content: center;
  text-transform: uppercase;
  border: 2px solid rgba(255, 255, 255, 0.2);
  font-family: 'Montserrat', sans-serif !important;
}

.main-icon {
  font-size: 2rem !important;
  font-weight: 900 !important;
  color: white !important;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease;
}

.main-action-btn span {
  font-size: 1rem;
  font-weight: 700;
  color: white;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  font-family: 'Montserrat', sans-serif !important;
}

.main-action-btn:hover .main-icon {
  transform: scale(1.1);
}

.main-action-btn.dilaziona-btn {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
}

.main-action-btn.dilaziona-btn:hover {
  background: linear-gradient(135deg, #059669, #047857);
  transform: translateY(-4px);
  box-shadow: 0 12px 35px rgba(16, 185, 129, 0.5);
  border-color: rgba(255, 255, 255, 0.4);
}

.main-action-btn.rimanda-btn {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: white;
}

.main-action-btn.rimanda-btn:hover {
  background: linear-gradient(135deg, #d97706, #b45309);
  transform: translateY(-4px);
  box-shadow: 0 12px 35px rgba(245, 158, 11, 0.5);
  border-color: rgba(255, 255, 255, 0.4);
}

.main-action-btn.distacca-btn {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: white;
}

.main-action-btn.distacca-btn:hover {
  background: linear-gradient(135deg, #dc2626, #b91c1c);
  transform: translateY(-4px);
  box-shadow: 0 12px 35px rgba(239, 68, 68, 0.5);
  border-color: rgba(255, 255, 255, 0.4);
}

.main-action-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.main-action-btn:disabled:hover {
  transform: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
}

.modal-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 1000px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: modalAppear 0.3s ease-out;
  max-height: 90vh;
  overflow-y: auto;
  font-family: 'Montserrat', sans-serif !important;
}

.modal-large {
  max-width: 900px;
}

.modal-ticket {
  max-width: 520px;
  width: 95%;
}

.modal-overlay-ticket {
  background-color: rgba(0, 0, 0, 0.35);
  backdrop-filter: none;
}

.modal-drag-handle {
  cursor: grab;
  user-select: none;
}

.modal-drag-handle:active {
  cursor: grabbing;
}

.modal-ticket .modal-body {
  max-height: 50vh;
}

.modal-extra-large {
  max-width: 1200px;
  width: 95%;
}

@keyframes modalAppear {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.modal-header h3 {
  font-family: 'Montserrat', sans-serif !important;
  font-weight: 600 !important;
  margin: 0 !important;
}

.modal-header:not(.modal-header-view):not(.modal-header-create):not(.modal-header-email):not(.modal-header-success):not(.modal-header-error) h3 {
  color: rgb(0, 0, 0) !important;
}

.modal-header-view h3,
.modal-header-create h3,
.modal-header-email h3,
.modal-header-success h3,
.modal-header-error h3 {
  color: #fff !important;
}

.modal-header-view {
  background: linear-gradient(135deg, #0d3c61, #1a5490);
}

.modal-header-create {
  background: linear-gradient(135deg, #10b981, #059669);
}

.modal-header-email {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
}

.close-button {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  font-size: 1.2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.close-button:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.modal-body {
  padding: 1.5rem;
  max-height: 60vh;
  overflow-y: auto;
  font-family: 'Montserrat', sans-serif !important;
}

.ticket-details {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px solid #e8eef5;
}

.detail-row:last-child {
  border-bottom: none;
}

.modal-footer {
  padding: 1.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  border-top: 1px solid #e5e7eb;
  background: #f8fafc;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  font-family: 'Montserrat', sans-serif !important;
}

.btn-secondary {
  background: #64748b;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  min-width: 100px;
  font-family: 'Montserrat', sans-serif !important;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-secondary:hover {
  background: #475569;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(100, 116, 139, 0.3);
}

.btn-primary {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  min-width: 120px;
  font-family: 'Montserrat', sans-serif !important;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: center;
}

.btn-primary:hover:not(:disabled) {
  background: linear-gradient(135deg, #059669, #047857);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

.btn-riattiva {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: white;
  border: none;
  padding: 0.5rem 0.8rem;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s ease;
}

.pdp-code-cell {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.appuntamento-alert {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  border: 1px solid #f0c36d;
  background: #fff8e8;
  color: #9a6700;
  border-radius: 999px;
  padding: 0.15rem 0.45rem;
  cursor: pointer;
  line-height: 1;
  transition: transform 0.15s ease, background-color 0.15s ease;
}

.appuntamento-alert:hover {
  background: #ffefc6;
}

.appuntamento-alert:active {
  transform: scale(0.96);
}

.appuntamento-alert__dot {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: #e6a700;
  box-shadow: 0 0 0 0 rgba(230, 167, 0, 0.45);
  animation: appuntamento-pulse 1.6s infinite;
}

.appuntamento-alert .pi {
  font-size: 0.75rem;
}

@keyframes appuntamento-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(230, 167, 0, 0.45);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(230, 167, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(230, 167, 0, 0);
  }
}

.btn-riattiva:hover:not(:disabled) {
  background: linear-gradient(135deg, #d97706, #b45309);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
}

.btn-riattiva:disabled {
  opacity: 0.8;
  cursor: not-allowed;
  box-shadow: none !important;
  background: linear-gradient(135deg, #6b7280, #4b5563);
}

.col-azioni {
  text-align: center;
  width: 120px;
}

.ticket-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: #0d3c61;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-family: 'Montserrat', sans-serif !important;
}

.form-label i {
  font-size: 1rem;
  color: #3388b3;
}

.form-label .opzionale {
  font-weight: 400;
  font-size: 0.75rem;
  color: #64748b;
  text-transform: none;
}

.input-with-prefix {
  display: flex;
  align-items: center;
  border: 2px solid #e1edf7;
  border-radius: 8px;
  background: white;
  overflow: hidden;
}

.input-with-prefix .input-prefix {
  padding: 0.875rem 0 0.875rem 1rem;
  font-weight: 600;
  color: #3388b3;
  font-size: 0.9rem;
  white-space: nowrap;
  background: #f0f7ff;
  border-right: 1px solid #e1edf7;
}

.input-with-prefix .form-input {
  border: none;
  flex: 1;
}

.input-with-prefix .form-input:focus {
  box-shadow: none;
}

.descrizione-motivazione-prefix {
  padding: 0.5rem 1rem;
  background: #f0f7ff;
  border: 1px solid #e1edf7;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #0d3c61;
  margin-bottom: 0.5rem;
}

.form-input,
.form-select {
  padding: 0.875rem 1rem;
  border: 2px solid #e1edf7;
  border-radius: 8px;
  font-size: 0.95rem;
  font-family: 'Montserrat', sans-serif !important;
  transition: all 0.3s ease;
  background: white;
  font-weight: 500;
}

.form-input:focus,
.form-select:focus {
  outline: none;
  border-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

.form-textarea {
  padding: 0.875rem 1rem;
  border: 2px solid #e1edf7;
  border-radius: 8px;
  font-size: 0.95rem;
  font-family: 'Montserrat', sans-serif !important;
  transition: all 0.3s ease;
  background: white;
  font-weight: 500;
  resize: vertical;
  min-height: 120px;
}

css .form-textarea:focus {
  outline: none;
  border-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

.form-select {
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 1rem;
  padding-right: 3rem;
  cursor: pointer;
}

.char-counter {
  align-self: flex-end;
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 500;
}

.form-help {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: #64748b;
  font-style: italic;
  font-family: 'Montserrat', sans-serif !important;
}

.dilazione-question {
  text-align: center;
  padding: 1rem;
  font-family: 'Montserrat', sans-serif !important;
}

.dilazione-question p {
  font-size: 1.1rem;
  color: #0d3c61;
  font-weight: 600;
  margin: 0;
  font-family: 'Montserrat', sans-serif !important;
}

.checkbox-group {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.checkbox-label {
  font-weight: 500;
  color: #0d3c61;
  cursor: pointer;
  font-family: 'Montserrat', sans-serif !important;
}

.selected-contact-info {
  background: linear-gradient(135deg, #f0f7ff, #e8f4fd);
  border: 1px solid #c5d3e4;
  border-radius: 8px;
  padding: 1rem;
}

.info-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  color: #0d3c61;
  font-weight: 600;
}

.contact-summary {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.contact-details {
  font-size: 0.9rem;
  color: #64748b;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-spinner {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.loading-spinner i {
  font-size: 2rem;
  color: #3388b3;
}

.loading-spinner span {
  font-weight: 600;
  color: #0d3c61;
  font-family: 'Montserrat', sans-serif !important;
}


@media (max-width: 1200px) {
  .search-bars-container {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .search-label {
    font-size: 0.7rem;
  }

  .main-content {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .header-top-row {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    text-align: center;
  }

  .user-name-container {
    justify-content: center;
  }

  .importo-container {
    align-items: center;
  }

  .main-action-buttons {
    gap: 1rem;
  }

  .main-action-btn {
    min-width: 180px;
    padding: 1.3rem 2.5rem;
  }

  .empty-state-content {
    padding: 2rem;
  }

  .empty-title {
    font-size: 1.5rem;
  }

  .search-instructions {
    max-width: 100%;
  }

  .search-type-buttons {
    flex-direction: column;
    align-items: center;
  }

  .search-type-btn {
    min-width: 300px;
    padding: 1.5rem 2rem;
  }
}

@media (max-width: 768px) {
  .incall-dashboard {
    padding: 1rem;
  }

  .search-header {
    padding: 1.5rem;
  }

  .search-bars-container {
    gap: 1rem;
  }

  .search-input {
    padding: 0.8rem 0.8rem 0.8rem 2.8rem;
    font-size: 0.9rem;
  }

  .search-icon {
    left: 0.8rem !important;
    font-size: 1.2rem !important;
  }

  .clear-search {
    right: 0.8rem;
    width: 24px;
    height: 24px;
  }

  .search-label {
    font-size: 0.65rem;
    padding: 0.2rem;
  }

  .user-header {
    padding: 1.5rem;
  }

  .dashboard-title {
    font-size: 1.8rem !important;
  }

  .importo-value {
    font-size: 1.5rem;
  }

  .main-action-buttons {
    flex-direction: column;
    gap: 1rem;
    padding: 1.5rem;
  }

  .main-action-btn {
    width: 100%;
    min-width: auto;
    padding: 1.2rem 2rem;
  }

  .main-icon {
    font-size: 1.8rem !important;
  }

  .fatture-table {
    font-size: 0.75rem;
  }

  .fatture-table th,
  .fatture-table td {
    padding: 0.5rem 0.25rem;
  }

  .pagination-container {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .empty-state {
    min-height: 50vh;
    padding: 2rem;
  }

  .empty-state-content {
    padding: 1.5rem;
  }

  .empty-icon {
    font-size: 3rem !important;
  }

  .empty-title {
    font-size: 1.3rem;
  }

  .empty-description {
    font-size: 1rem;
  }

  .instruction-item {
    padding: 0.75rem;
  }

  .instruction-icon {
    font-size: 1.3rem !important;
  }

  .instruction-item span {
    font-size: 0.85rem;
  }

  .modal-content {
    width: 95%;
    margin: 1rem;
    max-height: 95vh;
  }

  .modal-large {
    max-width: 95%;
  }

  .modal-header {
    padding: 1rem;
  }

  .modal-body {
    padding: 1rem;
    max-height: 70vh;
  }

  .modal-footer {
    padding: 1rem;
    flex-direction: column;
    gap: 0.75rem;
  }

  .btn-secondary,
  .btn-primary {
    width: 100%;
    justify-content: center;
    min-width: auto;
  }

  .ticket-form {
    gap: 1rem;
  }

  .form-input,
  .form-select,
  .form-textarea {
    padding: 0.75rem;
    font-size: 0.9rem;
  }

  .form-label {
    font-size: 0.85rem;
  }

  .search-type-selection {
    padding: 1rem;
  }

  .search-type-selection h2 {
    font-size: 1.4rem;
    margin-bottom: 1.5rem;
  }

  .search-type-buttons {
    gap: 1rem;
  }

  .search-type-btn {
    min-width: 280px;
    padding: 1.5rem 1.5rem;
  }

  .search-type-btn i {
    font-size: 2rem;
  }

  .search-type-btn span {
    font-size: 1.1rem;
  }

  .search-type-btn small {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .search-header {
    padding: 1rem;
  }

  .search-input {
    padding: 0.7rem 0.7rem 0.7rem 2.5rem;
    font-size: 0.85rem;
  }

  .search-icon {
    left: 0.7rem !important;
    font-size: 1.1rem !important;
  }

  .clear-search {
    right: 0.7rem;
    width: 22px;
    height: 22px;
  }

  .clear-search i {
    font-size: 0.85rem !important;
  }

  .search-label {
    font-size: 0.6rem;
    letter-spacing: 0.5px;
  }

  .user-header {
    padding: 1rem;
  }

  .dashboard-title {
    font-size: 1.5rem !important;
  }

  .importo-value {
    font-size: 1.3rem;
  }

  .main-action-btn {
    padding: 1rem 1.5rem;
    font-size: 1rem;
  }

  .main-icon {
    font-size: 1.6rem !important;
  }

  .main-action-btn span {
    font-size: 0.9rem;
  }

  .action-btn {
    width: 32px;
    height: 32px;
    font-size: 0.9rem;
  }

  .info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }

  .info-label {
    min-width: auto;
    font-size: 0.85rem;
  }

  .info-value {
    text-align: left;
    font-size: 0.9rem;
    word-break: break-all;
  }

  .fattura-actions {
    gap: 0.25rem;
  }

  .ticket-type,
  .status-badge {
    font-size: 0.65rem;
    padding: 0.2rem 0.5rem;
  }

  .empty-state {
    padding: 1rem;
  }

  .empty-state-content {
    padding: 1rem;
  }

  .empty-icon {
    font-size: 2.5rem !important;
  }

  .empty-title {
    font-size: 1.1rem;
  }

  .empty-description {
    font-size: 0.9rem;
  }

  .instruction-item {
    padding: 0.5rem;
  }

  .instruction-icon {
    font-size: 1.1rem !important;
  }

  .instruction-item span {
    font-size: 0.8rem;
  }

  .modal-content {
    width: 98%;
    margin: 0.5rem;
    border-radius: 8px;
  }

  .modal-header {
    padding: 0.75rem;
    border-radius: 8px 8px 0 0;
  }

  .modal-header h3 {
    font-size: 1.1rem;
  }

  .close-button {
    width: 24px;
    height: 24px;
    font-size: 1rem;
  }

  .modal-body {
    padding: 0.75rem;
  }

  .modal-footer {
    padding: 0.75rem;
    border-radius: 0 0 8px 8px;
  }

  .form-input,
  .form-select,
  .form-textarea {
    padding: 0.625rem;
    font-size: 0.85rem;
  }

  .form-textarea {
    min-height: 100px;
  }

  .btn-secondary,
  .btn-primary {
    padding: 0.625rem 1rem;
    font-size: 0.9rem;
  }

  .search-type-selection {
    padding: 0.5rem;
  }

  .search-type-selection h2 {
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }

  .search-type-btn {
    min-width: 250px;
    padding: 1rem 1rem;
  }

  .search-type-btn i {
    font-size: 1.8rem;
    margin-bottom: 0.5rem;
  }

  .search-type-btn span {
    font-size: 1rem;
  }

  .search-type-btn small {
    font-size: 0.75rem;
  }
}

.search-wrapper:focus-within .search-icon {
  color: #3388b3;
  transform: translateY(-50%) scale(1.1);
}

.search-input:focus+.search-icon {
  color: #3388b3;
}

.search-input:focus,
.main-action-btn:focus,
.action-btn:focus,
.pagination-btn:focus,
.btn-secondary:focus,
.btn-primary:focus,
.add-ticket-btn:focus {
  outline: 2px solid #3388b3;
  outline-offset: 2px;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(51, 136, 179, 0.4);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(51, 136, 179, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(51, 136, 179, 0);
  }
}

.main-action-btn:focus {
  animation: pulse 1.5s infinite;
}

.loading {
  opacity: 0.6;
  pointer-events: none;
}

.loading::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  margin: -10px 0 0 -10px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3388b3;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.info-card-content .info-row:hover {
  background-color: #f8fafc;
  border-radius: 6px;
  margin: 0 -0.5rem;
  padding: 0.75rem 0.5rem;
}

.action-btn {
  position: relative;
}

.action-btn::before {
  content: attr(title);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #1f2937;
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
  margin-bottom: 5px;
}

.action-btn::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 4px solid transparent;
  border-top-color: #1f2937;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
  margin-bottom: 1px;
}

.action-btn:hover::before,
.action-btn:hover::after {
  opacity: 1;
}

.incall-dashboard *,
.modal-overlay * {
  font-family: 'Montserrat', sans-serif !important;
}

.pi {
  font-family: 'primeicons' !important;
}

/* La regola con "*" qui sopra, compilata scoped, arriva anche ai componenti figli (diventa
   .incall-dashboard[data-v-...] *), mentre .pi vale solo per le icone di questo file:
   senza questa, le icone dei figli (es. SupplyPraticheSection) si vedono come quadratini. */
.incall-dashboard :deep(.pi),
.modal-overlay :deep(.pi) {
  font-family: 'primeicons' !important;
}

i[class*="pi-"] {
  font-weight: 900 !important;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease,
    transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

.modal-content,
.loading-overlay,
.empty-state-content {
  transition: none;
}

.search-wrapper:focus-within {
  transform: scale(1.02);
}

.search-container:has(.search-input:focus) .search-label {
  background: linear-gradient(135deg, #3388b3, #0d3c61);
  color: white;
  transform: scale(1.05);
}

.form-input:invalid,
.form-select:invalid,
.form-textarea:invalid {
  border-color: #ef4444;
}

.form-input:valid,
.form-select:valid,
.form-textarea:valid {
  border-color: #10b981;
}

.search-highlight {
  background-color: #fef3c7;
  padding: 0.1rem 0.2rem;
  border-radius: 3px;
  font-weight: 600;
}

.main-action-btn:active {
  transform: translateY(-2px) scale(0.98);
}

.action-btn:active {
  transform: translateY(-1px) scale(0.95);
}

@media (prefers-color-scheme: dark) {
  .search-icon {
    color: #9ca3af !important;
  }

  .clear-search i {
    color: #e5e7eb !important;
  }
}

.search-type-selection {
  text-align: center;
  padding: 2rem;
}

.search-type-selection h2 {
  margin-bottom: 2rem;
  font-size: 1.8rem;
  font-weight: 700;
  color: #333;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.search-type-buttons {
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.search-type-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem 3rem;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  min-width: 250px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  position: relative;
  overflow: hidden;
  text-decoration: none;
  color: white;
}

.search-type-btn:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.3);
}

.search-type-btn i {
  font-size: 2.5rem;
  font-weight: 900;
  color: white;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease;
}

.search-type-btn:hover i {
  transform: scale(1.1);
}

.search-type-btn span {
  font-size: 1.3rem;
  font-weight: 700;
  color: white;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.search-type-btn small {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
  line-height: 1.4;
  font-weight: 400;
}

.cliente-btn {
  background: linear-gradient(135deg, #10b981, #059669);
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.cliente-btn:hover {
  background: linear-gradient(135deg, #059669, #047857);
  border-color: rgba(255, 255, 255, 0.4);
  box-shadow: 0 12px 35px rgba(16, 185, 129, 0.5);
}

.rappresentante-btn {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.rappresentante-btn:hover {
  background: linear-gradient(135deg, #d97706, #b45309);
  border-color: rgba(255, 255, 255, 0.4);
  box-shadow: 0 12px 35px rgba(245, 158, 11, 0.5);
}

.search-title-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 0;
  background-color: transparent;
  border-bottom: none;
}

.selected-representative-box {
  background: #f0f7ff;
  border: 1px solid #b6d4fe;
  border-radius: 10px;
  padding: 1.2rem 2rem;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  box-shadow: 0 2px 8px rgba(13, 60, 97, 0.07);
}

.col-pdp {
  width: 120px;
  min-width: 120px;
  max-width: 120px;
}

.col-cliente {
  width: 180px;
  min-width: 180px;
  max-width: 180px;
}

.col-indirizzo {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
}

.col-numero {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
}

.col-emissione {
  width: 90px;
  min-width: 90px;
  max-width: 90px;
}

.col-scadenza {
  width: 90px;
  min-width: 90px;
  max-width: 90px;
}

.col-importo {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  text-align: right;
}

.col-dataInserimento {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  text-align: right;
}

.col-stato {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  text-align: center;
}

.truncate-text {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.table-link {
  color: #3388b3;
  text-decoration: underline;
  transition: color 0.2s ease;
}

.table-link:hover {
  color: #0d3c61;
  text-decoration: none;
}

.fatture-table th.col-pdp,
.fatture-table td.col-pdp {
  width: 120px;
  min-width: 120px;
  max-width: 120px;
}

.fatture-table th.col-cliente,
.fatture-table td.col-cliente {
  width: 180px;
  min-width: 180px;
  max-width: 180px;
}

.fatture-table th.col-indirizzo,
.fatture-table td.col-indirizzo {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
}

.fatture-table th.col-numero,
.fatture-table td.col-numero {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
}

.fatture-table th.col-emissione,
.fatture-table td.col-emissione {
  width: 90px;
  min-width: 90px;
  max-width: 90px;
}

.fatture-table th.col-scadenza,
.fatture-table td.col-scadenza {
  width: 90px;
  min-width: 90px;
  max-width: 90px;
}

.fatture-table th.col-importo,
.fatture-table td.col-importo {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  text-align: right;
}

.fatture-table th.col-stato,
.fatture-table td.col-stato {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  text-align: center;
}

@media (max-width: 1200px) {
  .fatture-table-wrapper {
    max-height: 400px;
  }
  
  .col-pdp {
    width: 100px;
    min-width: 100px;
    max-width: 100px;
  }
  
  .col-cliente {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
  }
  
  .col-indirizzo {
    width: 160px;
    min-width: 160px;
    max-width: 160px;
  }
  
  .col-numero {
    width: 80px;
    min-width: 80px;
    max-width: 80px;
  }
  
  .col-emissione,
  .col-scadenza {
    width: 80px;
    min-width: 80px;
    max-width: 80px;
  }
  
  .col-importo {
    width: 90px;
    min-width: 90px;
    max-width: 90px;
  }
  
  .col-stato {
    width: 70px;
    min-width: 70px;
    max-width: 70px;
  }
}

@media (max-width: 768px) {
  .fatture-table {
    font-size: 0.75rem;
  }
  
  .fatture-table th,
  .fatture-table td {
    padding: 0.5rem 0.25rem;
  }
  
  .col-pdp {
    width: 80px;
    min-width: 80px;
    max-width: 80px;
  }
  
  .col-cliente {
    width: 120px;
    min-width: 120px;
    max-width: 120px;
  }
  
  .col-indirizzo {
    width: 130px;
    min-width: 130px;
    max-width: 130px;
  }
  
  .col-numero {
    width: 70px;
    min-width: 70px;
    max-width: 70px;
  }
  
  .col-emissione,
  .col-scadenza {
    width: 70px;
    min-width: 70px;
    max-width: 70px;
  }
  
  .col-importo {
    width: 80px;
    min-width: 80px;
    max-width: 80px;
  }
  
  .col-stato {
    width: 60px;
    min-width: 60px;
    max-width: 60px;
  }
}

.send-email-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: rgb(255, 255, 255);
  padding: 0.45rem 0.75rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  transition: all 0.2s ease;
  margin-left: 0;
  white-space: nowrap;
  font-size: 0.82rem;
  flex: 0 1 auto;
}

.ask-call-btn {
  background: rgb(15, 128, 21);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: rgb(255, 255, 255);
  padding: 0.4rem 0.4rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  transition: all 0.2s ease;
  margin-left: 0.4rem;
}

.send-email-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.send-email-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.add-icon {
  color: white;
}

.fatture-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  background: white;
}

.fatture-loader div {
  text-align: center;
}

.fatture-loader i {
  font-size: 2rem;
  color: #3388b3;
  margin-bottom: 1rem;
}

.fatture-loader p {
  color: #666;
  margin: 0;
}

.email-modal-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  background: white;
}

.email-modal-loader div {
  text-align: center;
}

.email-modal-loader i {
  font-size: 2rem;
  color: #3388b3;
  margin-bottom: 1rem;
}

.email-modal-loader p {
  color: #666;
  margin: 0;
}

.loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.loader-content small {
  font-size: 0.8rem;
  color: #666;
}

.info-message {
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.info-message i {
  font-size: 1.2rem;
}

.info-message strong {
  font-weight: 600;
}

.info-message {
  background: #e3f2fd;
  border: 1px solid #2196f3;
}

.info-message i {
  color: #2196f3;
}

.info-message:not(:has(i.pi-info-circle)) {
  background: #e8f5e8;
  border: 1px solid #4caf50;
}

.info-message:not(:has(i.pi-info-circle)) i {
  color: #4caf50;
}

.info-message.info-rappresentante {
  background: #e3f2fd;
  border: 1px solid #2196f3;
}

.info-message.info-rappresentante i {
  color: #2196f3;
}

.info-message.info-cliente {
  background: #e8f5e8;
  border: 1px solid #4caf50;
}

.info-message.info-cliente i {
  color: #4caf50;
}

.send-email-btn:has(i.pi-file-pdf) {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.25);
}

.send-email-btn:has(i.pi-file-pdf):hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.25);
}

.send-email-btn i.pi-file-pdf {
  color: #ff6b6b;
}

.send-estratto-btn {
  background: #667eea;
  border: 1px solid #5a6fd8;
  color: white;
  margin-left: 10px;
}

.send-estratto-btn:hover {
  background: #5a6fd8;
}

.send-bollettino-btn {
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: white;
  margin-left: 10px;
}

.send-bollettino-btn:hover {
  background: #667eea;
}

.send-bonaria-btn {
  background: rgba(255, 152, 0, 0.2);
  border: 1px solid rgba(255, 152, 0, 0.4);
  color: white;
  margin-left: 10px;
}

.send-bonaria-btn:hover {
  background: #ff9800;
}

.modal-small {
  max-width: 400px;
  width: 90%;
}

.modal-header-success {
  background: #4caf50;
  color: white;
}

.modal-header-error {
  background: #f44336;
  color: white;
}

.message-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1rem;
  padding: 1rem 0;
}

.message-content i {
  font-size: 3rem;
}

.message-content i.pi-check-circle {
  color: #4caf50;
}

.message-content i.pi-exclamation-triangle {
  color: #f44336;
}

.message-content p {
  margin: 0;
  font-size: 1.1rem;
  line-height: 1.5;
}

.selected-user-header {
  text-align: center;
  margin-bottom: 2rem;
}

.selected-user-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.totale-insoluto {
  font-size: 1.5rem;
  font-weight: 500;
  color: #d32f2f;
  margin-left: 2rem;
  background: rgba(211, 47, 47, 0.1);
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  border: 1px solid rgba(211, 47, 47, 0.3);
  margin-left: 10rem;
}

.add-dilazione-btn {
  background: linear-gradient(135deg, #FF9800, #F57C00);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.add-dilazione-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.3);
}

.add-dilazione-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.estratto-section {
  margin-bottom: 2rem;
}

.section-divider {
  border-top: 1px solid #e0e0e0;
  margin: 1.5rem 0;
}

.section-subtitle {
  font-size: 1.1rem;
  font-weight: 600;
  color: #0d3c61;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.section-subtitle i {
  color: #3388b3;
  font-size: 1rem;
}

.section-description {
  font-size: 0.9rem;
  color: #64748b;
  margin-bottom: 1rem;
  line-height: 1.4;
}

.estratto-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-start;
}

.clienti-list {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #f8f9fa;
}

.cliente-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #e0e0e0;
  background: white;
  transition: background-color 0.2s ease;
}

.cliente-item:last-child {
  border-bottom: none;
}

.cliente-item:hover {
  background: #f8f9fa;
}

.cliente-info {
  flex: 1;
  margin-right: 1rem;
}

.cliente-name {
  font-weight: 600;
  color: #0d3c61;
  margin-bottom: 0.25rem;
}

.cliente-details {
  font-size: 0.8rem;
  color: #64748b;
  display: flex;
  gap: 1rem;
}

.cliente-id {
  background: #e1edf7;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  font-weight: 500;
}

.cliente-saldo {
  color: #d32f2f;
  font-weight: 600;
}

.cliente-actions {
  display: flex;
  gap: 0.5rem;
  flex-shrink: 0;
}

.btn-secondary.btn-small {
  background: #64748b;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.8rem;
  font-weight: 500;
}

.btn-secondary.btn-small:hover {
  background: #475569;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-primary.btn-small {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.8rem;
  font-weight: 500;
}

.btn-primary.btn-small:hover {
  background: linear-gradient(135deg, #059669, #047857);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.no-clients-message {
  text-align: center;
  color: #64748b;
  font-style: italic;
  padding: 2rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px dashed #cbd5e1;
}

.no-clients-message i {
  font-size: 2rem;
  color: #94a3b8;
  margin-bottom: 0.5rem;
  display: block;
}

.no-clients-message p {
  margin: 0;
  font-size: 0.9rem;
}

.anno-selector-section {
  margin-bottom: 2rem;
  padding: 1rem;
  background: linear-gradient(135deg, #f8fafc, #e2e8f0);
  border-radius: 8px;
  border: 1px solid #cbd5e1;
}

.anno-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: #0d3c61;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-family: 'Montserrat', sans-serif !important;
  margin-bottom: 0.5rem;
}

.anno-label i {
  color: #3388b3;
  font-size: 1rem;
}

.anno-select {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #e1edf7;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #0d3c61;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 1rem;
  padding-right: 3rem;
}

.anno-select:focus {
  outline: none;
  border-color: #3388b3;
  box-shadow: 0 0 0 3px rgba(51, 136, 179, 0.1);
}

.anno-select:hover {
  border-color: #3388b3;
}

.anno-info {
  margin-top: 0.5rem;
  font-size: 0.75rem;
  color: #64748b;
  font-style: italic;
}

.cliente-fatture {
  background: #e1edf7;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  font-weight: 500;
  color: #3388b3;
}

.tipo-estratto-selector-section {
  margin-bottom: 2rem;
  padding: 1rem;
  background: linear-gradient(135deg, #f8fafc, #e2e8f0);
  border-radius: 8px;
  border: 1px solid #cbd5e1;
}

.estratto-filters-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.25rem;
}

.estratto-filter-col {
  min-width: 0;
}

@media (max-width: 720px) {
  .estratto-filters-row {
    grid-template-columns: 1fr;
  }
}

.punto-selector-section {
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: linear-gradient(135deg, #f8fafc, #e2e8f0);
  border-radius: 8px;
  border: 1px solid #cbd5e1;
}
.punto-selector-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #0d3c61;
}
.punto-selector-select {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  color: #0d3c61;
}
.punto-selector-info small {
  display: block;
  margin-top: 0.5rem;
  color: #64748b;
}

.tipo-estratto-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: #0d3c61;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-family: 'Montserrat', sans-serif !important;
  margin-bottom: 0.5rem;
}

.tipo-estratto-select {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #e1edf7;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #0d3c61;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 1rem;
  padding-right: 3rem;
}

.tipo-estratto-select:focus {
  outline: none;
  border-color: #3388b3;
  box-shadow: 0 0 0 3px rgba(51, 136, 179, 0.1);
}

.tipo-estratto-select:hover {
  border-color: #3388b3;
}

.tipo-estratto-info {
  margin-top: 0.5rem;
  font-size: 0.75rem;
  color: #64748b;
  font-style: italic;
}

.bollettino-info {
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.bollettino-info .section-description {
  margin: 0;
  font-size: 1rem;
  color: #334155;
  line-height: 1.6;
}

.bollettino-info strong {
  color: #0d3c61;
  font-weight: 600;
}

.bollettino-saldo-notice {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-top: 1rem;
  padding: 0.85rem 1rem;
  color: #075985;
  background: #e0f2fe;
  border: 1px solid #7dd3fc;
  border-left: 4px solid #0284c7;
  border-radius: 6px;
}

.bollettino-saldo-notice i {
  font-size: 1.15rem;
}

.bollettino-tipo-selector {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.85rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
}

.bollettino-tipo-label {
  font-weight: 600;
  color: #0d3c61;
}

.bollettino-tipo-option {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  color: #334155;
  font-size: 0.95rem;
}

.bollettino-tipo-option .p-radiobutton {
  cursor: pointer;
}

.fatture-selection {
  margin-bottom: 2rem;
}

.selection-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  padding: 1rem 1.25rem;
  background: #f1f5f9;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.select-all-label {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #0d3c61;
  cursor: pointer;
  font-size: 0.95rem;
}

.select-all-checkbox {
  margin-right: 0.75rem;
  transform: scale(1.2);
  accent-color: #3388b3;
}

.fatture-list {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: white;
}

.fattura-item {
  display: flex;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
}

.fattura-item:hover {
  background: #f8fafc;
}

.fattura-item:last-child {
  border-bottom: none;
}

.fattura-item.selected {
  background: #e1edf7;
  border-left: 3px solid #3388b3;
}

.fattura-item.disabled {
  opacity: 0.55;
}

.fattura-item.disabled .fattura-checkbox {
  cursor: not-allowed;
}

.fattura-checkbox {
  display: flex;
  align-items: center;
  margin-right: 1rem;
  cursor: pointer;
}

.fattura-checkbox-input {
  margin-right: 0.75rem;
  transform: scale(1.2);
  accent-color: #3388b3;
}

.fattura-info {
  flex: 1;
}

.fattura-numero {
  font-weight: 600;
  color: #0d3c61;
  margin-bottom: 0.5rem;
  font-size: 1rem;
}

.fattura-details {
  display: flex;
  gap: 1rem;
  font-size: 0.85rem;
  color: #64748b;
  flex-wrap: wrap;
}

.fattura-details span {
  background: #f8fafc;
  padding: 0.3rem 0.6rem;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  font-weight: 500;
}

.no-fatture-message {
  text-align: center;
  color: #64748b;
  font-style: italic;
  padding: 2rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px dashed #cbd5e1;
  margin: 1rem;
}

.no-fatture-message i {
  font-size: 2rem;
  color: #cbd5e1;
  margin-bottom: 0.5rem;
  display: block;
}

.no-fatture-message p {
  font-size: 1rem;
  margin: 0;
}

.bollettino-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1.5rem;
  border-top: 1px solid #e2e8f0;
  margin-top: 1.5rem;
}

.bollettino-actions .btn-primary {
  background: #3388b3;
  border: none;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
}

.bollettino-actions .btn-primary:hover {
  background: #0d3c61;
}

.bollettino-actions .btn-primary:disabled {
  background: #cbd5e1;
  cursor: not-allowed;
}

.bollettino-actions .btn-secondary {
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  color: #64748b;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  font-size: 1rem;
}

.bollettino-actions .btn-secondary:hover {
  background: #e2e8f0;
  border-color: #94a3b8;
}

.modal-content.modal-medium {
  max-width: 1500px;
  width: 95%;
  
  max-height: 90vh;
  overflow-y: auto;
}

.modal-content.bollettino-modal {
  width: 97%;
  max-width: 1750px;
  max-height: 96vh;
}

.bollettino-modal .modal-header {
  padding: 0.75rem 1rem;
}

.bollettino-modal .modal-body {
  padding: 0.75rem 1rem 1rem;
}

.bollettino-modal .bollettino-info {
  margin-bottom: 0.75rem;
  padding: 0.75rem 1rem;
}

.bollettino-modal .bollettino-saldo-notice {
  margin-top: 0.5rem;
  padding: 0.5rem 0.75rem;
}

.bollettino-modal .bollettino-tipo-selector {
  margin-top: 0.6rem;
  padding-top: 0.6rem;
}

.bollettino-modal .search-fatture-section {
  margin-bottom: 0.75rem;
  padding: 0.65rem;
}

.bollettino-modal .fatture-selection {
  margin-bottom: 0.75rem;
}

.bollettino-modal .selection-header {
  margin-bottom: 0.75rem;
  padding: 0.65rem 0.9rem;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.toggle-fatture-non-selezionabili {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.7rem;
  color: #0d3c61;
  background: #ffffff;
  border: 1px solid #94a3b8;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
}

.toggle-fatture-non-selezionabili:hover {
  color: #ffffff;
  background: #3388b3;
  border-color: #3388b3;
}

.bollettino-modal .fatture-list {
  max-height: 55vh;
  padding: 0.35rem;
  gap: 0.5rem;
}

.bollettino-modal .fattura-item {
  padding: 0;
}

.bollettino-modal .fattura-checkbox {
  margin-right: 0;
  padding: 0.65rem;
  min-height: 0;
}

.bollettino-modal .fattura-checkbox-input {
  margin-right: 0.6rem;
}

.bollettino-modal .fattura-numero {
  margin-bottom: 0.35rem;
}

.bollettino-modal .fattura-details {
  gap: 0.5rem;
  line-height: 1.35;
}

.bollettino-modal .fattura-details span {
  padding: 0.25rem 0.45rem;
}

.bollettino-modal .bollettino-actions {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
}

.modal-content.pratiche-pdf-modal {
  max-width: 640px;
}

.pratiche-pdf-loading,
.pratiche-pdf-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 2rem 1rem;
  color: #64748b;
  font-size: 0.95rem;
}

.pratiche-pdf-loading i {
  color: #3388b3;
  font-size: 1.25rem;
}

.pratiche-pdf-list {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  max-height: 60vh;
  overflow-y: auto;
}

.pratiche-pdf-group-title {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #0d3c61;
  font-size: 0.95rem;
}

.pratiche-pdf-group-title small {
  font-weight: 500;
  color: #94a3b8;
  font-size: 0.8rem;
}

.pratiche-pdf-files {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.pratiche-pdf-file-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.65rem 0.85rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f8fafc;
}

.pratiche-pdf-file-row.is-missing {
  color: #94a3b8;
  background: #f1f5f9;
}

.pratiche-pdf-file-info {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  min-width: 0;
  flex: 1;
}

.pratiche-pdf-file-text {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
}

.pratiche-pdf-file-info i {
  flex-shrink: 0;
  color: #3388b3;
}

.pratiche-pdf-file-row.is-missing i {
  color: #94a3b8;
}

.pratiche-pdf-file-actions {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-shrink: 0;
}

.pratiche-pdf-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.65rem;
  border: 1px solid #cbd5e1;
  border-radius: 5px;
  background: #fff;
  color: #0d3c61;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.pratiche-pdf-action-btn:hover:not(:disabled) {
  background: #eef6fb;
  border-color: #3388b3;
}

.pratiche-pdf-action-btn.is-email:hover:not(:disabled) {
  background: #f0fdf4;
  border-color: #16a34a;
}

.pratiche-pdf-action-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.pratiche-pdf-action-btn i {
  font-size: 0.85rem;
}

.pratiche-pdf-action-btn.is-preview:hover:not(:disabled) {
  background: #eff6ff;
  border-color: #93c5fd;
  color: #1d4ed8;
}

.pratiche-pdf-action-btn.is-signed:hover:not(:disabled) {
  background: #f0fdf4;
  border-color: #16a34a;
  color: #15803d;
}

.pratiche-pdf-sign-status {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  font-size: 0.75rem;
  line-height: 1.2;
}

.pratiche-pdf-status-badge {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
}

.pratiche-pdf-sign-status small {
  color: #64748b;
}

.pratiche-pdf-sign-status.is-sent .pratiche-pdf-status-badge {
  background: #dbeafe;
  color: #1d4ed8;
}

.pratiche-pdf-sign-status.is-waiting .pratiche-pdf-status-badge {
  background: #ffedd5;
  color: #c2410c;
}

.pratiche-pdf-sign-status.is-signed .pratiche-pdf-status-badge {
  background: #dcfce7;
  color: #15803d;
}

.pratiche-pdf-sign-status.is-cancelled .pratiche-pdf-status-badge {
  background: #fee2e2;
  color: #b91c1c;
}

.pratiche-email-mode-options {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.pratiche-email-mode-option {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.9rem;
  color: #334155;
  cursor: pointer;
}

.modal-content.pratiche-pdf-preview-modal,
.modal-content.pratiche-pdf-compile-modal {
  max-width: 1180px;
  width: 96%;
}

.pratiche-pdf-compile-body {
  padding-top: 0.5rem;
}

.pratiche-pdf-compile-layout {
  display: grid;
  grid-template-columns: minmax(340px, 460px) 1fr;
  gap: 1rem;
  min-height: 70vh;
}

.pratiche-pdf-compile-form {
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 0.5rem;
  border-right: 1px solid #e2e8f0;
}

.pratiche-pdf-compile-hint {
  margin: 0 0 0.85rem;
  font-size: 0.85rem;
  color: #64748b;
  line-height: 1.4;
}

.pratiche-pdf-update-btn {
  width: 100%;
  justify-content: center;
  margin-top: 0.75rem;
  margin-bottom: 0.5rem;
  padding: 0.55rem 0.75rem;
}

.pratiche-pdf-compile-form .form-group {
  margin-bottom: 0.75rem;
}

.pratiche-pdf-compile-form label {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: #334155;
}

.pratiche-pdf-compile-block {
  margin-bottom: 0.65rem;
}

.pratiche-pdf-compile-fields-row {
  display: grid;
  gap: 0.5rem 0.6rem;
  align-items: end;
}

.pratiche-pdf-compile-fields-row .form-group {
  margin-bottom: 0;
  min-width: 0;
}

.pratiche-pdf-compile-fields-row.is-checkboxes {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem 0.9rem;
}

.pratiche-pdf-compile-fields-row .form-group.is-checkbox {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.4rem;
  flex: 0 0 auto;
  min-width: auto;
  overflow: visible;
}

.pratiche-pdf-compile-fields-row .form-group.is-checkbox label {
  display: inline;
  margin-bottom: 0;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
}

.pratiche-pdf-compile-fields-row .form-group.is-checkbox input {
  width: 16px;
  height: 16px;
  margin: 0;
  flex-shrink: 0;
  cursor: pointer;
  accent-color: #0d9488;
}

.pratiche-pdf-compile-radio-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem;
}

.pratiche-pdf-compile-radio-group {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0.55rem 0.7rem;
}

.pratiche-pdf-compile-radio-title {
  display: block;
  font-size: 0.78rem;
  font-weight: 700;
  color: #334155;
  margin-bottom: 0.4rem;
}

.pratiche-pdf-compile-radio-options {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem 0.85rem;
}

.pratiche-pdf-compile-radio-options.is-column {
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 0.28rem;
}

.pratiche-pdf-compile-form .pratiche-pdf-compile-radio-option {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0;
  font-weight: 500;
  font-size: 0.78rem;
  cursor: pointer;
  color: #334155;
  white-space: nowrap;
}

.pratiche-pdf-compile-radio-option input {
  appearance: auto;
  width: 16px;
  height: 16px;
  margin: 0;
  flex-shrink: 0;
  cursor: pointer;
  pointer-events: auto;
  accent-color: #0d9488;
}

.pratiche-pdf-compile-preview {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  min-width: 0;
}

.pdf-preview-panel {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.pdf-preview-actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.pdf-preview-frame {
  height: 64vh;
  min-height: 420px;
  border: 1px solid rgba(51, 51, 51, 0.16);
  border-radius: 6px;
  overflow: hidden;
  background: #f8fafc;
}

.pdf-preview-frame iframe {
  width: 100%;
  height: 100%;
  border: 0;
}

@media (max-width: 900px) {
  .pratiche-pdf-compile-layout {
    grid-template-columns: 1fr;
  }

  .pratiche-pdf-compile-form {
    max-height: 40vh;
    border-right: none;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 0.75rem;
  }

  .pratiche-pdf-compile-radio-row {
    grid-template-columns: 1fr;
  }
}

.modal-content.pratiche-pdf-email-modal {
  max-width: 560px;
}

.pratiche-pdf-filename {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pratiche-pdf-missing {
  flex-shrink: 0;
  font-size: 0.75rem;
  color: #94a3b8;
}

.modal-header-view h3,
.modal-header-create h3,
.modal-header-email h3,
.modal-header-success h3,
.modal-header-error h3 {
  color: #fff;
  font-weight: 600;
  font-size: 1.3rem;
  margin: 0;
}

.modal-header:not(.modal-header-view):not(.modal-header-create):not(.modal-header-email):not(.modal-header-success):not(.modal-header-error) h3 {
  color: #0d3c61;
  font-weight: 600;
  font-size: 1.3rem;
  margin: 0;
}

.modal-body {
  padding: 2rem;
}

@media (max-width: 768px) {
  .fattura-details {
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .fattura-details span {
    width: 100%;
    text-align: center;
  }
  
  .bollettino-actions {
    flex-direction: column;
    gap: 1rem;
  }
  
  .bollettino-actions .btn-primary,
  .bollettino-actions .btn-secondary {
    width: 100%;
    justify-content: center;
  }
}

.search-fatture-section {
  margin-bottom: 2rem;
  padding: 1rem;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.modal-content.modal-large {
  max-width: 1800px;
  width: 95%;
  max-height: 90vh;
  overflow-y: auto;
}

.anni-selector-section {
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.anni-label {
  display: block;
  font-weight: 600;
  color: #0d3c61;
  margin-bottom: 1rem;
  font-size: 1rem;
}

.anni-label i {
  margin-right: 0.5rem;
  color: #3388b3;
}

.anno-select {
  width: 100%;
  max-width: 200px;
  padding: 0.75rem;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 1rem;
  background: white;
  cursor: pointer;
}

.anno-select:focus {
  outline: none;
  border-color: #3388b3;
  box-shadow: 0 0 0 3px rgba(51, 136, 179, 0.1);
}

.tipo-estratto-section {
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.tipo-estratto-label {
  display: block;
  font-weight: 600;
  color: #0d3c61;
  margin-bottom: 1rem;
  font-size: 1rem;
}

.tipo-estratto-label i {
  margin-right: 0.5rem;
  color: #3388b3;
}

.tipo-estratto-select {
  width: 100%;
  max-width: 300px;
  padding: 0.75rem;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 1rem;
  background: white;
}

.tipo-estratto-select:focus {
  outline: none;
  border-color: #3388b3;
  box-shadow: 0 0 0 3px rgba(51, 136, 179, 0.1);
}

.totali-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  color: #64748b;
}

.totali-loader i {
  font-size: 2rem;
  color: #3388b3;
  margin-bottom: 1rem;
}

.totali-loader p {
  margin: 0;
  font-size: 1rem;
}

.totali-results {
  margin-top: 1.5rem;
}

.totali-header {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: #f0f9ff;
  border-radius: 8px;
  border: 1px solid #bae6fd;
}

.totali-header h4 {
  margin: 0 0 1rem 0;
  color: #0d3c61;
  font-size: 1.2rem;
  font-weight: 600;
}

.periodo-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
}

.periodo-label {
  font-weight: 600;
  color: #64748b;
}

.periodo-value {
  color: #0d3c61;
  background: white;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  border: 1px solid #cbd5e1;
}

.totali-table-container {
  overflow-x: auto;
  max-height: 400px;
  overflow-y: auto;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: white;
}

.totali-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.totali-table th {
  background: #f8fafc;
  padding: 0.6rem 0.8rem;
  text-align: left;
  font-weight: 600;
  color: #0d3c61;
  border-bottom: 2px solid #e2e8f0;
}

.totali-table td {
  padding: 0.6rem 0.8rem;
  border-bottom: 1px solid #f1f5f9;
}

.totali-table tbody tr:hover {
  background: #f8fafc;
}

.totali-table td.importo,
.totali-table .importo {
  text-align: right !important;
  font-weight: 500 !important;
  font-size: 0.45rem !important;
  padding-right: 1rem !important;
}

.totali-table .saldo-positivo {
  color: #059669;
}

.totali-table .saldo-negativo {
  color: #dc2626;
}

.totali-table tfoot {
  background: #f0f9ff;
  border-top: 2px solid #3388b3;
}

.totali-table tfoot td {
  font-weight: 600;
  color: #0d3c61;
  padding: 0.6rem 0.8rem;
}

.totali-table tfoot .importo {
  font-size: 0.4rem !important;
}

.no-data-message,
.select-years-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  color: #64748b;
  text-align: center;
}

.no-data-message i,
.select-years-message i {
  font-size: 2rem;
  color: #cbd5e1;
  margin-bottom: 1rem;
}

.no-data-message p,
.select-years-message p {
  margin: 0;
  font-size: 1rem;
}

@media (max-width: 768px) {
  .anno-select {
    max-width: 100%;
  }
  
  .totali-table-container {
    font-size: 0.8rem;
  }
  
  .totali-table th,
  .totali-table td {
    padding: 0.5rem;
  }
  
  .periodo-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
}

.search-wrapper {
  position: relative;
  max-width: 400px;
}

.search-input {
  width: 100%;
  padding: 8px 12px 8px 35px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.search-input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.search-container .pi-search {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  font-size: 0.9rem;
  pointer-events: none;
}

.search-container button {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 4px;
  border-radius: 2px;
  transition: color 0.2s ease;
}

.search-container button:hover {
  color: #333;
  background-color: rgba(0, 0, 0, 0.05);
}

.search-container .search-info {
  margin-top: 8px;
  font-size: 0.85rem;
  color: #666;
  font-style: italic;
}


.fatture-selection-container {
  padding: 1rem;
}

.selection-info {
  margin-bottom: 1rem;
  color: #666;
  font-size: 0.95rem;
}

.fatture-list {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 0.75rem;
}

.fattura-item {
  margin-bottom: 0;
}

.fattura-checkbox {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  height: 100%;
  min-height: 80px;
}

.fattura-checkbox:hover {
  background-color: #f8f9fa;
  border-color: #007bff;
}

.fattura-checkbox input[type="checkbox"] {
  margin-right: 0.75rem;
  transform: scale(1.2);
}

.fattura-info {
  flex: 1;
}

.fattura-numero {
  font-weight: 600;
  color: #333;
  margin-bottom: 0.25rem;
}

.fattura-details {
  display: flex;
  gap: 1rem;
  font-size: 0.9rem;
  color: #666;
}

.fattura-importo {
  font-weight: 600;
  color: #28a745;
}

.hidden-file-input {
  display: none;
}

.upload-info {
  margin-top: 0.25rem;
  font-size: 0.8rem;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.upload-info .file-name {
  color: #0d3c61;
  font-weight: 500;
}

.upload-success {
  color: #16a34a;
  font-weight: 500;
}

.upload-error {
  color: #dc2626;
  font-weight: 500;
}

.documento-gia-caricato {
  font-weight: 600;
  color: #16a34a;
  font-size: 0.85rem;
  white-space: nowrap;
}

.text-muted {
  color: #64748b;
  font-size: 0.85rem;
}



.quietanza-container {
  padding: 1rem;
  background: white;
}

.quietanza-content {
  width: 100%;
}

.quietanza-inline {
  width: 100%;
}


.quietanza-inline .card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
  background: #f9f9f9;
}

.quietanza-inline .formgrid {
  margin-top: 0.5rem;
}

.quietanza-inline .field {
  margin-bottom: 0.5rem;
}

.quietanza-modal {
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.quietanza-modal .modal-body {
  flex: 1;
  overflow: hidden;
  position: relative;
}

.quietanza-wrapper {
  height: 100%;
  overflow: hidden;
  position: relative;
}

.quietanza-wrapper::after {
  content: '';
  display: block;
  clear: both;
  height: 0;
}

.sms-left-scroll {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 6px;
}

.sms-left-scroll::-webkit-scrollbar {
  width: 8px;
}
.sms-left-scroll::-webkit-scrollbar-thumb {
  background: rgba(0,0,0,0.2);
  border-radius: 8px;
}
.sms-left-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.modal-body-sms {
  max-height: 55vh;
  overflow-y: auto;
  font-family: 'Montserrat', sans-serif !important;
  padding: 0.8rem;
}

.modal-content-sms {
  margin: 0.5rem;
  border-radius: 8px;
  max-width: 1800px;
  width: 95%;
  max-height: 80vh;
  overflow-y: auto;
  background: white;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: modalAppear 0.3s ease-out;
  font-family: 'Montserrat', sans-serif !important;
}

.sms-template-button {
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.sms-template-button:hover {
  background-color: var(--surface-200);
}

.sms-template-button.is-active {
  background-color: var(--surface-300);
}

</style>
